export default {
  en: {
    // Legacy camelCase keys
    employee: 'Employee',
    roster: 'Roster',
    payroll: 'Payroll',
    employeeRoster: 'Employee Roster',
    employeeRosterAnalysis: 'Employee Roster Analysis',
    rosterStatistics: 'Roster Statistics',
    noPunchesOnly: 'No Punches Only',
    copyEmails: 'Copy Emails',
    forOutlook: 'For Outlook',
    minorAdult: 'Minor/Adult',
    highlightedRowsDenoteMinors: 'Highlighted rows denote minors',
    adult: 'Adult',
    minor: 'Minor',
    primaryHourlyPayRate: 'Primary Hourly Pay Rate',
    primaryJobTitleCode: 'Primary Job Title Code',
    primaryJobTitleCodeDescription: 'Primary Job Title Code Description',
    contact: 'Contact',
    birthday: 'Birthday',
    anniversary: 'Anniversary',
    reviewDue: 'Review Due',
    signature: 'Signature',
    crewStaffSize: 'Crew (Staff size)',
    shiftStaffSize: 'Shift (Staff size)',
    rosterSize: 'Roster Size',
    rosterActive: 'Roster Active',

    // People Dashboard
    overview: 'Overview',
    shift: 'Shift',
    'turnover-trend': 'Turnover Trend',
    'roster-statistics': 'Roster Statistics',
    attendance: 'Attendance',
    staffing: 'Staffing',
    'on-time-rating': 'On Time Rating',
    'crew-turnover': 'Crew Turnover',
    'shift-turnover': 'Shift Turnover',

    // Overview Subwidget - Attendance
    'attendance-rating': 'Attendance Rating',
    'monthly-average-restaurant-shifts-worked':
      'Monthly Average Restaurant % of shifts worked',
    'jtc-crew-and-swing': 'JTC: Crew and Swing',
    'green-attendance': 'Green: at or above 90%',
    'yellow-attendance': 'Yellow: 80% up to 90%',
    'red-attendance': 'Red: Below 80%',
    'please-select-a-previous-month-to-view-attendance-rating':
      'Please select a previous month to view attendance rating.',
    'rest-avg': 'Rest Avg',
    'total-shifts': 'Total Shifts',
    'missed-shifts': 'Missed Shifts',

    // Overview Subwidget - Shift
    'actual-hours-as-of-needed-for-month-needed':
      'Actual Hours as % of Needed for month Needed = Variable Needed + Floor Needed + Fixed Scheduled',
    'green-shift': 'Green: 95%-105%',
    'yellow-shift': 'Yellow: 85-95% or 105-115%',
    'red-shift': 'Red: Less than 85% or more than 115%',
    'scheduled-hours-as-of-guide-for-month':
      'Scheduled hours as % of guide for month',
    'actual-hours-as-of-scheduled-for-month':
      'Actual hours as % of scheduled for month',
    'avg-hrs-r-d': 'Avg Hrs/R/D',
    'act-vs-req': 'Act Vs Req',
    'act-vs-sch': 'Act Vs Sch',
    'sch-vs-guide': 'Sch Vs Guide',
    last: 'Last',
    month: 'Month',
    current: 'Current',
    required: 'Required',
    'required-hours': 'Required',
    scheduled: 'Scheduled',

    // Overview Subwidget - Roster
    'average-restaurant-active-paid-during-month':
      'Average Restaurant % active (paid) during month',
    'average-restaurant-active-during-month':
      'Average Restaurant % active during month',
    'green-roster': 'Green: at or above 95%',
    'yellow-roster': 'Yellow: 90% up to 95%',
    'red-roster': 'Red: Below 90%',
    active: 'Active',
    termed: 'Termed',
    inactive: 'Inactive',
    'employee-location': 'Employee Location',
    home: 'Home',
    shared: 'Shared',
    'termination-year': 'Termination Year',
    'term-year': 'Term Year',
    total: 'Total',
    crew: 'Crew',
    manager: 'Manager',
    'past-due-date': 'Past Due Date',
    'overall-trained': 'Overall Trained',
    'path-not-completed': '{path} Path Not Completed',
    'employees-label': 'employees',
    'crew-trainer-role': 'Crew Trainer',
    'awaiting-verification': 'Awaiting Verification',
    'crew-trainer-training-not-completed':
      'Crew Trainer Training Not Completed',
    'overall-trained-in-compliance': 'Overall Trained in Compliance',
    'overall-trained-crew-trainer': 'Overall Crew Trainer Training Completed',
    'overall-trained-in-path': 'Overall Trained in {path}',

    // Training report filters / labels
    role: 'Role',
    path: 'Path',
    locations: 'Location(s)',
    all: 'All',
    'past-due': 'Past Due',
    'due-soon': 'Due Soon',
    'new-hires': 'New Hires',
    'awaiting-eval': 'Awaiting Your Evaluation',
    foundation: 'Foundation',
    production: 'Production',
    service: 'Service',
    digital: 'Digital',
    employees: 'Employees',
    courses: 'Courses',
    'by-stats': 'By Stats',
    'by-courses': 'By Courses',
    'all-filters': 'ALL FILTERS',
    'percent-completed-training': '% Completed Training',
    expand: 'Expand',
    collapse: 'Collapse',
    'employee-training-report': 'Employee Training Report',
    compliance: 'Compliance',
    'digital-ambassador': 'Digital Ambassador',
    'shift-leader': 'Shift Leader',
    'department-leader': 'Department Leader',

    // Overview Subwidget - OnTime
    'monthly-average-restaurant-of-shifts-on-time':
      'Monthly Average Restaurant % of shifts on time',
    'punch-threshold': 'Punch Threshold: 3 min',
    'green-ontime': 'Green: at or above 85%',
    'yellow-ontime': 'Yellow: 70% up to 85%',
    'red-ontime': 'Red: Below 70%',
    'please-select-a-previous-month-to-view-on-time-rating':
      'Please select a previous month to view on time rating.',
    'on-time': 'On Time',

    // Overview Subwidget - Turnover
    'crew-monthly-annualized-turnover': 'Crew monthly annualized turnover %',
    'green-turnover': 'Green: below 130%',
    'yellow-turnover': 'Yellow: 130% to 200%',
    'red-turnover': 'Red: Above 200%',
    hires: 'Hires',
    terminations: 'Terminations',

    // Overview Subwidget - Retention (Shift Turnover)
    'monthly-annualized-shift-turnover': 'Monthly annualized shift turnover %',
    'green-below-50': 'Green: below 50%',
    'yellow-50-to-100': 'Yellow: 50% to 100%',
    'red-above-100': 'Red: Above 100%',

    // Turnover Trend Widget
    'shift-managers': 'Shift Managers',
    'monthly-annual-turnover': 'Monthly Annual Turnover',
    'monthly-ann': 'Mo. Ann.',
    'ttm-turnover': 'TTM Turnover',
    ttm: 'TTM',
    'ytd-turnover': 'YTD Turnover',
    ytd: 'YTD',
    '3mo': '3 Mo.',
    '3mo-turnover': '3 Month Turnover',
    'tooltip-turnover': 'Turnover data requires full month date range',

    // Shift Widget (dashboard)
    'by-store': 'By Store',
    'act-hrs-vs-need': 'Act Hrs vs Need',
    'sch-hrs-vs-guide': 'Sch Hrs vs Guide',
    'act-hrs-vs-sch': 'Act Hrs vs Sch',

    // Roster Statistics Widget
    'roster-active': 'Roster Active',
    'number-of-non-terminated-employees':
      'Number of non-terminated employees who had punches during the selected period',
    'roster-inactive': 'Roster Inactive',

    // Attendance Widget (dashboard grid)
    'punch-in-on-time': 'Punch In On Time',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-within':
      'Number of shifts in the period where the employee punched in within the threshold (before or after scheduled time)',
    'punch-in-late': 'Punch In Late',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-after':
      'Number of shifts in the period where the employee punched in after the threshold',
    'punch-in-early': 'Punch In Early',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-before':
      'Number of shifts in the period where the employee punched in before the threshold',
    'punch-out-on-time': 'Punch Out On Time',
    'number-of-scheduled-shifts-where-the-employee-punched-out-within-the-threshold':
      'Number of scheduled shifts where the employee punched out within the threshold',
    'number-of-shifts-where-an-employee-was-on-time-divided-by-total':
      'Number of shifts where an employee was on time divided by total shifts scheduled in the selected period',
    'number-of-scheduled-shifts-an-employee-had-punches-for':
      'Number of scheduled shifts an employee had punches for divided by total number of scheduled shifts',
    'punch-out-late': 'Punch Out Late',
    'number-of-scheduled-shifts-where-the-employee-punched-out-later':
      'Number of scheduled shifts where the employee punched out later than the threshold',
    'punch-out-early': 'Punch Out Early',
    'number-of-scheduled-shifts-where-the-employee-punched-out-earlier':
      'Number of scheduled shifts where the employee punched out earlier than the threshold',
    'worked-not-sched': 'Worked, Not Sched',
    'number-of-days-where-an-employee-worked-but-was-not-scheduled':
      'Number of days where an employee worked but was not scheduled in the selected period',
    'missed-shift': 'Missed Shift',
    'number-of-missed-shifts-for-the-employee-in-the-selected-period':
      'Number of missed shifts for the employee in the selected period',
    'days-on-sched': 'Days On Sched',
    'crew-swing': 'Crew/Swing',

    // Employee Roster
    'custom-date-range': 'Custom Date Range',
    'employee-roster': 'Employee Roster',
    'employee-roster-analysis': 'Employee Roster Analysis',
    'no-punches-only': 'No Punches Only',
    search: 'Search',
    'copy-emails': 'Copy Emails',
    'for-outlook': 'For Outlook',
    'minor-adult': 'Minor/Adult',
    'highlighted-rows-denote-minors': 'Highlighted rows denote minors',
    'primary-hourly-pay-rate': 'Primary Hourly Pay Rate',
    'employees-primary-hourly-pay-rate':
      'Employees Primary hourly pay rate - may be zero or null (N/A) for salaried employees',
    'primary-job-title-code': 'Primary Job Title Code',
    'mcdonalds-primary-job-title-code': 'McDonalds Primary Job Title Code',
    'primary-job-title-code-description': 'Primary Job Title Code Description',
    'mcdonalds-primary-job-title-code-description':
      'McDonalds Primary Job Title Code Description',
    purpose: 'Purpose',
    'signature-line': 'Signature Line',
    'date-signed': 'Date Signed',
    'review-due': 'Review Due',

    // Roster Statistics (full page)
    'crew-staff-size': 'Crew (Staff size)',
    'total-number-of-hourly-crew':
      'Total number of hourly crew on the roster for the selected month',
    'shift-staff-size': 'Shift (Staff size)',
    'total-number-of-swing-managers-or-floor-supervisors':
      'Total number of Swing Managers or Floor Supervisors whose status is "Active"',
    'gm-dm-crew-staff-size': 'GM & DM (Staff size)',
    'number-of-total-active-general-managers-and-department-managers':
      'Number of total active General Managers and Department Managers',
    'crew-active': 'Crew Active',
    'number-of-crew-who-had-punched-hours-in-the-selected-month':
      'Number of crew who had punched hours in the selected month',
    'shift-active': 'Shift Active',
    'number-of-swing-managers-or-floor-supervisors':
      'Number of Swing Managers or Floor Supervisors who have "Active" status and have punches in the most recent month',
    'number-of-swing-managers-or-floor-supervisors-active':
      'Number of Swing Managers or Floor Supervisors who have "Active" status and have punches in the most recent month',
    'under-18-staff-size': 'Under 18 (Staff size)',
    'number-of-staff-whose-age-is-below-18-years-old':
      'Number of staff whose age is below 18 years old',
    'under-17-staff-size': 'Under 17 (Staff size)',
    'number-of-staff-whose-age-is-below-17-years-old':
      'Number of staff whose age is below 17 years old',
    'under-16-staff-size': 'Under 16 (Staff size)',
    'number-of-staff-whose-age-is-below-16-years-old':
      'Number of staff whose age is below 16 years old',
    'roster-size': 'Roster Size',
    'total-number-of-people-whose-status-is-active':
      'Total number of people whose status is "Active"',
    'number-of-non-terminated-employees-who-had-punches':
      'Number of non-terminated employees who had punches during the selected period',
    'number-crew-inactive': '# Crew Inactive',
    'crew-who-were-on-the-roster-not-termed-in-the-selected-month':
      'Crew who were on the roster (not termed) in the selected month but who had no punched hours',
    'number-of-swing-managers-or-floor-supervisors-inactive':
      'Number of Swing Managers or Floor Supervisors who have "Active" status but have no punches in the most recent month',
    'crew-who-were-on-the-roster-not-termed':
      'Crew who were on the roster (not termed) in the selected month but who had no punched hours',
    'number-shift-inactive': '# Shift Inactive',
    'number-of-people-who-have-active-status':
      'Number of people who have "Active" status but have no punches in the most recent month',
    'crew-active-pct': 'Crew Active %',
    'crew-active-divided-by-total-crew': 'Crew Active divided by total crew',
    'shift-active-pct': 'Shift Active %',
    'shift-active-divided-by-shift-staff-size':
      'Shift Active divided by Shift (Staff size). Percent of all Swing Managers or Floor Supervisors with "Active" status that have punches in the last month',
    'under-18-pct': 'Under 18 %',
    'under-18-staff-size-divided-by-total-staff':
      'Under 18 (Staff size) divided by Total Staff',
    'under-17-pct': 'Under 17 %',
    'under-17-staff-size-divided-by-total-staff':
      'Under 17 (Staff size) divided by Total Staff',
    'under-16-pct': 'Under 16 %',
    'under-16-staff-size-divided-by-total-staff':
      'Under 16 (Staff size) divided by Total Staff',
    'roster-active-pct': 'Roster Active %',
    'roster-active-divided-by-total-staff':
      'Roster Active divided by Total Staff',

    // Employee Roster Bottom Sheet
    error_loadingReport: 'There was an error loading the report.',
    employee_roster: 'Employee Roster for Location',

    // Birthdays/Anniversaries
    birthdays: 'Birthdays',
    anniversaries: 'Anniversaries',
    'todays-birthdays': "Today's Birthdays",
    'current-months-birthdays': "Current Month's Birthdays",
    'next-months-birthdays': "Next Month's Birthdays",
    loc: 'Loc',
    'employee-name': 'Employee Name',
    location: 'Loc',
    todays: "Today's",
    'current-months': "Current Month's",
    'next-months': "Next Month's",

    // Store Time Punches
    'back-to-employee-time-punches': 'Back to Employee Time Punches',
    'store-time-punches': 'Store Time Punches',
    'by-employee': 'By Employee',
    'day-of-week': 'Day Of Week',
    'payroll-id': 'Payroll ID',
    custom: 'Custom',

    // Punch Extract
    back_to_employee_time_punches: 'Back to Employee Time Punches',
    time_punch_export: 'Time Punch Export',

    // Labor Exceptions
    'missing-pii-permissions-message':
      'You are missing required Personally Identifiable Information (PII) permissions to schedule this report: Access Full Names and Access to Address, Email, DOB, National Origin. Please contact support if you believe this is an error.',
    'report-title-exception': 'By Exception',
    'report-title-summary-exceptions': 'Summary By Exceptions',
    'report-title-summary-location': 'Summary By Location',
    'adult-exceptions-header': 'Regular Exceptions',
    'minor-exceptions-header': 'Minor Exceptions',
    'exceptions-header': 'Total Exceptions',
    'adult-exceptions-description':
      'Exceptions for any employee who is not a minor',
    'minor-exceptions-description':
      'Exceptions for any minor employee, regardless of whether a regular or minor rule was breached',
    'exceptions-description': 'A count of all exceptions for an employee',
    'breach-type-header': 'Exception',
    'breach-type-description':
      'Workforce Management Software rule that was breached',
    'highlighted-rows-explanation': 'Highlighted rows indicate edited punches',
    'labor-date-header': 'Labor Date',
    'employee-full-name-header': 'Employee',
    'employee-full-name-description': 'Employee Name',
    'first-name-header': 'First Name',
    'first-name-description': 'Employee First Name',
    'last-name': 'Last Name',
    age: 'Age',
    'actual-shift-start-time-header': 'Act Start',
    'actual-shift-start-time-description': 'Actual start time of this shift',
    'actual-shift-end-time-header': 'Act End',
    'actual-shift-end-time-description': 'Actual end time of this shift',
    'schedule-shift-start-time-header': 'Sch Start',
    'schedule-shift-start-time-description':
      'Scheduled start time of this shift',
    'schedule-shift-end-time-header': 'Sch End',
    'schedule-shift-end-time-description': 'Scheduled end time of this shift',
    'actual-shift-length-header': 'Act Shift Length',
    'actual-shift-length-description': 'The actual duration of the shift',
    'date-time-of-exception-header': 'Exception Time',
    'date-time-of-exception-description': 'Time the exception occurred',
    'is-manager-authorized-header': 'Manager Authorized',
    'is-manager-authorized-description':
      'Was this exception authorized by a manager?',
    'manager-name-header': 'Manager',
    'manager-name-description': 'Name of the manager',
    punches: 'Punches',
    'error-loading-report': 'There was an error loading the report',
    'punch-type': 'Punch Type',
    'is-overnight-shift': 'Is Overnight Shift',
    'is-overnight-shift-desc':
      "'Y' if the punch was the 4:00 ending punch or 4:00 starting punch for a shift that crossed labor days, otherwise 'N'",
    'is-paid-break': 'Is Paid Break',
    'is-paid-break-desc':
      "'Y' if the punch is the starting or ending punch of a paid break, otherwise 'N'",
    'in-time': 'In Time',
    'out-time': 'Out Time',

    // Time and Attendance (mcd)
    'time-and-attendance': 'Time And Attendance',
    'time-and-attendance-analysis': 'Time And Attendance Analysis',
    'first-name': 'First Name',
    'employee-first-name': 'Employee First Name',
    'employee-last-name': 'Employee Last Name',
    'job-title-code': 'Job Title Code',
    'mcdonalds-job-title-code': 'McDonalds Job Title Code',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-within-the-threshold':
      'Number of shifts in the period where the employee punched in within the threshold (before or after scheduled time)',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-after-the-threshold':
      'Number of shifts in the period where the employee punched in after the threshold',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-before-the-threshold':
      'Number of shifts in the period where the employee punched in before the threshold',
    'number-of-shifts-where-an-employee-was-on-time-divided-by-total-shifts-scheduled-in-the-selected-period':
      'Number of shifts where an employee was on time divided by total shifts scheduled in the selected period',
    'number-of-scheduled-shifts-an-employee-had-punches-for-divided-by-total-number-of-scheduled-shifts':
      'Number of scheduled shifts an employee had punches for divided by total number of scheduled shifts',
    'number-of-scheduled-shifts-where-the-employee-punched-out-later-than-the-threshold':
      'Number of scheduled shifts where the employee punched out later than the threshold',
    'number-of-scheduled-shifts-where-the-employee-punched-out-earlier-than-the-threshold':
      'Number of scheduled shifts where the employee punched out earlier than the threshold',
    'number-of-days-where-an-employee-worked-but-was-not-scheduled-in-the-selected-period':
      'Number of days where an employee worked but was not scheduled in the selected period',
    'mcdonalds-global-employee-identifier':
      'McDonalds Global Employee Identifier',
    'sched-start-time': 'Sched Start Time',
    'sched-end-time': 'Sched End Time',
    'punch-start-time': 'Punch Start Time',
    'punch-end-time': 'Punch End Time',
    'punch-early-late-min-threshold': 'Punch Early/Late Min. Threshold',
    schedule: 'Schedule',
    'at-store': 'At Store',

    // Turnover Report + JTC Definitions
    'january-thru-last-month': 'January Thru Last Month',
    'trailing-13-months': 'Trailing 13 Months',
    'premium-upgrade-message-start': 'Want to reduce turnover? ',
    'premium-upgrade-message-link-text': 'Upgrade to Premium',
    'premium-upgrade-message-end':
      ' to drive employee engagement for better retention.',
    'jtc-definitions': 'JTC Definitions',
    'jtc-name': 'JTC Name',
    'turnover-type': 'Turnover Type',
    'general-manager-w-mgr-punches': 'GENERAL MANAGER W/ MGR PUNCHES',
    'general-manager-w-crew-punches': 'GENERAL MANAGER W/ CREW PUNCHES',
    'general-manager': 'GENERAL MANAGER',
    'store-mgr-trainee-f': 'STORE MGR TRAINEE-F',
    'floor-supervisor': 'FLOOR SUPERVISOR',
    swing: 'Swing',
    'cert-swing-mgr': 'CERT. SWING MGR.',
    'crew-trainer': 'CREW TRAINER',
    'crew-person': 'CREW PERSON',
    'manager-oje': 'MANAGER OJE',
    'security-guard': 'SECURITY GUARD',
    'backup-maintenance-person': 'BACKUP MAINTENANCE PERSON',
    'primary-maintenance-person': 'PRIMARY MAIN. PERSON',
    'intern-f': 'INTERN-F',
    'administrative-assistant': 'ADMINISTRATIVE ASSISTANT',
    'shift-manager-trainee': 'SHIFT MANAGER TRAINEE',
    'otp-pro-hourly': 'OTP PRO HOURLY',
    'otp-pro-salary': 'OTP PRO SALARY',
    'department-manager-i': 'DEPARTMENT MANAGER i',
    'department-manager-ii': 'DEPARTMENT MANAGER ii',
    'department-manager-iii': 'DEPARTMENT MANAGER iii',
    'area-manager-grill-ca': 'AREA MANAGER - GRILL (CA)',
    'guam-inventory-employee': 'GUAM INVENTORY EMPLOYEE',
    'intern-so-cal-region': 'INTERN - SO CAL REGION',
    'profit-center-admin-assist': 'PROFIT CTR ADMIN ASSIST',
    'lsm-coordinator': 'LSM COORDINATOR',
    'intern-gsw': 'INTERN GSW',
    'dept-mgr-w-i-crew-punches': 'DEPT MGR W/ i CREW PUNCHES',
    'dept-mgr-w-ii-crew-punches': 'DEPT MGR W/ ii CREW PUNCHES',
    'dept-mgr-w-iii-crew-punches': 'DEPT MGR W/ iii CREW PUNCHES',

    // Turnover Grid
    turnover: 'Turnover',
    'number-of-employees-hired-in-the-period':
      'Number of employees hired in the period',
    'roster-size-description':
      'Count of all employees within the selected group who are active in the roster',
    terms: 'Terms',
    'number-of-employees-whose-job-ended':
      'Number of employees whose job ended',
    'terms-less-than-90': 'Terms < 90',
    'terms-less-than-90-description':
      "For the month, the number of new hires who were termed before reaching 90 days of employment. This number will not be final until 90 days after the month ends (January won't be final until May 1, February won't be final until June 1, etc)",
    'retained-greater-than-90': 'Retained > 90',
    'number-of-employees-who-remained-employed-at-the-restaurant-more-than-90-days':
      'Number of employees who remained employed at the restaurant more than 90 days',
    'terms-less-than-90-pct': 'Terms < 90 Pct',
    'terms-less-than-90-pct-description':
      "Terms < 90 divided by hires that month. This number will not be final until 90 days after the month ends (January won't be final until May 1, February won't be final until June 1, etc)",
    'retained-greater-than-90-pct': 'Retained > 90 Pct',
    'retained-greater-than-90-divided-by-number-of-employees-hired-in-the-month':
      'Retained > 90 divided by number of employees hired in the month',
    'monthly-turnover-multiplied-by-12-to-annualized-it':
      'Monthly turnover multiplied by 12 to annualized it',
    'ttm-turnover-description':
      'Trailing Twelve Month Turnover. Total Terms in the last 12 months divided by Roster Size at the end of the most recent month',
    'ytd-turnover-description':
      'Year to Date Turnover. Total terms so far for the current year divided by Roster Size at the end of the most recent month',
    'three-month-turnover': '3-Month Turnover',
    '3-month-turnover-description':
      '3 month turnover reports for the most recent 3-month period for which it can be know whether new hires made it 90 days. {link}',
    'details-link-text': 'Details are here',
    'three-month-terms': '3-Month Terms',
    '3-month-terms-description':
      'Number of people termed in the 3 month period',
    'three-month-retained': '3-Month Retained',
    '3-month-retained-description':
      'Number of people retained in the 3 month period',
    'new-hire-retention': 'New Hire Retention',
    'employees-in-red-were-terminated-prior-to-working-90-days':
      'Employees in red were terminated prior to working 90 days',

    // Emp Hours This Week
    'filter-results': 'Filter Results',
    'emp-hours-this-week': 'Emp Hours This Week',

    // Shift report
    'shift-report': 'Shift Report',
    'actual-gc': 'Actual GC',
    'actual-gc-recorded-by-the-pos': 'Actual GC recorded by the POS',
    'projected-gc': 'Projected GC',
    'actual-gc-vs-proj': 'Act GC vs Proj',
    'actual-gc-minus-gc-that-were-projected-in-the-scheduling-software':
      'Actual GC minus GC that were projected in the scheduling software',
    'proj-eff': 'Proj Eff',
    'number-of-hours-where-actual-gc-was-within-10':
      'Number of hours where Actual GC was within 10 of Projected GC, divided by total hours the restaurant was open',
    'total-act-hrs': 'Total Act Hrs',
    'var-actual-hrs': 'Var Actual Hrs',
    'act-punch-hrs': 'Act Punch Hrs',
    'actual-hours-punched-on-the-timeclock':
      'Actual Hours punched on the timeclock',
    'salaried-manager-hrs': 'Salaried Manager Hrs',
    'since-salaried-managers-do-not':
      'Since Salaried managers do not punch the clock, Scheduled Salaried Manager hours are used (it is assumed that all scheduled salaried hours get worked)',
    'total-need-hrs': 'Total Need Hrs',
    'total-hours-needed-hours-variable-hours-needed':
      'Total Needed Hours - Variable Hours Needed plus Floor Hours Needed + Fixed Hours Scheduled',
    'var-need-hrs': 'Var Need Hrs',
    'flr-need-hrs': 'Flr Need Hrs',
    'manager-hours-needed-to-run-the-floor':
      'Manager Hours needed to run the floor',
    'total-sch-hrs': 'Total Sch Hrs',
    'var-sch-hrs': 'Var Sch Hrs',
    'flr-sch-hrs': 'Flr Sch Hrs',
    'manager-hours-scheduled-to-run-the-floor':
      'Manager Hours Scheduled to run the floor',
    'fixed-sch-hrs': 'Fixed Sch Hrs',
    'scheduled-hours-for-schedule-symbols-that-are-fixed':
      'Scheduled hours for Schedule symbols that are "fixed" (not dependent on sales volume)',
    'total-guide': 'Total Guide',
    'fixed-guide': 'Fixed Guide',
    'hours-in-the-fixed-hours-guide':
      'Hours in the Fixed Hours guide (also called a contract) for a given scheduling symbol',
    'var-guide': 'Var Guide',
    'flr-guide': 'Flr Guide',
    'floor-hours-needed-based-on-gc-volume':
      'Floor Hours needed based on GC volume',
    'act-vs-need-percentage': 'Act vs Need %',
    'sch-vs-guide-percentage': 'Sch vs Guide %',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Actual Hours used compared to Hours that were scheduled',
    'act-vs-sch-percentage': 'Act vs Sch %',
    'sch-flr-vs-guide': 'Sch Flr vs Guide',
    'var-act-vs-need': 'Var Act vs Need',
    'actual-variable-hours-used-compared-to-variable-hours-needed':
      'Actual Variable hours used compared to Variable Hours needed according to the VLH guide',
    'fixed-sch-vs-guide': 'Fixed Sch vs Guide',
    'var-sch-vs-guide': 'Var Sch vs Guide',

    // Labor Schedules
    labor_schedules: 'Labor Schedules',

    // Rewards
    'by-employee-title': 'By Employee',
    'by-store-title': 'By Store',
    'auto-rewards': 'Auto Rewards',
    'rewards-by-store': 'Rewards by Store',
    'rewards-by-employee': 'Rewards by Employee',
    transfers: 'Transfers',
    purchase: 'Purchase',
    refund: 'Refund',
    manual: 'Manual',
    auto: 'Auto',
    pts: 'Pts',
    qty: 'Qty',
    'employee-name-description': 'Name of the employee',
    'by-date': 'By Date',
    'sum-all-dates': 'Sum',
    geid: 'GEID',
    '3-month-turnover': '3-Month Turnover',
    '3-month-terms': '3-Month Terms',
    '3-month-retained': '3-Month Retained',
    category: 'Category',
    value: 'Value',
    'retained-90-divided-by-number-of-employees-hired-in-the-month':
      'Retained > 90 divided by number of employees hired in the month',
    primary: 'Primary',
    secondary: 'Secondary',
    // Training Report — Shift Leader
    'shift-leader-foundations': 'Shift Leader Foundations',
    'sl-shift-leader': 'Shift Leader',
    'sl-advancing-tooltip':
      'Advancing Leadership is a secondary path that can be taken only after completion of Leadership Foundations',
    'sl-location': 'Location',
    'sl-role': 'Role',
    'sl-path': 'Path',
    'sl-employee': 'Employee',
    'sl-jtc-start-date': 'JTC Start Date',
    'sl-due-date': 'Due Date',
    'sl-avg-days': 'Average Days to Complete',
    'sl-all': 'All',
    'sl-past-due': 'Past Due',
    'sl-past-due-hint':
      'Past due: not completed and the due date passed {n} days ago',
    'sl-due-soon-hint': 'Due soon: due in {n} days',
    'sl-past-due-group-hint':
      'Past due: {n} required course(s) in this group not completed by the due date',
    'sl-due-soon-group-hint':
      'Due soon: {n} required course(s) in this group due in the next few days',
    'sl-due-soon': 'Due Soon',
    'sl-not-started': 'Not Started',
    'sl-in-progress': 'In Progress',
    'sl-completed': 'Completed',
    'sl-na': 'n/a',
    'sl-badge-start-overdue': 'Start overdue - 14',
    'sl-badge-start-due': 'Start due - 14',
    'sl-employees': 'employees',
    'sl-card-past-due': 'Past Due Date',
    'sl-card-due-soon': 'Due Soon',
    'past-due-date-training': 'Past Due Date Training',
    'due-soon-training': 'Due Soon Training',
    'sl-card-not-trained': 'Not Trained In This Path',
    'sl-col-past-due': '# Past Due',
    'sl-col-due-soon': '# Due Soon',
    'sl-first-course-col': 'First Course (14 days)',
    'sl-training-status': 'Training Status',
    'sl-see-all': 'SEE ALL',
    'sl-close': 'Close',
    'sl-due-header-tooltip':
      'First course of the path should be taken no later than 14 days from JTC effective date. The whole path should be completed no later than 9 months from JTC effective date.',
    'sl-tip-first-overdue':
      'First course not started within 14 days of JTC (due {date}).',
    'sl-tip-first-due':
      'First course must be started within 14 days of JTC (due {date}).',
    'sl-tip-count-past-due':
      '{n} courses past the 9-month path deadline (due {date}).',
    'sl-tip-count-due-soon':
      '{n} courses coming due before the 9-month path deadline (due {date}).',
    'hire-date': 'Hire Date',
    'completion-date': 'Completion Date',
    'course-name': 'Course Name',
    'employee-training-details': 'Employee Training Details',
    'new-hire': 'New Hire',
    'job-category': 'Job Category',
    'training-report': 'Training Report',
    'course-required': 'Required',
    'crew-pct-past-due': '{pct} Past Due',
    'crew-pct-crew-trainer-not-completed':
      '{pct} Crew Trainer Training Not Completed',
    'crew-pct-due-soon': '{pct} Due Soon',
    'sl-pct-not-trained': '{pct} Not Trained In This Path',
    'crew-pct-path-not-completed': '{pct} {path} Not Completed',
    'crew-pct-trained': '{pct} Trained',
    'past-due-value': 'Past Due Value',
    'course-status': 'Course Status',
    'overall-progress': 'Overall Progress {pct}%',
    'dl-path-guest-services': 'Guest Services Path',
    'dl-path-kitchen-leader': 'Kitchen Leader Path',
    'dl-path-people-leader': 'People Leader Path',
    'dl-paths': 'Path(s)',
    'dl-standalone-courses': 'Standalone Courses',
    'dl-dlim': 'DLIM',
    'dl-picked-guest-services': 'Picked Guest Services Path',
    'dl-picked-kitchen-leader': 'Picked Kitchen Leader Path',
    'dl-picked-people-leader': 'Picked People Leader Path',
    'dl-completed-dlim': 'Completed DLIM Course (1 of 2)',
    'dl-dlim-subtitle': '1 of 2 is mandatory',
    'gm-lgr-subtitle': '1 of 2 is mandatory',
    'capstone-required-tooltip': 'Required.',
    'n-days': '{n} days',
    'unknown-course': 'Unknown Course',
    'general-manager-role': 'General Manager',
    'crew-role': 'Crew',
    'due-soon-value': 'Due Soon Value',
    'multiple-courses': 'Multiple Courses',
    download: 'Download',
    'pct-completed': '% Completed',
    'not-available': 'N/A',
    'new-hires-label': 'New Hires',
    'last-n-days': 'Last {n} Days',
    'geid-label': 'GEID',
    'gm-path-leading-people': 'Leading People Path',
    'gm-path-leading-hospitality': 'Leading Hospitality Path',
    'gm-path-leading-operational-excellence':
      'Leading Operational Excellence Path',
    'gm-path-financial': 'The Financial Path',
    'gm-not-trained-in-path': 'Not Trained in This Path',
    'gm-employees-pct': '{n} employees ({pct}%)',
    'beverage-specialist': 'Beverage Specialist',
    'employees-who-picked': 'Employees who Picked {path}',
    'all-n-paths': 'All {n}',
    'gm-picked-leading-people': 'Picked Leading People Path',
    'gm-picked-leading-hospitality': 'Picked Leading Hospitality Path',
    'gm-picked-leading-operational-excellence':
      'Picked Leading Operational Excellence Path',
    'gm-picked-financial': 'Picked The Financial Path',
    'gm-completed-lgr': 'Completed LGR Course (1 of 2)',
    'gm-lgr': 'LGR',
    'dl-path-progress': 'Path Progress',
    'dl-completion-date': 'Completion Date',
    'dl-percent-of-employees': '{pct}% of Employees',
    'dl-overall-progress': 'Overall Progress {pct}%',
    'dl-all-three': 'All 3',
    'dl-certification-name': 'Certification Name',
    'dl-completed-on': 'Completed on {date}',
    'employees-none-for-status': 'No employees with this status',
    'employees-load-failed':
      'Could not load employees. Change a filter to retry.',
    'employees-removed-for-status':
      '{n} selected employee(s) removed - not in this status',
    'mapping-title': 'Training Mapping',
    'mapping-courses-filters': 'Courses',
    'mapping-completions': 'Completions',
    'mapping-completions-any': 'Any',
    'mapping-completions-none': 'None',
    'mapping-completions-some': 'Some',
    'mapping-hide-retired': 'Hide retired',
    'mapping-unmapped-ids-caption':
      'Completions with no course record. Not affected by the course filters above.',
    'mapping-group-assigned': 'On a path',
    'mapping-n-of-m-courses': '{n} of {m}',
    'mapping-path-reordered': 'Path order saved',
    'mapping-show': 'Show',
    'mapping-hide': 'Hide',
    'mapping-applies-to-line': 'Applies to',
    'mapping-reorder-hint': 'Drag to reorder',
    'mapping-required-paths': 'Required paths',
    'mapping-course-library': 'Course library',
    'mapping-search-courses': 'Search by name or Campus id',
    'mapping-library-hint':
      'Drag a course onto a path to add it, or between paths to move it. Use the x on a course to take it off a path.',
    'mapping-group-unassigned': 'Not on any path',
    'mapping-unmapped-ids': 'Campus ids with completions but no course',
    'mapping-unmapped-ids-hint':
      'Employees at the selected locations completed these Campus course ids, but no course record covers them. Create a course from one to map it.',
    'mapping-no-courses': 'No courses',
    'mapping-drop-course-here': 'Drop a course here',
    'mapping-n-completed': '{n} completed',
    'mapping-zero-completed': '0 completed',
    'mapping-last-completed': 'last {date}',
    'mapping-create-course-from-id': 'Create a course for {id}',
    'mapping-course-moved': 'Course order saved',
    'mapping-path-regrouped': 'Path requirement updated',
    'mapping-n-paths-no-courses': '{n} paths have no courses',
    'mapping-n-unassigned-courses': '{n} courses are not on any path',
    'mapping-n-unassigned-with-completions': '{n} of them have completions',
    'mapping-add-jtc': 'Add JTC',
    'mapping-jtc-code': 'JTC code',
    'mapping-jtc-invalid': 'Enter a JTC as a whole number',
    'mapping-remove-jtc': 'Remove JTC {jtc}',
    'mapping-new-path': 'New path',
    'mapping-edit-path': 'Edit path',
    'mapping-require-path': 'Require a path',
    'mapping-remove-from-role': 'Remove from this role',
    'mapping-add-course': 'Add course',
    'mapping-edit-course': 'Edit course',
    'mapping-remove-from-path': 'Remove from this path',
    'mapping-existing-course': 'Existing course',
    'mapping-new-course': 'New course',
    'mapping-pick-course': 'Pick a course',
    'mapping-no-courses-left': 'No courses to add',
    'mapping-on-no-path': 'on no path',
    'mapping-course-name': 'Course name',
    'mapping-path-name': 'Path name',
    'mapping-campus-ids-hint': 'Type a Campus course id and press Enter',
    'mapping-course-url': 'Campus link (https)',
    'mapping-art': 'Art',
    'mapping-art-preview-celebration': 'Preview celebration',
    'mapping-art-celebration-preview': 'Key celebration (live)',
    'mapping-art-palette-blobs': 'Blobs',
    'mapping-art-palette-rays': 'Rays',
    'mapping-art-palette-confetti': 'Confetti',
    'mapping-art-palette-default': 'app defaults',
    'mapping-art-key-palette': 'Celebration palette',
    'mapping-art-palette-add': 'Add colour',
    'mapping-art-palette-remove': 'Remove colour',
    'mapping-art-missing': '{n} art missing',
    'mapping-art-missing-title':
      'Required art is missing; the crew app will show fallbacks',
    'mapping-art-show': 'Show',
    'mapping-art-hide': 'Hide',
    'mapping-art-none': 'No art yet',
    'mapping-art-save-first': 'Save the record first, then art can be uploaded',
    'mapping-art-upload': 'Upload',
    'mapping-art-replace': 'Replace',
    'mapping-art-clear': 'Clear',
    'mapping-art-door-still': 'Door (closed)',
    'mapping-art-door-clean': 'Door, tight crop',
    'mapping-art-door': 'Door',
    'mapping-art-door-rig': 'Door style',
    'mapping-default-art': 'Default art',
    'mapping-default-art-hint':
      'What any path or course without its own art shows, slot by slot. A path with a door style keeps its own door; one without draws this one. Applies to every role.',
    'mapping-art-rig-magic': 'Magic',
    'mapping-art-rig-magic-hint':
      'A folding slab with a glowing keyhole. Foundation and Beverage Specialist use it.',
    'mapping-art-rig-hinged': 'Hinged',
    'mapping-art-rig-hinged-hint':
      'A swinging leaf on a lever, with props thrown out as it opens. Production uses it.',
    'mapping-art-rig-diner': 'Diner',
    'mapping-art-rig-diner-hint':
      'A two leaf swing door with a tray. Service uses it.',
    'mapping-art-rig-vault': 'Vault',
    'mapping-art-rig-vault-hint':
      'A round vault door with holo traces. Digital Ambassador uses it.',
    'mapping-art-rig-locker': 'Locker',
    'mapping-art-rig-locker-hint':
      'A locker door with floating gems and a loot burst. Compliance uses it.',
    'mapping-art-door-layers': 'Layers',
    'mapping-art-door-layers-hint':
      "Drawn on the style's template. The door only draws once every layer is uploaded.",
    'mapping-art-door-layer-closed': 'Closed slab',
    'mapping-art-door-layer-frame': 'Frame',
    'mapping-art-door-layer-leaf': 'Leaf',
    'mapping-art-door-layer-interior': 'Interior',
    'mapping-art-door-layer-lever': 'Lever',
    'mapping-art-door-layer-leafFront': 'Leaf, front',
    'mapping-art-door-layer-leafBack': 'Leaf, back',
    'mapping-art-door-layer-tray': 'Tray',
    'mapping-art-door-layer-holo': 'Holo',
    'mapping-art-door-layer-traces': 'Traces',
    'mapping-art-door-layer-plate': 'Plate',
    'mapping-art-door-layer-faceFront': 'Face, front',
    'mapping-art-door-layer-faceBack': 'Face, back',
    'mapping-art-door-layer-knob': 'Knob',
    'mapping-art-door-decor-props': 'Thrown props',
    'mapping-art-door-decor-gems': 'Floating gems',
    'mapping-art-door-decor-loot': 'Loot burst',
    'mapping-art-optional': 'optional',
    'mapping-art-tuning-scale': 'Scale',
    'mapping-art-tuning-shiftX': 'Door nudge (px)',
    'mapping-art-tuning-labelShift': 'Label nudge (px)',
    'mapping-art-tuning-opening': 'Doorway polygon',
    'mapping-art-tuning-keyholeX': 'Keyhole x',
    'mapping-art-tuning-keyholeY': 'Keyhole y',
    'mapping-art-tuning-edge': 'Slab edge gradient',
    'mapping-art-advanced': 'Advanced',
    'mapping-art-advanced-hint':
      "Only needed when the art drifts from the style's template.",
    'mapping-art-door-preview': 'Door preview',
    'mapping-art-door-preview-hint':
      'Drawn by the same rig the crew app uses, at the scale above.',
    'mapping-art-door-open': 'Open',
    'mapping-art-door-close': 'Close',
    'mapping-art-door-incomplete': 'Upload every layer to see the door',
    'mapping-art-gradient': 'Background gradient',
    'mapping-art-fallback-key': 'Fallback key',
    'mapping-art-celebration-key': 'Celebration key',
    'mapping-art-preview-title': 'Celebration preview',
    'mapping-art-preview-hint':
      'Press play to see the celebration key over the gradient with the palette above. It restarts when a colour changes.',
    'mapping-art-missing-slot': 'Missing',
    'mapping-art-course-key': 'Key',
    'mapping-use-groups': 'Modality groups',
    'mapping-item-name': 'Step name',
    'mapping-n-steps': '{n} steps',
    'mapping-edit-group': 'Edit group',
    'mapping-edit-step': 'Edit step',
    'mapping-unnamed-step': 'Unnamed step',
    'mapping-done': 'Done',
    'mapping-remove-item': 'Remove step',
    'mapping-drag-to-reorder': 'Drag to reorder',
    'mapping-group-modality': 'Modality',
    'mapping-no-modality': 'No modality',
    'mapping-group-required': 'Required',
    'mapping-optional-group': 'optional',
    'mapping-group-item': 'Item {n}',
    'mapping-group-item-hint':
      'Campus ids for this item, any one of them counts',
    'mapping-add-item': 'Add item',
    'mapping-add-group': 'Add group',
    'mapping-remove-group': 'Remove group',
    'mapping-group-rule': 'Every item in the group has to be completed',
    'mapping-groups-rule':
      'The course is complete when any required group is complete. Optional groups only show progress.',
    'mapping-group-ids-required':
      'Every group needs at least one item with a Campus id',
    'mapping-retired-flag': 'Retired',
    'mapping-states-scope': 'Only for stores in these states (optional)',
    'mapping-translations': 'Translations',
    'mapping-translation-es': 'Spanish',
    'mapping-translation-fr': 'French',
    'mapping-translation-fr-ca': 'French (Canada)',
    'mapping-due-window': 'Due window',
    'mapping-window-days': 'Days',
    'mapping-applies-each': 'Each course',
    'mapping-applies-first': 'First course only',
    'mapping-due-soon-days': 'Due soon, days before',
    'mapping-path-deadline-label': 'Whole path deadline',
    'mapping-deadline-months': 'Months',
    'mapping-anchor': 'Counted from',
    'mapping-anchor-first-punch-label': 'First punch',
    'mapping-anchor-first-jtc-label': 'First JTC start',
    'mapping-anchor-role': 'In role (optional)',
    'mapping-due-dates-from-label': 'Only for starts on or after (YYYY-MM-DD)',
    'mapping-required': 'Required',
    'mapping-pick-one-group': 'Pick-one group (optional)',
    'mapping-pick-one-group-hint':
      'Paths with the same group name are alternatives: the employee completes one of them',
    'mapping-pick-path': 'Pick a path',
    'mapping-no-paths-left': 'Every path is already on this role',
    'mapping-save': 'Save',
    'mapping-cancel': 'Cancel',
    'mapping-save-failed': 'The change was not saved.',
    'mapping-saved-course': 'Course saved',
    'mapping-saved-path': 'Path saved',
    'mapping-course-added': 'Course added to the path',
    'mapping-course-removed': 'Course removed from the path',
    'mapping-jtc-added': 'JTC added',
    'mapping-jtc-removed': 'JTC removed',
    'mapping-path-required': 'Path added to the role',
    'mapping-path-unrequired': 'Path removed from the role',
    'mapping-name-required': 'Name is required',
    'mapping-campus-ids-required': 'At least one Campus course id is required',
    'mapping-url-https': 'The link must start with https://',
    'mapping-select-role':
      'Select a role to see its paths, courses and employees.',
    'mapping-select-locations': 'Select at least one location.',
    'mapping-paths': 'Paths',
    'mapping-paths-and-courses': 'Paths and courses',
    'mapping-n-paths': '{n} paths',
    'mapping-n-courses': '{n} courses',
    'mapping-pick-one-of-n': 'Pick one of {n}',
    'mapping-pick-one-plus-n': 'Pick one of {n}, plus {m} required',
    'mapping-pick-one-of-these-paths': 'Pick one of these paths',
    'mapping-required-with-path': 'Required with the path',
    'mapping-optional-paths': 'Optional paths',
    'mapping-pick-one': 'pick one',
    'mapping-admin-only': 'This page is only available to QSR admins.',
    'mapping-required-for-role': 'required',
    'mapping-optional-for-role': 'optional',
    'mapping-applies-to': 'Applies to',
    'mapping-employees-with-jtcs': 'Employees in {n} job title codes (JTCs)',
    'mapping-all-active-employees': 'All active employees',
    'mapping-due-rule': 'Due rule',
    'mapping-no-due-rule': 'No due dates',
    'mapping-each-course-due': 'Each course is due {days} days after {anchor}',
    'mapping-first-course-due':
      'The first course is due {days} days after {anchor}',
    'mapping-path-deadline':
      'The whole path is due {months} months after {anchor}',
    'mapping-due-dates-from': 'Due dates apply to starts on or after {date}',
    'mapping-anchor-first-punch': 'first punch',
    'mapping-anchor-first-jtc': 'first JTC start',
    'mapping-anchor-first-jtc-in-role': 'first start in {role}',
    'mapping-courses': 'Courses',
    'mapping-campus-ids': 'Campus IDs',
    'mapping-states': 'States',
    'mapping-retired': 'Retired',
    'mapping-open-in-campus': 'Open in Campus',
    'mapping-first-punch': 'First Punch',
    'mapping-name-unavailable': 'Name unavailable',
    'mapping-employees': 'Employees',
    'mapping-n-employees': '{n} employees',
    'mapping-no-employees':
      'No employees at the selected locations are in this role.',
    'picked-path': 'Picked {path}',
    'completed-capstone-course': 'Completed {path} Course',
    'one-of-n-mandatory': '1 of {n} is mandatory',
  },
  es: {
    employee: 'Empleado',
    roster: 'Lista',
    payroll: 'Nómina',
    employeeRoster: 'Lista de Empleados',
    employeeRosterAnalysis: 'Análisis de Lista de Empleados',
    rosterStatistics: 'Estadísticas de Lista',
    noPunchesOnly: 'Solo Sin Registros',
    copyEmails: 'Copiar Correos',
    forOutlook: 'Para Outlook',
    minorAdult: 'Menor/Adulto',
    highlightedRowsDenoteMinors: 'Las filas resaltadas indican menores',
    adult: 'Adulto',
    minor: 'Menor',
    primaryHourlyPayRate: 'Tarifa por Hora Principal',
    primaryJobTitleCode: 'Código de Puesto Principal',
    primaryJobTitleCodeDescription:
      'Descripción del Código de Puesto Principal',
    contact: 'Contacto',
    birthday: 'Cumpleaños',
    anniversary: 'Aniversario',
    reviewDue: 'Revisión Pendiente',
    signature: 'Firma',
    crewStaffSize: 'Tripulación (Tamaño de personal)',
    shiftStaffSize: 'Turno (Tamaño de personal)',
    rosterSize: 'Tamaño de Lista',
    rosterActive: 'Lista Activa',

    overview: 'Resumen',
    shift: 'Turno',
    'turnover-trend': 'Tendencia de Rotación',
    'roster-statistics': 'Estadísticas de Horario',
    attendance: 'Asistencia',
    staffing: 'Dotación',
    'on-time-rating': 'Calificación a Tiempo',
    'crew-turnover': 'Rotación de Personal',
    'shift-turnover': 'Rotación de Turno',

    'attendance-rating': 'Calificación de Asistencia',
    'monthly-average-restaurant-shifts-worked':
      'Promedio Mensual de Restaurante % de turnos trabajados',
    'jtc-crew-and-swing': 'JTC: Tripulación y Cambio',
    'green-attendance': 'Verde: al menos 90%',
    'yellow-attendance': 'Amarillo: 80% hasta 90%',
    'red-attendance': 'Rojo: Menos del 80%',
    'please-select-a-previous-month-to-view-attendance-rating':
      'Seleccione un mes anterior para ver la calificación de asistencia.',
    'rest-avg': 'Promedio Restaurante',
    'total-shifts': 'Turnos Totales',
    'missed-shifts': 'Turnos Perdidos',

    'actual-hours-as-of-needed-for-month-needed':
      'Horas reales como % de Necesario para el mes Necesario = Necesario variable + Necesario de piso + Programado fijo',
    'green-shift': 'Verde: 95%-105%',
    'yellow-shift': 'Amarillo: 85-95% o 105-115%',
    'red-shift': 'Rojo: Menos del 85% o más del 115%',
    'scheduled-hours-as-of-guide-for-month':
      'Horas programadas como % de guía para el mes',
    'actual-hours-as-of-scheduled-for-month':
      'Horas reales como % de programadas para el mes',
    'avg-hrs-r-d': 'Promedio Hrs/R/D',
    'act-vs-req': 'Actual Vs Requerido',
    'act-vs-sch': 'Actual Vs Programado',
    'sch-vs-guide': 'Sch Vs Guía',
    last: 'Último',
    month: 'Mes',
    current: 'Este',
    required: 'Requerido',
    'required-hours': 'Requerido',
    scheduled: 'Programado',

    'average-restaurant-active-paid-during-month':
      'Promedio Restaurante % activo (pagado) durante el mes',
    'average-restaurant-active-during-month':
      'Restaurante promedio activo durante el mes',
    'green-roster': 'Verde: por encima del 95%',
    'yellow-roster': 'Amarillo: 90% hasta 95%',
    'red-roster': 'Rojo: por debajo del 90%',
    active: 'Activo',
    termed: 'Terminado',
    inactive: 'Inactivo',
    'employee-location': 'Ubicación del Empleado',
    home: 'Inicio',
    shared: 'Compartido',
    'termination-year': 'Año de Terminación',
    'term-year': 'Año de Term.',
    total: 'Total',
    crew: 'Tripulación',
    manager: 'Gerente',
    'past-due-date': 'Fecha Vencida',
    'overall-trained': 'Entrenamiento General',
    'path-not-completed': 'Ruta {path} No Completada',
    'employees-label': 'empleados',
    'crew-trainer-role': 'Entrenador de Equipo',
    'awaiting-verification': 'Esperando Verificación',
    'crew-trainer-training-not-completed':
      'Entrenamiento de Entrenador de Equipo No Completado',
    'overall-trained-in-compliance': 'Entrenamiento General en Cumplimiento',
    'overall-trained-crew-trainer':
      'Entrenamiento General de Entrenador de Equipo Completado',
    'overall-trained-in-path': 'Entrenamiento General en {path}',

    // Training report filters / labels
    role: 'Rol',
    path: 'Ruta',
    locations: 'Ubicación(es)',
    all: 'Todos',
    'past-due': 'Vencido',
    'due-soon': 'Próximo a Vencer',
    'new-hires': 'Nuevos Empleados',
    'awaiting-eval': 'Esperando Su Evaluación',
    foundation: 'Fundamentos',
    production: 'Producción',
    service: 'Servicio',
    digital: 'Digital',
    employees: 'Empleados',
    courses: 'Cursos',
    'by-stats': 'Por Estadísticas',
    'by-courses': 'Por Cursos',
    'all-filters': 'TODOS LOS FILTROS',
    'percent-completed-training': '% de Entrenamiento Completado',
    expand: 'Expandir',
    collapse: 'Contraer',
    'employee-training-report': 'Informe de Entrenamiento del Empleado',
    compliance: 'Cumplimiento',
    'digital-ambassador': 'Embajador Digital',
    'shift-leader': 'Líder de Turno',
    'department-leader': 'Líder de Departamento',

    'monthly-average-restaurant-of-shifts-on-time':
      'Promedio Mensual de Restaurante % de turnos a tiempo',
    'punch-threshold': 'Umbral de Golpe: 3 min',
    'green-ontime': 'Verde: al menos 85%',
    'yellow-ontime': 'Amarillo: 70% hasta 85%',
    'red-ontime': 'Rojo: Menos de 70%',
    'please-select-a-previous-month-to-view-on-time-rating':
      'Seleccione un mes anterior para ver la calificación a tiempo.',
    'on-time': 'A Tiempo',

    'crew-monthly-annualized-turnover':
      'Rotación de tripulación anualizada mensual %',
    'green-turnover': 'Verde: por debajo del 130%',
    'yellow-turnover': 'Amarillo: 130% a 200%',
    'red-turnover': 'Rojo: por encima del 200%',
    hires: 'Contrataciones',
    terminations: 'Terminaciones',

    'monthly-annualized-shift-turnover':
      'Rotación de Turnos Anualizada Mensual %',
    'green-below-50': 'Verde: por debajo del 50%',
    'yellow-50-to-100': 'Amarillo: 50% a 100%',
    'red-above-100': 'Rojo: por encima del 100%',

    'shift-managers': 'Gerentes de Turno',
    'monthly-annual-turnover': 'Rotación Anual Mensual',
    'monthly-ann': 'Rot. Mens.',
    'ttm-turnover': 'Rotación de los últimos Doce Meses',
    ttm: 'UDM',
    'ytd-turnover': 'Rotación Desde Comienzos del Año',
    ytd: 'ADH',
    '3mo': '3 Mes.',
    '3mo-turnover': 'Rotación de 3 Meses',
    'tooltip-turnover':
      'Los datos de rotación requieren un rango de fechas completo del mes',

    'by-store': 'Por Tienda',
    'act-hrs-vs-need': 'Horas Actual vs Necesidad',
    'sch-hrs-vs-guide': 'Horas Programado vs Guía',
    'act-hrs-vs-sch': 'Horas Actual vs Programado',

    'roster-active': 'Lista Activa',
    'number-of-non-terminated-employees':
      'Número de empleados no terminados que tuvieron golpes durante el período seleccionado',
    'roster-inactive': 'Lista Inactiva',

    'punch-in-on-time': 'Entrada a Tiempo',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-within':
      'Número de turnos en el período donde el empleado entró dentro del umbral (antes o después de la hora programada)',
    'punch-in-late': 'Entrada Tarde',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-after':
      'Número de turnos en el período donde el empleado entró después del umbral',
    'punch-in-early': 'Entrada Temprano',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-before':
      'Número de turnos en el período donde el empleado entró antes del umbral',
    'punch-out-on-time': 'Salida a Tiempo',
    'number-of-scheduled-shifts-where-the-employee-punched-out-within-the-threshold':
      'Número de turnos programados donde el empleado salió dentro del umbral',
    'number-of-shifts-where-an-employee-was-on-time-divided-by-total':
      'Número de turnos donde un empleado estuvo a tiempo dividido por el total de turnos programados en el período seleccionado',
    'number-of-scheduled-shifts-an-employee-had-punches-for':
      'Número de turnos programados para los que un empleado tuvo golpes dividido por el número total de turnos programados',
    'punch-out-late': 'Salida Tarde',
    'number-of-scheduled-shifts-where-the-employee-punched-out-later':
      'Número de turnos programados donde el empleado salió más tarde que el umbral',
    'punch-out-early': 'Salida Temprana',
    'number-of-scheduled-shifts-where-the-employee-punched-out-earlier':
      'Número de turnos programados donde el empleado salió antes del umbral',
    'worked-not-sched': 'Trabajado, No Programado',
    'number-of-days-where-an-employee-worked-but-was-not-scheduled':
      'Número de días donde un empleado trabajó pero no fue programado en el período seleccionado',
    'missed-shift': 'Turno Perdido',
    'number-of-missed-shifts-for-the-employee-in-the-selected-period':
      'Número de turnos perdidos para el empleado en el período seleccionado',
    'days-on-sched': 'Días Programados',
    'crew-swing': 'Tripulación/Swing',

    'custom-date-range': 'Rango de Fechas Personalizado',
    'employee-roster': 'Lista de Empleados',
    'employee-roster-analysis': 'Análisis de la Lista de Empleados',
    'no-punches-only': 'Sin Fichar',
    search: 'Buscar',
    'copy-emails': 'Copiar Correos Electrónicos',
    'for-outlook': 'Para Outlook',
    'minor-adult': 'Menor/Adulto',
    'highlighted-rows-denote-minors':
      'Las filas resaltadas denotan menores de edad',
    'primary-hourly-pay-rate': 'Tarifa Horaria Primaria',
    'employees-primary-hourly-pay-rate':
      'La tarifa horaria primaria de los empleados puede ser cero o nula (N/A) para empleados asalariados',
    'primary-job-title-code': 'Código de Título de Trabajo Primario',
    'mcdonalds-primary-job-title-code':
      'Código de Título de Trabajo Primario de McDonalds',
    'primary-job-title-code-description':
      'Descripción del Código de Título de Trabajo Primario',
    'mcdonalds-primary-job-title-code-description':
      'Descripción del Código de Título de Trabajo Primario de McDonalds',
    purpose: 'Propósito',
    'signature-line': 'Línea de Firma',
    'date-signed': 'Fecha Firmada',
    'review-due': 'Revisión Pendiente',

    'crew-staff-size': 'Personal (Tamaño del personal)',
    'total-number-of-hourly-crew':
      'Número total de empleados por hora en la planilla para el mes seleccionado',
    'shift-staff-size': 'Turno (Tamaño del personal)',
    'total-number-of-swing-managers-or-floor-supervisors':
      'Número total de Gerentes de Turno o Supervisores de Piso cuyo estado es "Activo"',
    'gm-dm-crew-staff-size': 'GM & DM (Tamaño del personal)',
    'number-of-total-active-general-managers-and-department-managers':
      'Número de Gerentes Generales y Gerentes de Departamento activos totales',
    'crew-active': 'Personal Activo',
    'number-of-crew-who-had-punched-hours-in-the-selected-month':
      'Número de empleados que tuvieron horas marcadas en el mes seleccionado',
    'shift-active': 'Turno Activo',
    'number-of-swing-managers-or-floor-supervisors':
      'Número de Gerentes de Turno o Supervisores de Piso cuyo estado es "Activo" y tienen golpes en el mes más reciente',
    'number-of-swing-managers-or-floor-supervisors-active':
      'Número de Gerentes de Turno o Supervisores de Piso que tienen un estado "Activo" y tienen golpes en el mes más reciente',
    'under-18-staff-size': 'Menores de 18 (Tamaño del personal)',
    'number-of-staff-whose-age-is-below-18-years-old':
      'Número de empleados cuya edad es inferior a 18 años',
    'under-17-staff-size': 'Menores de 17 (Tamaño del personal)',
    'number-of-staff-whose-age-is-below-17-years-old':
      'Número de empleados cuya edad es inferior a 17 años',
    'under-16-staff-size': 'Menores de 16 (Tamaño del personal)',
    'number-of-staff-whose-age-is-below-16-years-old':
      'Número de empleados cuya edad es inferior a 16 años',
    'roster-size': 'Tamaño de la Planilla',
    'total-number-of-people-whose-status-is-active':
      'Número total de personas cuyo estado es "Activo"',
    'number-of-non-terminated-employees-who-had-punches':
      'Número de empleados no terminados que tuvieron golpes durante el período seleccionado',
    'number-crew-inactive': '# Personal Inactivo',
    'crew-who-were-on-the-roster-not-termed-in-the-selected-month':
      'Personal que estaban en la planilla (no terminados) en el mes seleccionado pero que no tuvieron horas marcadas',
    'number-of-swing-managers-or-floor-supervisors-inactive':
      'Número de Gerentes de Turno o Supervisores de Piso que tienen un estado "Activo" pero no tienen golpes en el mes más reciente',
    'crew-who-were-on-the-roster-not-termed':
      'Personal que estaban en la planilla (no terminados) en el mes seleccionado pero que no tuvieron horas marcadas',
    'number-shift-inactive': '# Turno Inactivo',
    'number-of-people-who-have-active-status':
      'Número de personas que tienen un estado "Activo" pero no tienen golpes en el mes más reciente',
    'crew-active-pct': 'Crew Activo %',
    'crew-active-divided-by-total-crew':
      'Personal Activo dividido por el total de personal',
    'shift-active-pct': 'Turno Activo %',
    'shift-active-divided-by-shift-staff-size':
      'Turno Activo dividido por el tamaño del personal de turno. Porcentaje de todos los Gerentes de Turno o Supervisores de Piso con estado "Activo" que tienen golpes en el último mes',
    'under-18-pct': 'Menores de 18 %',
    'under-18-staff-size-divided-by-total-staff':
      'Menores de 18 (Tamaño del personal) dividido por el Total del Personal',
    'under-17-pct': 'Menores de 17 %',
    'under-17-staff-size-divided-by-total-staff':
      'Menores de 17 (Tamaño del personal) dividido por el Total del Personal',
    'under-16-pct': 'Menores de 16 %',
    'under-16-staff-size-divided-by-total-staff':
      'Menores de 16 (Tamaño del personal) dividido por el Total del Personal',
    'roster-active-pct': '% de Planilla Activa',
    'roster-active-divided-by-total-staff':
      'Planilla Activa dividida por el Total del Personal',

    error_loadingReport: 'Hubo un error al cargar el informe.',
    employee_roster: 'Lista de Empleados para la Ubicación',

    birthdays: 'Cumpleaños',
    anniversaries: 'Aniversarios',
    'todays-birthdays': 'Cumpleaños de Hoy',
    'current-months-birthdays': 'Cumpleaños del Mes Actual',
    'next-months-birthdays': 'Cumpleaños del Próximo Mes',
    loc: 'Ubicación',
    'employee-name': 'Nombre del Empleado',
    location: 'Ubicación',
    todays: 'Hoy',
    'current-months': 'Este Mes',
    'next-months': 'Próximo Mes',

    'back-to-employee-time-punches':
      'Volver a los Registros de Tiempo del Empleado',
    'store-time-punches': 'Registros de Tiempo de la Tienda',
    'by-employee': 'Por Empleado',
    'day-of-week': 'Día de la Semana',
    'payroll-id': 'ID de Nómina',
    custom: 'Personalizado',

    back_to_employee_time_punches:
      'Volver a los Registros de Tiempo del Empleado',
    time_punch_export: 'Exportar Registros de Tiempo',

    'missing-pii-permissions-message':
      'Le faltan los permisos requeridos de Información Personal Identificable (PII) para programar este informe: "Access Full Names" y "Access to Address, Email, DOB, National Origin". Comuníquese con el soporte si cree que esto es un error.',
    'report-title': 'Resumen por Ubicación',
    'report-title-exception': 'Por Excepción',
    'report-title-summary-exceptions': 'Resumen Por Excepciones',
    'report-title-summary-location': 'Resumen Por Ubicación',
    'adult-exceptions-header': 'Excepciones Regulares',
    'minor-exceptions-header': 'Excepciones de Menores',
    'exceptions-header': 'Total de Excepciones',
    'adult-exceptions-description':
      'Excepciones para cualquier empleado que no sea menor de edad',
    'minor-exceptions-description':
      'Excepciones para cualquier empleado menor de edad, independientemente de si se infringió una regla regular o menor',
    'exceptions-description':
      'Un recuento de todas las excepciones para un empleado',
    'breach-type-header': 'Excepción',
    'breach-type-description':
      'Regla del software de gestión de la fuerza laboral que se infringió',
    'highlighted-rows-explanation':
      'Las filas resaltadas indican que se han editado los registros de entrada y salida',
    'labor-date-header': 'Fecha Laboral',
    'employee-full-name-header': 'Empleado',
    'employee-full-name-description': 'Nombre del Empleado',
    'first-name-header': 'Nombre',
    'first-name-description': 'Nombre del Empleado',
    'last-name': 'Apellido',
    age: 'Edad',
    'actual-shift-start-time-header': 'Inicio Real',
    'actual-shift-start-time-description': 'Hora de inicio real de este turno',
    'actual-shift-end-time-header': 'Fin Real',
    'actual-shift-end-time-description':
      'Hora de finalización real de este turno',
    'schedule-shift-start-time-header': 'Inicio Programado',
    'schedule-shift-start-time-description':
      'Hora de inicio programada de este turno',
    'schedule-shift-end-time-header': 'Fin Programado',
    'schedule-shift-end-time-description':
      'Hora de finalización programada de este turno',
    'actual-shift-length-header': 'Duración Real del Turno',
    'actual-shift-length-description': 'La duración real del turno',
    'date-time-of-exception-header': 'Hora de Excepción',
    'date-time-of-exception-description': 'Hora en que ocurrió la excepción',
    'is-manager-authorized-header': 'Gerente Autorizado',
    'is-manager-authorized-description':
      '¿Esta excepción fue autorizada por un gerente?',
    'manager-name-header': 'Gerente',
    'manager-name-description': 'Nombre del gerente',
    punches: 'Registro',
    'error-loading-report': 'Hubo un error al cargar el informe',
    'punch-type': 'Tipo de Marcaje',
    'is-overnight-shift': 'Es turno nocturno',
    'is-overnight-shift-desc':
      "'Y' si el marcaje fue el de finalización a las 4:00 o el de inicio a las 4:00 para un turno que cruzó días laborales; de lo contrario, 'N'",
    'is-paid-break': 'Es descanso pagado',
    'is-paid-break-desc':
      "'Y' si el marcaje es el de inicio o fin de un descanso pagado; de lo contrario, 'N'",
    'in-time': 'Hora de Entrada',
    'out-time': 'Hora de Salida',

    'time-and-attendance': 'Tiempo y Asistencia',
    'time-and-attendance-analysis': 'Análisis de Tiempo y Asistencia',
    'first-name': 'Nombre',
    'employee-first-name': 'Nombre del Empleado',
    'employee-last-name': 'Apellido del Empleado',
    'job-title-code': 'Código de Puesto',
    'mcdonalds-job-title-code': "Código de Puesto de McDonald's",
    'number-of-shifts-in-the-period-where-the-employee-punched-in-within-the-threshold':
      'Número de turnos en el período en el que el empleado marcó dentro del umbral (antes o después de la hora programada)',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-after-the-threshold':
      'Número de turnos en el período en el que el empleado marcó después del umbral',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-before-the-threshold':
      'Número de turnos en el período en el que el empleado marcó antes del umbral',
    'number-of-shifts-where-an-employee-was-on-time-divided-by-total-shifts-scheduled-in-the-selected-period':
      'Número de turnos en los que un empleado estuvo a tiempo dividido por el total de turnos programados en el período seleccionado',
    'number-of-scheduled-shifts-an-employee-had-punches-for-divided-by-total-number-of-scheduled-shifts':
      'Número de turnos programados que un empleado tuvo golpes divididos por el número total de turnos programados',
    'number-of-scheduled-shifts-where-the-employee-punched-out-later-than-the-threshold':
      'Número de turnos programados en los que el empleado salió más tarde del umbral',
    'number-of-scheduled-shifts-where-the-employee-punched-out-earlier-than-the-threshold':
      'Número de turnos programados en los que el empleado salió antes del umbral',
    'number-of-days-where-an-employee-worked-but-was-not-scheduled-in-the-selected-period':
      'Número de días en los que un empleado trabajó pero no estaba programado en el período seleccionado',
    'mcdonalds-global-employee-identifier':
      "Identificador Global de Empleados de McDonald's (GEID)",
    'sched-start-time': 'Hora de Inicio Programada',
    'sched-end-time': 'Hora de Finalización Programada',
    'punch-start-time': 'Hora de Inicio del Golpe',
    'punch-end-time': 'Hora de Finalización del Golpe',
    'punch-early-late-min-threshold':
      'Umbral de Minutos de Entrada/Salida Temprano/Tarde',
    schedule: 'Horario',
    'at-store': 'En Tienda',

    'january-thru-last-month': 'Enero Hasta el Mes Pasado',
    'trailing-13-months': 'Últimos 13 Meses',
    'premium-upgrade-message-start': '¿Quieres reducir la rotación? ',
    'premium-upgrade-message-link-text': 'Actualiza a Premium',
    'premium-upgrade-message-end':
      ' para impulsar el compromiso de los empleados y mejorar la retención.',
    'jtc-definitions': 'Definiciones de JTC',
    'jtc-name': 'Nombre de JTC',
    'turnover-type': 'Tipo de Rotación',
    'general-manager-w-mgr-punches': 'GERENTE GENERAL CON FICHAJES DE GERENTE',
    'general-manager-w-crew-punches': 'GERENTE GENERAL CON FICHAJES DE EQUIPO',
    'general-manager': 'GERENTE GENERAL',
    'store-mgr-trainee-f': 'GERENTE DE TIENDA TRAINEE-F',
    'floor-supervisor': 'SUPERVISOR DE PISO',
    swing: 'Swing',
    'cert-swing-mgr': 'GERENTE DE SWING CERTIFICADO',
    'crew-trainer': 'ENTRENADOR DE EQUIPO',
    'crew-person': 'PERSONA DE EQUIPO',
    'manager-oje': 'GERENTE OJE',
    'security-guard': 'GUARDIA DE SEGURIDAD',
    'backup-maintenance-person': 'PERSONA DE MANTENIMIENTO DE RESPALDO',
    'primary-maintenance-person': 'PERSONA DE MANTENIMIENTO PRINCIPAL',
    'intern-f': 'PRACTICANTE-F',
    'administrative-assistant': 'ASISTENTE ADMINISTRATIVO',
    'shift-manager-trainee': 'GERENTE DE TURNO TRAINEE',
    'otp-pro-hourly': 'OTP PRO POR HORA',
    'otp-pro-salary': 'OTP PRO SALARIO',
    'department-manager-i': 'GERENTE DE DEPARTAMENTO i',
    'department-manager-ii': 'GERENTE DE DEPARTAMENTO ii',
    'department-manager-iii': 'GERENTE DE DEPARTAMENTO iii',
    'area-manager-grill-ca': 'GERENTE DE ÁREA - GRILL (CA)',
    'guam-inventory-employee': 'EMPLEADO DE INVENTARIO DE GUAM',
    'intern-so-cal-region': 'PRACTICANTE - REGIÓN SO CAL',
    'profit-center-admin-assist':
      'ASISTENTE ADMINISTRATIVO DEL CENTRO DE BENEFICIOS',
    'lsm-coordinator': 'COORDINADOR LSM',
    'intern-gsw': 'PRACTICANTE GSW',
    'dept-mgr-w-i-crew-punches':
      'GERENTE DE DEPARTAMENTO CON i FICHAJES DE EQUIPO',
    'dept-mgr-w-ii-crew-punches':
      'GERENTE DE DEPARTAMENTO CON ii FICHAJES DE EQUIPO',
    'dept-mgr-w-iii-crew-punches':
      'GERENTE DE DEPARTAMENTO CON iii FICHAJES DE EQUIPO',

    turnover: 'Rotación',
    'number-of-employees-hired-in-the-period':
      'Número de empleados contratados en el período',
    'roster-size-description':
      'Cantidad de empleados activos en la plantilla dentro del grupo seleccionado',
    terms: 'Términos',
    'number-of-employees-whose-job-ended':
      'Número de empleados cuyo trabajo terminó',
    'terms-less-than-90': 'Términos < 90',
    'terms-less-than-90-description':
      'Para el mes, el número de nuevas contrataciones que fueron dadas de baja antes de cumplir 90 días de empleo. Este número no será definitivo hasta 90 días después de que termine el mes (enero no será definitivo hasta el 1 de mayo, febrero hasta el 1 de junio, etc.)',
    'retained-greater-than-90': 'Retenido > 90',
    'number-of-employees-who-remained-employed-at-the-restaurant-more-than-90-days':
      'Número de empleados que permanecieron empleados en el restaurante más de 90 días',
    'terms-less-than-90-pct': 'Términos < 90 Pct',
    'terms-less-than-90-pct-description':
      'Términos < 90 dividido por las contrataciones de ese mes. Este número no será definitivo hasta 90 días después de que termine el mes (enero no será definitivo hasta el 1 de mayo, febrero hasta el 1 de junio, etc.)',
    'retained-greater-than-90-pct': 'Retenido > 90 Pct',
    'retained-greater-than-90-divided-by-number-of-employees-hired-in-the-month':
      'Retenido > 90 dividido por el número de empleados contratados en el mes',
    'monthly-turnover-multiplied-by-12-to-annualized-it':
      'Rotación mensual multiplicada por 12 para anualizarlo',
    'ttm-turnover-description':
      'Rotación TTM. Total de términos en los últimos 12 meses dividido por el tamaño de la plantilla al final del mes más reciente',
    'ytd-turnover-description':
      'Rotación acumulada del año. Total de términos hasta ahora en el año actual dividido por el tamaño de la plantilla al final del mes más reciente',
    'three-month-turnover': 'Rotación de 3 meses',
    '3-month-turnover-description':
      'Informes de rotación de 3 meses para el período más reciente de 3 meses en el que se puede saber si las nuevas contrataciones alcanzaron los 90 días. {link}',
    'details-link-text': 'Los detalles están aquí',
    'three-month-terms': 'Términos de 3 meses',
    '3-month-terms-description':
      'Número de personas dadas de baja en el período de 3 meses',
    'three-month-retained': 'Retenido durante 3 meses',
    '3-month-retained-description':
      'Número de personas retenidas en el período de 3 meses',
    'new-hire-retention': 'Retención de Nuevos Empleados',
    'employees-in-red-were-terminated-prior-to-working-90-days':
      'Los empleados en rojo fueron despedidos antes de trabajar 90 días',

    'filter-results': 'Filtrar Resultados',
    'emp-hours-this-week': 'Horas de Empleados Esta Semana',

    'shift-report': 'Informe de Turno',
    'actual-gc': 'GC Actual',
    'actual-gc-recorded-by-the-pos': 'GC Actual registrado por el POS',
    'projected-gc': 'GC Proyectado',
    'actual-gc-vs-proj': 'Act GC vs Proj',
    'actual-gc-minus-gc-that-were-projected-in-the-scheduling-software':
      'GC Actual menos GC que se proyectaron en el software de programación',
    'proj-eff': 'Eficiencia Proyectada',
    'number-of-hours-where-actual-gc-was-within-10':
      'Número de horas en las que el GC real estuvo dentro de 10 del GC proyectado, dividido por el total de horas que el restaurante estuvo abierto',
    'total-act-hrs': 'Total de Horas Actuales',
    'var-actual-hrs': 'Horas Actuales Variables',
    'act-punch-hrs': 'Horas de Golpe Actuales',
    'actual-hours-punched-on-the-timeclock':
      'Horas reales marcadas en el reloj de tiempo',
    'salaried-manager-hrs': 'Horas del Gerente Asalariado',
    'since-salaried-managers-do-not':
      'Dado que los gerentes asalariados no marcan el reloj, se utilizan las horas programadas del gerente asalariado (se supone que todas las horas programadas del asalariado se trabajan)',
    'total-need-hrs': 'Total de Horas Necesarias',
    'total-hours-needed-hours-variable-hours-needed':
      'Horas totales necesarias - Horas variables necesarias más horas de piso necesarias + horas fijas programadas',
    'var-need-hrs': 'Horas Necesarias Variables',
    'flr-need-hrs': 'Horas Necesarias de Piso',
    'manager-hours-needed-to-run-the-floor':
      'Horas del Gerente necesarias para dirigir el piso',
    'total-sch-hrs': 'Total de Horas Programadas',
    'var-sch-hrs': 'Horas Programadas Variables',
    'flr-sch-hrs': 'Horas Programadas de Piso',
    'manager-hours-scheduled-to-run-the-floor':
      'Horas del Gerente programadas para dirigir el piso',
    'fixed-sch-hrs': 'Horas Programadas Fijas',
    'scheduled-hours-for-schedule-symbols-that-are-fixed':
      'Horas programadas para símbolos de programación que son "fijos" (no dependen del volumen de ventas)',
    'total-guide': 'Guía Total',
    'fixed-guide': 'Guía Fija',
    'hours-in-the-fixed-hours-guide':
      'Horas en la guía de horas fijas (también llamada contrato) para un símbolo de programación determinado',
    'var-guide': 'Guía Variable',
    'flr-guide': 'Guía de Piso',
    'floor-hours-needed-based-on-gc-volume':
      'Horas de piso necesarias según el volumen de GC',
    'act-vs-need-percentage': 'Act vs Necesidad %',
    'sch-vs-guide-percentage': 'Programado vs Guía %',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Horas reales utilizadas en comparación con las horas que se programaron',
    'act-vs-sch-percentage': 'Act vs Programado %',
    'sch-flr-vs-guide': 'Piso Programado vs Guía',
    'var-act-vs-need': 'Act vs Necesidad Variable',
    'actual-variable-hours-used-compared-to-variable-hours-needed':
      'Horas variables reales utilizadas en comparación con las horas variables necesarias según la guía VLH',
    'fixed-sch-vs-guide': 'Programado Fijo vs Guía',
    'var-sch-vs-guide': 'Programado Variable vs Guía',

    labor_schedules: 'Horarios Laborales',

    'by-employee-title': 'Empleado',
    'by-store-title': 'Tienda',
    'auto-rewards': 'Recompensas Automáticas',
    'rewards-by-store': 'Recompensas por tienda',
    'rewards-by-employee': 'Recompensas por empleado',
    transfers: 'Transferencias',
    purchase: 'Compra',
    refund: 'Reembolso',
    manual: 'Manual',
    auto: 'Auto',
    pts: 'Ptos',
    qty: 'Cantidad',
    'employee-name-description': 'Nombre del empleado',
    'by-date': 'Por Fecha',
    'sum-all-dates': 'Sumar',
    geid: 'GEID',
    '3-month-turnover': 'Rotación de 3 Meses',
    '3-month-terms': 'Términos de 3 Meses',
    '3-month-retained': 'Retenido de 3 Meses',
    category: 'Categoría',
    value: 'Valor',
    'retained-90-divided-by-number-of-employees-hired-in-the-month':
      'Retenido > 90 dividido por el número de empleados contratados en el mes',
    primary: 'Primario',
    secondary: 'Secundario',
    // Training Report — Shift Leader
    'shift-leader-foundations': 'Fundamentos de Líder de Turno',
    'sl-shift-leader': 'Líder de Turno',
    'sl-advancing-tooltip':
      'Liderazgo Avanzado es una ruta secundaria que solo puede tomarse después de completar Fundamentos de Liderazgo',
    'sl-location': 'Ubicación',
    'sl-role': 'Rol',
    'sl-path': 'Ruta',
    'sl-employee': 'Empleado',
    'sl-jtc-start-date': 'Fecha de Inicio JTC',
    'sl-due-date': 'Fecha de Vencimiento',
    'sl-avg-days': 'Días Promedio para Completar',
    'sl-all': 'Todos',
    'sl-past-due': 'Vencido',
    'sl-past-due-hint':
      'Vencido: no completado y la fecha límite pasó hace {n} días',
    'sl-due-soon-hint': 'Vence pronto: vence en {n} días',
    'sl-past-due-group-hint':
      'Vencido: {n} curso(s) obligatorio(s) de este grupo no completado(s) antes de la fecha límite',
    'sl-due-soon-group-hint':
      'Vence pronto: {n} curso(s) obligatorio(s) de este grupo vence(n) en los próximos días',
    'sl-due-soon': 'Próximo a Vencer',
    'sl-not-started': 'No Iniciado',
    'sl-in-progress': 'En Progreso',
    'sl-completed': 'Completado',
    'sl-na': 'n/d',
    'sl-badge-start-overdue': 'Inicio vencido - 14',
    'sl-badge-start-due': 'Inicio por vencer - 14',
    'sl-employees': 'empleados',
    'sl-card-past-due': 'Fecha Vencida',
    'sl-card-due-soon': 'Próximo a Vencer',
    'past-due-date-training': 'Entrenamiento con Fecha Vencida',
    'due-soon-training': 'Entrenamiento Próximo a Vencer',
    'sl-card-not-trained': 'No Entrenado en esta Ruta',
    'sl-col-past-due': '# Vencido',
    'sl-col-due-soon': '# Próximo a Vencer',
    'sl-first-course-col': 'Primer Curso (14 días)',
    'sl-training-status': 'Estado del Entrenamiento',
    'sl-see-all': 'VER TODO',
    'sl-close': 'Cerrar',
    'sl-due-header-tooltip':
      'El primer curso de la ruta debe tomarse a más tardar 14 días después de la fecha efectiva del JTC. La ruta completa debe completarse a más tardar 9 meses después de la fecha efectiva del JTC.',
    'sl-tip-first-overdue':
      'El primer curso no se inició dentro de los 14 días del JTC (vencía el {date}).',
    'sl-tip-first-due':
      'El primer curso debe iniciarse dentro de los 14 días del JTC (vence el {date}).',
    'sl-tip-count-past-due':
      '{n} cursos vencidos según el plazo de 9 meses de la ruta (vencía el {date}).',
    'sl-tip-count-due-soon':
      '{n} cursos por vencer antes del plazo de 9 meses de la ruta (vence el {date}).',
    'hire-date': 'Fecha de Contratación',
    'completion-date': 'Fecha de Finalización',
    'course-name': 'Nombre del Curso',
    'employee-training-details': 'Detalles de Entrenamiento del Empleado',
    'new-hire': 'Nuevo Empleado',
    'job-category': 'Categoría de Trabajo',
    'training-report': 'Informe de Entrenamiento',
    'course-required': 'Requerido',
    'crew-pct-past-due': '{pct} Vencido',
    'crew-pct-crew-trainer-not-completed':
      '{pct} Entrenamiento de Entrenador de Equipo No Completado',
    'crew-pct-due-soon': '{pct} Próximo a Vencer',
    'sl-pct-not-trained': '{pct} No Entrenado en esta Ruta',
    'crew-pct-path-not-completed': '{pct} {path} No Completado',
    'crew-pct-trained': '{pct} Entrenado',
    'past-due-value': 'Valor Vencido',
    'course-status': 'Estado del Curso',
    'overall-progress': 'Progreso General {pct}%',
    'dl-path-guest-services': 'Ruta de Servicio al Cliente',
    'dl-path-kitchen-leader': 'Ruta de Líder de Cocina',
    'dl-path-people-leader': 'Ruta de Líder de Personas',
    'dl-paths': 'Ruta(s)',
    'dl-standalone-courses': 'Cursos Independientes',
    'dl-dlim': 'DLIM',
    'dl-picked-guest-services': 'Eligió Ruta de Servicio al Cliente',
    'dl-picked-kitchen-leader': 'Eligió Ruta de Líder de Cocina',
    'dl-picked-people-leader': 'Eligió Ruta de Líder de Personas',
    'dl-completed-dlim': 'Completó Curso DLIM (1 de 2)',
    'dl-dlim-subtitle': '1 de 2 es obligatorio',
    'gm-lgr-subtitle': '1 de 2 es obligatorio',
    'capstone-required-tooltip': 'Obligatorio.',
    'n-days': '{n} días',
    'unknown-course': 'Curso Desconocido',
    'general-manager-role': 'Gerente General',
    'crew-role': 'Tripulación',
    'due-soon-value': 'Valor de Próximo a Vencer',
    'multiple-courses': 'Cursos Múltiples',
    download: 'Descargar',
    'pct-completed': '% Completado',
    'not-available': 'N/D',
    'new-hires-label': 'Nuevas Contrataciones',
    'last-n-days': 'Últimos {n} días',
    'geid-label': 'GEID',
    'gm-path-leading-people': 'Ruta de Liderazgo de Personas',
    'gm-path-leading-hospitality': 'Ruta de Liderazgo de Hospitalidad',
    'gm-path-leading-operational-excellence': 'Ruta de Excelencia Operacional',
    'gm-path-financial': 'La Ruta Financiera',
    'gm-not-trained-in-path': 'No Entrenado en Esta Ruta',
    'gm-employees-pct': '{n} empleados ({pct}%)',
    'beverage-specialist': 'Especialista en Bebidas',
    'employees-who-picked': 'Empleados que Eligieron {path}',
    'all-n-paths': 'Las {n}',
    'gm-picked-leading-people': 'Eligió Ruta de Liderazgo de Personas',
    'gm-picked-leading-hospitality': 'Eligió Ruta de Liderazgo de Hospitalidad',
    'gm-picked-leading-operational-excellence':
      'Eligió Ruta de Excelencia Operacional',
    'gm-picked-financial': 'Eligió La Ruta Financiera',
    'gm-completed-lgr': 'Completó Curso LGR (1 de 2)',
    'gm-lgr': 'LGR',
    'dl-path-progress': 'Progreso de la Ruta',
    'dl-completion-date': 'Fecha de Finalización',
    'dl-percent-of-employees': '{pct}% de Empleados',
    'dl-overall-progress': 'Progreso General {pct}%',
    'dl-all-three': 'Las 3',
    'dl-certification-name': 'Nombre de la Certificación',
    'dl-completed-on': 'Completado el {date}',
    'employees-none-for-status': 'No hay empleados con este estado',
    'employees-load-failed':
      'No se pudieron cargar los empleados. Cambie un filtro para reintentar.',
    'employees-removed-for-status':
      '{n} empleado(s) seleccionado(s) eliminado(s): no tienen este estado',
    'mapping-title': 'Mapeo de Capacitación',
    'mapping-courses-filters': 'Cursos',
    'mapping-completions': 'Cumplimientos',
    'mapping-completions-any': 'Todos',
    'mapping-completions-none': 'Ninguno',
    'mapping-completions-some': 'Algunos',
    'mapping-hide-retired': 'Ocultar retirados',
    'mapping-unmapped-ids-caption':
      'Cumplimientos sin curso. No se ven afectados por los filtros de cursos de arriba.',
    'mapping-group-assigned': 'En una ruta',
    'mapping-n-of-m-courses': '{n} de {m}',
    'mapping-path-reordered': 'Orden de rutas guardado',
    'mapping-show': 'Mostrar',
    'mapping-hide': 'Ocultar',
    'mapping-applies-to-line': 'Aplica a',
    'mapping-reorder-hint': 'Arrastre para reordenar',
    'mapping-required-paths': 'Rutas requeridas',
    'mapping-course-library': 'Biblioteca de cursos',
    'mapping-search-courses': 'Buscar por nombre o ID de Campus',
    'mapping-library-hint':
      'Arrastre un curso a una ruta para agregarlo, o entre rutas para moverlo. Use la x de un curso para quitarlo de la ruta.',
    'mapping-group-unassigned': 'En ninguna ruta',
    'mapping-unmapped-ids': 'IDs de Campus con cumplimientos pero sin curso',
    'mapping-unmapped-ids-hint':
      'Empleados de las ubicaciones seleccionadas completaron estos IDs de curso de Campus, pero ningún curso los cubre. Cree un curso a partir de uno para mapearlo.',
    'mapping-no-courses': 'Sin cursos',
    'mapping-drop-course-here': 'Suelte un curso aquí',
    'mapping-n-completed': '{n} completaron',
    'mapping-zero-completed': '0 completaron',
    'mapping-last-completed': 'último {date}',
    'mapping-create-course-from-id': 'Crear un curso para {id}',
    'mapping-course-moved': 'Orden de cursos guardado',
    'mapping-path-regrouped': 'Requisito de la ruta actualizado',
    'mapping-n-paths-no-courses': '{n} rutas no tienen cursos',
    'mapping-n-unassigned-courses': '{n} cursos no están en ninguna ruta',
    'mapping-n-unassigned-with-completions':
      '{n} de ellos tienen cumplimientos',
    'mapping-add-jtc': 'Agregar JTC',
    'mapping-jtc-code': 'Código JTC',
    'mapping-jtc-invalid': 'Ingrese el JTC como número entero',
    'mapping-remove-jtc': 'Quitar el JTC {jtc}',
    'mapping-new-path': 'Nueva ruta',
    'mapping-edit-path': 'Editar ruta',
    'mapping-require-path': 'Requerir una ruta',
    'mapping-remove-from-role': 'Quitar de este rol',
    'mapping-add-course': 'Agregar curso',
    'mapping-edit-course': 'Editar curso',
    'mapping-remove-from-path': 'Quitar de esta ruta',
    'mapping-existing-course': 'Curso existente',
    'mapping-new-course': 'Nuevo curso',
    'mapping-pick-course': 'Elija un curso',
    'mapping-no-courses-left': 'No hay cursos para agregar',
    'mapping-on-no-path': 'en ninguna ruta',
    'mapping-course-name': 'Nombre del curso',
    'mapping-path-name': 'Nombre de la ruta',
    'mapping-campus-ids-hint':
      'Escriba un ID de curso de Campus y presione Enter',
    'mapping-course-url': 'Enlace de Campus (https)',
    'mapping-art': 'Arte',
    'mapping-art-preview-celebration': 'Vista previa de la celebración',
    'mapping-art-celebration-preview': 'Celebración de la llave (en vivo)',
    'mapping-art-palette-blobs': 'Manchas',
    'mapping-art-palette-rays': 'Rayos',
    'mapping-art-palette-confetti': 'Confeti',
    'mapping-art-palette-default': 'valores de la app',
    'mapping-art-key-palette': 'Paleta de la celebración',
    'mapping-art-palette-add': 'Añadir color',
    'mapping-art-palette-remove': 'Quitar color',
    'mapping-art-missing': 'Falta arte: {n}',
    'mapping-art-missing-title':
      'Falta arte obligatorio; la app del equipo mostrará respaldos',
    'mapping-art-show': 'Mostrar',
    'mapping-art-hide': 'Ocultar',
    'mapping-art-none': 'Aún sin arte',
    'mapping-art-save-first':
      'Guarda el registro primero, luego se puede subir arte',
    'mapping-art-upload': 'Subir',
    'mapping-art-replace': 'Reemplazar',
    'mapping-art-clear': 'Quitar',
    'mapping-art-door-still': 'Puerta (cerrada)',
    'mapping-art-door-clean': 'Puerta, recorte ajustado',
    'mapping-art-door': 'Puerta',
    'mapping-art-door-rig': 'Estilo de puerta',
    'mapping-default-art': 'Arte predeterminado',
    'mapping-default-art-hint':
      'Lo que muestra cualquier ruta o curso sin arte propio, espacio por espacio. Una ruta con estilo de puerta conserva su puerta; una sin estilo dibuja esta. Aplica a todos los roles.',
    'mapping-art-rig-magic': 'Mágica',
    'mapping-art-rig-magic-hint':
      'Una losa plegable con cerradura luminosa. La usan Foundation y Beverage Specialist.',
    'mapping-art-rig-hinged': 'Con bisagras',
    'mapping-art-rig-hinged-hint':
      'Una hoja que gira sobre una palanca y lanza objetos al abrirse. La usa Production.',
    'mapping-art-rig-diner': 'Diner',
    'mapping-art-rig-diner-hint':
      'Una puerta vaivén de dos hojas con bandeja. La usa Service.',
    'mapping-art-rig-vault': 'Bóveda',
    'mapping-art-rig-vault-hint':
      'Una puerta redonda de bóveda con trazos holográficos. La usa Digital Ambassador.',
    'mapping-art-rig-locker': 'Casillero',
    'mapping-art-rig-locker-hint':
      'Una puerta de casillero con gemas flotantes y un estallido de botín. La usa Compliance.',
    'mapping-art-door-layers': 'Capas',
    'mapping-art-door-layers-hint':
      'Dibujadas sobre la plantilla del estilo. La puerta solo se dibuja con todas las capas subidas.',
    'mapping-art-door-layer-closed': 'Losa cerrada',
    'mapping-art-door-layer-frame': 'Marco',
    'mapping-art-door-layer-leaf': 'Hoja',
    'mapping-art-door-layer-interior': 'Interior',
    'mapping-art-door-layer-lever': 'Palanca',
    'mapping-art-door-layer-leafFront': 'Hoja, frente',
    'mapping-art-door-layer-leafBack': 'Hoja, fondo',
    'mapping-art-door-layer-tray': 'Bandeja',
    'mapping-art-door-layer-holo': 'Holo',
    'mapping-art-door-layer-traces': 'Trazos',
    'mapping-art-door-layer-plate': 'Placa',
    'mapping-art-door-layer-faceFront': 'Cara, frente',
    'mapping-art-door-layer-faceBack': 'Cara, fondo',
    'mapping-art-door-layer-knob': 'Perilla',
    'mapping-art-door-decor-props': 'Objetos lanzados',
    'mapping-art-door-decor-gems': 'Gemas flotantes',
    'mapping-art-door-decor-loot': 'Estallido de botín',
    'mapping-art-optional': 'opcional',
    'mapping-art-tuning-scale': 'Escala',
    'mapping-art-tuning-shiftX': 'Ajuste de la puerta (px)',
    'mapping-art-tuning-labelShift': 'Ajuste de la etiqueta (px)',
    'mapping-art-tuning-opening': 'Polígono del vano',
    'mapping-art-tuning-keyholeX': 'Cerradura x',
    'mapping-art-tuning-keyholeY': 'Cerradura y',
    'mapping-art-tuning-edge': 'Degradado del borde',
    'mapping-art-advanced': 'Avanzado',
    'mapping-art-advanced-hint':
      'Solo hace falta cuando el arte se aparta de la plantilla del estilo.',
    'mapping-art-door-preview': 'Vista previa de la puerta',
    'mapping-art-door-preview-hint':
      'Dibujada por el mismo mecanismo que usa la app de crew, a la escala de arriba.',
    'mapping-art-door-open': 'Abrir',
    'mapping-art-door-close': 'Cerrar',
    'mapping-art-door-incomplete': 'Sube todas las capas para ver la puerta',
    'mapping-art-gradient': 'Degradado de fondo',
    'mapping-art-fallback-key': 'Llave de respaldo',
    'mapping-art-celebration-key': 'Llave de celebración',
    'mapping-art-preview-title': 'Vista previa de la celebración',
    'mapping-art-preview-hint':
      'Pulsa play para ver la llave de celebración sobre el degradado con la paleta de arriba. Se reinicia al cambiar un color.',
    'mapping-art-missing-slot': 'Falta',
    'mapping-art-course-key': 'Llave',
    'mapping-use-groups': 'Grupos por modalidad',
    'mapping-item-name': 'Nombre del paso',
    'mapping-n-steps': '{n} pasos',
    'mapping-edit-group': 'Editar grupo',
    'mapping-edit-step': 'Editar paso',
    'mapping-unnamed-step': 'Paso sin nombre',
    'mapping-done': 'Listo',
    'mapping-remove-item': 'Quitar paso',
    'mapping-drag-to-reorder': 'Arrastra para reordenar',
    'mapping-group-modality': 'Modalidad',
    'mapping-no-modality': 'Sin modalidad',
    'mapping-group-required': 'Obligatorio',
    'mapping-optional-group': 'opcional',
    'mapping-group-item': 'Elemento {n}',
    'mapping-group-item-hint':
      'Ids de Campus de este elemento, cualquiera de ellos cuenta',
    'mapping-add-item': 'Agregar elemento',
    'mapping-add-group': 'Agregar grupo',
    'mapping-remove-group': 'Quitar grupo',
    'mapping-group-rule': 'Hay que completar todos los elementos del grupo',
    'mapping-groups-rule':
      'El curso se completa cuando se completa cualquier grupo obligatorio. Los grupos opcionales solo muestran el progreso.',
    'mapping-group-ids-required':
      'Cada grupo necesita al menos un elemento con un id de Campus',
    'mapping-retired-flag': 'Retirado',
    'mapping-states-scope': 'Solo para tiendas en estos estados (opcional)',
    'mapping-translations': 'Traducciones',
    'mapping-translation-es': 'Español',
    'mapping-translation-fr': 'Francés',
    'mapping-translation-fr-ca': 'Francés (Canadá)',
    'mapping-due-window': 'Plazo de vencimiento',
    'mapping-window-days': 'Días',
    'mapping-applies-each': 'Cada curso',
    'mapping-applies-first': 'Solo el primer curso',
    'mapping-due-soon-days': 'Próximo a vencer, días antes',
    'mapping-path-deadline-label': 'Fecha límite de toda la ruta',
    'mapping-deadline-months': 'Meses',
    'mapping-anchor': 'Contado desde',
    'mapping-anchor-first-punch-label': 'Primera marcación',
    'mapping-anchor-first-jtc-label': 'Primer inicio de JTC',
    'mapping-anchor-role': 'En el rol (opcional)',
    'mapping-due-dates-from-label': 'Solo para inicios desde el (AAAA-MM-DD)',
    'mapping-required': 'Requerida',
    'mapping-pick-one-group': 'Grupo de elegir una (opcional)',
    'mapping-pick-one-group-hint':
      'Las rutas con el mismo nombre de grupo son alternativas: el empleado completa una de ellas',
    'mapping-pick-path': 'Elija una ruta',
    'mapping-no-paths-left': 'Todas las rutas ya están en este rol',
    'mapping-save': 'Guardar',
    'mapping-cancel': 'Cancelar',
    'mapping-save-failed': 'El cambio no se guardó.',
    'mapping-saved-course': 'Curso guardado',
    'mapping-saved-path': 'Ruta guardada',
    'mapping-course-added': 'Curso agregado a la ruta',
    'mapping-course-removed': 'Curso quitado de la ruta',
    'mapping-jtc-added': 'JTC agregado',
    'mapping-jtc-removed': 'JTC quitado',
    'mapping-path-required': 'Ruta agregada al rol',
    'mapping-path-unrequired': 'Ruta quitada del rol',
    'mapping-name-required': 'El nombre es obligatorio',
    'mapping-campus-ids-required':
      'Se requiere al menos un ID de curso de Campus',
    'mapping-url-https': 'El enlace debe comenzar con https://',
    'mapping-select-role':
      'Seleccione un rol para ver sus rutas, cursos y empleados.',
    'mapping-select-locations': 'Seleccione al menos una ubicación.',
    'mapping-paths': 'Rutas',
    'mapping-paths-and-courses': 'Rutas y cursos',
    'mapping-n-paths': '{n} rutas',
    'mapping-n-courses': '{n} cursos',
    'mapping-pick-one-of-n': 'Elegir una de {n}',
    'mapping-pick-one-plus-n': 'Elegir una de {n}, más {m} requerida',
    'mapping-pick-one-of-these-paths': 'Elegir una de estas rutas',
    'mapping-required-with-path': 'Requerida junto con la ruta',
    'mapping-optional-paths': 'Rutas opcionales',
    'mapping-pick-one': 'elegir una',
    'mapping-admin-only':
      'Esta página solo está disponible para administradores de QSR.',
    'mapping-required-for-role': 'requerida',
    'mapping-optional-for-role': 'opcional',
    'mapping-applies-to': 'Aplica a',
    'mapping-employees-with-jtcs': 'Empleados en {n} códigos de puesto (JTC)',
    'mapping-all-active-employees': 'Todos los empleados activos',
    'mapping-due-rule': 'Regla de vencimiento',
    'mapping-no-due-rule': 'Sin fechas de vencimiento',
    'mapping-each-course-due':
      'Cada curso vence {days} días después de {anchor}',
    'mapping-first-course-due':
      'El primer curso vence {days} días después de {anchor}',
    'mapping-path-deadline':
      'La ruta completa vence {months} meses después de {anchor}',
    'mapping-due-dates-from':
      'Las fechas de vencimiento aplican a inicios desde el {date}',
    'mapping-anchor-first-punch': 'la primera marcación',
    'mapping-anchor-first-jtc': 'el primer inicio de JTC',
    'mapping-anchor-first-jtc-in-role': 'el primer inicio en {role}',
    'mapping-courses': 'Cursos',
    'mapping-campus-ids': 'IDs de Campus',
    'mapping-states': 'Estados',
    'mapping-retired': 'Retirado',
    'mapping-open-in-campus': 'Abrir en Campus',
    'mapping-first-punch': 'Primera Marcación',
    'mapping-name-unavailable': 'Nombre no disponible',
    'mapping-employees': 'Empleados',
    'mapping-n-employees': '{n} empleados',
    'mapping-no-employees':
      'Ningún empleado de las ubicaciones seleccionadas pertenece a este rol.',
    'picked-path': 'Eligieron {path}',
    'completed-capstone-course': 'Completaron el Curso {path}',
    'one-of-n-mandatory': '1 de {n} es obligatorio',
  },
  // JTC entries stay in upper case, matching the source payroll job title codes
  // the way the Spanish block does.
  fr: {
    // Legacy camelCase keys
    employee: 'Employé',
    roster: 'Effectif',
    payroll: 'Paie',
    employeeRoster: 'Effectif du personnel',
    employeeRosterAnalysis: 'Analyse de l’effectif du personnel',
    rosterStatistics: 'Statistiques d’effectif',
    noPunchesOnly: 'Sans pointage uniquement',
    copyEmails: 'Copier les e-mails',
    forOutlook: 'Pour Outlook',
    minorAdult: 'Mineur/majeur',
    highlightedRowsDenoteMinors:
      'Les lignes surlignées correspondent à des mineurs',
    adult: 'Majeur',
    minor: 'Mineur',
    primaryHourlyPayRate: 'Taux horaire principal',
    primaryJobTitleCode: 'Code de poste principal',
    primaryJobTitleCodeDescription: 'Description du code de poste principal',
    contact: 'Contact',
    birthday: 'Anniversaire',
    anniversary: 'Anniversaire d’ancienneté',
    reviewDue: 'Entretien à venir',
    signature: 'Signature',
    crewStaffSize: 'Équipiers (effectif)',
    shiftStaffSize: 'Responsables de poste (effectif)',
    rosterSize: 'Taille de l’effectif',
    rosterActive: 'Effectif actif',

    // People Dashboard
    overview: 'Vue d’ensemble',
    shift: 'Poste',
    'turnover-trend': 'Tendance de la rotation',
    'roster-statistics': 'Statistiques d’effectif',
    attendance: 'Assiduité',
    staffing: 'Effectifs',
    'on-time-rating': 'Taux de ponctualité',
    'crew-turnover': 'Rotation des équipiers',
    'shift-turnover': 'Rotation des responsables de poste',

    // Overview Subwidget - Attendance
    'attendance-rating': 'Taux d’assiduité',
    'monthly-average-restaurant-shifts-worked':
      'Moyenne mensuelle du restaurant : % de postes travaillés',
    'jtc-crew-and-swing': 'JTC : équipiers et polyvalents',
    'green-attendance': 'Vert : 90 % ou plus',
    'yellow-attendance': 'Jaune : de 80 % à moins de 90 %',
    'red-attendance': 'Rouge : moins de 80 %',
    'please-select-a-previous-month-to-view-attendance-rating':
      'Veuillez sélectionner un mois antérieur pour consulter le taux d’assiduité.',
    'rest-avg': 'Moy. restaurant',
    'total-shifts': 'Total des postes',
    'missed-shifts': 'Postes manqués',

    // Overview Subwidget - Shift
    'actual-hours-as-of-needed-for-month-needed':
      'Heures réelles en % des heures requises pour le mois. Requis = Variable requis + Encadrement requis + Fixe planifié',
    'green-shift': 'Vert : 95 %-105 %',
    'yellow-shift': 'Jaune : 85-95 % ou 105-115 %',
    'red-shift': 'Rouge : moins de 85 % ou plus de 115 %',
    'scheduled-hours-as-of-guide-for-month':
      'Heures planifiées en % du guide pour le mois',
    'actual-hours-as-of-scheduled-for-month':
      'Heures réelles en % des heures planifiées pour le mois',
    'avg-hrs-r-d': 'Moy. h/R/J',
    'act-vs-req': 'Réel vs requis',
    'act-vs-sch': 'Réel vs planifié',
    'sch-vs-guide': 'Planifié vs guide',
    last: 'Précédent',
    month: 'Mois',
    current: 'En cours',
    required: 'Requis',
    'required-hours': 'Requis',
    scheduled: 'Planifié',

    // Overview Subwidget - Roster
    'average-restaurant-active-paid-during-month':
      'Moyenne du restaurant : % actifs (payés) durant le mois',
    'average-restaurant-active-during-month':
      'Moyenne du restaurant : % actifs durant le mois',
    'green-roster': 'Vert : 95 % ou plus',
    'yellow-roster': 'Jaune : de 90 % à moins de 95 %',
    'red-roster': 'Rouge : moins de 90 %',
    active: 'Actif',
    termed: 'Sorti des effectifs',
    inactive: 'Inactif',
    'employee-location': 'Site de l’employé',
    home: 'Site principal',
    shared: 'Partagé',
    'termination-year': 'Année de départ',
    'term-year': 'Année départ',
    total: 'Total',
    crew: 'Équipiers',
    manager: 'Manager',
    'past-due-date': 'Date d’échéance dépassée',
    'overall-trained': 'Formation globale',
    'path-not-completed': 'Parcours {path} non terminé',
    'employees-label': 'employés',
    'crew-trainer-role': 'Formateur équipiers',
    'awaiting-verification': 'En attente de vérification',
    'crew-trainer-training-not-completed':
      'Formation de formateur équipiers non terminée',
    'overall-trained-in-compliance': 'Formation globale en conformité',
    'overall-trained-in-path': 'Formation globale en {path}',
    'overall-trained-crew-trainer':
      'Formation globale de formateur équipiers terminée',

    // Training report filters / labels
    role: 'Rôle',
    path: 'Parcours',
    all: 'Tous',
    'past-due': 'En retard',
    'due-soon': 'Échéance proche',
    'new-hires': 'Nouvelles embauches',
    'awaiting-eval': 'En attente de votre évaluation',
    foundation: 'Fondamentaux',
    production: 'Production',
    service: 'Service',
    digital: 'Digital',
    employees: 'Employés',
    courses: 'Cours',
    'by-stats': 'Par statistiques',
    'by-courses': 'Par cours',
    'employee-training-report': 'Rapport de formation des employés',
    compliance: 'Conformité',
    'digital-ambassador': 'Ambassadeur digital',
    'shift-leader': 'Responsable de poste',
    'department-leader': 'Responsable de département',

    // Overview Subwidget - OnTime
    'monthly-average-restaurant-of-shifts-on-time':
      'Moyenne mensuelle du restaurant : % de postes commencés à l’heure',
    'punch-threshold': 'Seuil de pointage : 3 min',
    'green-ontime': 'Vert : 85 % ou plus',
    'yellow-ontime': 'Jaune : de 70 % à moins de 85 %',
    'red-ontime': 'Rouge : moins de 70 %',
    'please-select-a-previous-month-to-view-on-time-rating':
      'Veuillez sélectionner un mois antérieur pour consulter le taux de ponctualité.',
    'on-time': 'À l’heure',

    // Overview Subwidget - Turnover
    'crew-monthly-annualized-turnover':
      '% de rotation mensuelle annualisée des équipiers',
    'green-turnover': 'Vert : moins de 130 %',
    'yellow-turnover': 'Jaune : de 130 % à 200 %',
    'red-turnover': 'Rouge : plus de 200 %',
    hires: 'Embauches',
    terminations: 'Départs',

    // Overview Subwidget - Retention (Shift Turnover)
    'monthly-annualized-shift-turnover':
      '% de rotation mensuelle annualisée des responsables de poste',
    'green-below-50': 'Vert : moins de 50 %',
    'yellow-50-to-100': 'Jaune : de 50 % à 100 %',
    'red-above-100': 'Rouge : plus de 100 %',

    // Turnover Trend Widget
    'shift-managers': 'Responsables de poste',
    'monthly-annual-turnover': 'Rotation mensuelle annualisée',
    'monthly-ann': 'Mens. ann.',
    'ttm-turnover': 'Rotation TTM',
    ttm: 'TTM',
    'ytd-turnover': 'Rotation cumulée annuelle',
    ytd: 'CAJ',
    '3mo': '3 mois',
    '3mo-turnover': 'Rotation sur 3 mois',
    'tooltip-turnover':
      'Les données de rotation exigent une plage de dates couvrant un mois complet',

    // Shift Widget (dashboard)
    'by-store': 'Par restaurant',
    'act-hrs-vs-need': 'H. réelles vs requises',
    'sch-hrs-vs-guide': 'H. planifiées vs guide',
    'act-hrs-vs-sch': 'H. réelles vs planifiées',

    // Roster Statistics Widget
    'roster-active': 'Effectif actif',
    'number-of-non-terminated-employees':
      'Nombre d’employés non sortis des effectifs ayant pointé durant la période sélectionnée',
    'roster-inactive': 'Effectif inactif',

    // Attendance Widget (dashboard grid)
    'punch-in-on-time': 'Pointage entrée à l’heure',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-within':
      'Nombre de postes de la période où l’employé a pointé à l’entrée dans le seuil imparti (avant ou après l’heure planifiée)',
    'punch-in-late': 'Pointage entrée en retard',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-after':
      'Nombre de postes de la période où l’employé a pointé à l’entrée après le seuil',
    'punch-in-early': 'Pointage entrée en avance',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-before':
      'Nombre de postes de la période où l’employé a pointé à l’entrée avant le seuil',
    'punch-out-on-time': 'Pointage sortie à l’heure',
    'number-of-scheduled-shifts-where-the-employee-punched-out-within-the-threshold':
      'Nombre de postes planifiés où l’employé a pointé à la sortie dans le seuil imparti',
    'number-of-shifts-where-an-employee-was-on-time-divided-by-total':
      'Nombre de postes où l’employé était à l’heure, divisé par le total des postes planifiés sur la période sélectionnée',
    'number-of-scheduled-shifts-an-employee-had-punches-for':
      'Nombre de postes planifiés pour lesquels l’employé a pointé, divisé par le nombre total de postes planifiés',
    'punch-out-late': 'Pointage sortie en retard',
    'number-of-scheduled-shifts-where-the-employee-punched-out-later':
      'Nombre de postes planifiés où l’employé a pointé à la sortie après le seuil',
    'punch-out-early': 'Pointage sortie en avance',
    'number-of-scheduled-shifts-where-the-employee-punched-out-earlier':
      'Nombre de postes planifiés où l’employé a pointé à la sortie avant le seuil',
    'worked-not-sched': 'Travaillé, non planifié',
    'number-of-days-where-an-employee-worked-but-was-not-scheduled':
      'Nombre de jours où l’employé a travaillé sans être planifié sur la période sélectionnée',
    'missed-shift': 'Poste manqué',
    'number-of-missed-shifts-for-the-employee-in-the-selected-period':
      'Nombre de postes manqués par l’employé sur la période sélectionnée',
    'days-on-sched': 'Jours planifiés',
    'crew-swing': 'Équipiers / polyvalents',

    // Employee Roster
    'custom-date-range': 'Plage de dates personnalisée',
    'employee-roster': 'Effectif du personnel',
    'employee-roster-analysis': 'Analyse de l’effectif du personnel',
    'no-punches-only': 'Sans pointage uniquement',
    search: 'Rechercher',
    'copy-emails': 'Copier les e-mails',
    'for-outlook': 'Pour Outlook',
    'minor-adult': 'Mineur/majeur',
    'highlighted-rows-denote-minors':
      'Les lignes surlignées correspondent à des mineurs',
    'primary-hourly-pay-rate': 'Taux horaire principal',
    'employees-primary-hourly-pay-rate':
      'Taux horaire principal de l’employé - peut être nul ou vide (S.O.) pour les employés salariés',
    'primary-job-title-code': 'Code de poste principal',
    'mcdonalds-primary-job-title-code': 'Code de poste principal McDonald’s',
    'primary-job-title-code-description':
      'Description du code de poste principal',
    'mcdonalds-primary-job-title-code-description':
      'Description du code de poste principal McDonald’s',
    purpose: 'Objet',
    'signature-line': 'Ligne de signature',
    'date-signed': 'Date de signature',
    'review-due': 'Entretien à venir',

    // Roster Statistics (full page)
    'crew-staff-size': 'Équipiers (effectif)',
    'total-number-of-hourly-crew':
      'Nombre total d’équipiers horaires présents dans l’effectif pour le mois sélectionné',
    'shift-staff-size': 'Responsables de poste (effectif)',
    'total-number-of-swing-managers-or-floor-supervisors':
      'Nombre total de managers polyvalents ou de superviseurs de salle dont le statut est « Actif »',
    'gm-dm-crew-staff-size': 'DR et DD (effectif)',
    'number-of-total-active-general-managers-and-department-managers':
      'Nombre total de directeurs de restaurant et de directeurs de département actifs',
    'crew-active': 'Équipiers actifs',
    'number-of-crew-who-had-punched-hours-in-the-selected-month':
      'Nombre d’équipiers ayant pointé des heures durant le mois sélectionné',
    'shift-active': 'Responsables de poste actifs',
    'number-of-swing-managers-or-floor-supervisors':
      'Nombre de managers polyvalents ou de superviseurs de salle au statut « Actif » ayant pointé au cours du mois le plus récent',
    'number-of-swing-managers-or-floor-supervisors-active':
      'Nombre de managers polyvalents ou de superviseurs de salle au statut « Actif » ayant pointé au cours du mois le plus récent',
    'under-18-staff-size': 'Moins de 18 ans (effectif)',
    'number-of-staff-whose-age-is-below-18-years-old':
      'Nombre de collaborateurs âgés de moins de 18 ans',
    'under-17-staff-size': 'Moins de 17 ans (effectif)',
    'number-of-staff-whose-age-is-below-17-years-old':
      'Nombre de collaborateurs âgés de moins de 17 ans',
    'under-16-staff-size': 'Moins de 16 ans (effectif)',
    'number-of-staff-whose-age-is-below-16-years-old':
      'Nombre de collaborateurs âgés de moins de 16 ans',
    'roster-size': 'Taille de l’effectif',
    'total-number-of-people-whose-status-is-active':
      'Nombre total de personnes dont le statut est « Actif »',
    'number-of-non-terminated-employees-who-had-punches':
      'Nombre d’employés non sortis des effectifs ayant pointé durant la période sélectionnée',
    'number-crew-inactive': 'Nb équipiers inactifs',
    'crew-who-were-on-the-roster-not-termed-in-the-selected-month':
      'Équipiers présents dans l’effectif (non sortis) durant le mois sélectionné mais n’ayant pointé aucune heure',
    'number-of-swing-managers-or-floor-supervisors-inactive':
      'Nombre de managers polyvalents ou de superviseurs de salle au statut « Actif » n’ayant pas pointé au cours du mois le plus récent',
    'crew-who-were-on-the-roster-not-termed':
      'Équipiers présents dans l’effectif (non sortis) durant le mois sélectionné mais n’ayant pointé aucune heure',
    'number-shift-inactive': 'Nb responsables de poste inactifs',
    'number-of-people-who-have-active-status':
      'Nombre de personnes au statut « Actif » n’ayant pas pointé au cours du mois le plus récent',
    'crew-active-pct': '% équipiers actifs',
    'crew-active-divided-by-total-crew':
      'Équipiers actifs divisés par le total des équipiers',
    'shift-active-pct': '% responsables de poste actifs',
    'shift-active-divided-by-shift-staff-size':
      'Responsables de poste actifs divisés par l’effectif des responsables de poste. Pourcentage de managers polyvalents ou de superviseurs de salle au statut « Actif » ayant pointé le mois dernier',
    'under-18-pct': '% moins de 18 ans',
    'under-18-staff-size-divided-by-total-staff':
      'Effectif des moins de 18 ans divisé par l’effectif total',
    'under-17-pct': '% moins de 17 ans',
    'under-17-staff-size-divided-by-total-staff':
      'Effectif des moins de 17 ans divisé par l’effectif total',
    'under-16-pct': '% moins de 16 ans',
    'under-16-staff-size-divided-by-total-staff':
      'Effectif des moins de 16 ans divisé par l’effectif total',
    'roster-active-pct': '% effectif actif',
    'roster-active-divided-by-total-staff':
      'Effectif actif divisé par l’effectif total',

    // Employee Roster Bottom Sheet
    error_loadingReport:
      'Une erreur s’est produite lors du chargement du rapport.',
    employee_roster: 'Effectif du personnel pour le site',

    // Birthdays/Anniversaries
    birthdays: 'Anniversaires',
    anniversaries: 'Anniversaires d’ancienneté',
    'todays-birthdays': 'Anniversaires du jour',
    'current-months-birthdays': 'Anniversaires du mois en cours',
    'next-months-birthdays': 'Anniversaires du mois prochain',
    loc: 'Site',
    'employee-name': 'Nom de l’employé',
    location: 'Site',
    todays: 'Du jour',
    'current-months': 'Du mois en cours',
    'next-months': 'Du mois prochain',

    // Store Time Punches
    'back-to-employee-time-punches': 'Retour aux pointages des employés',
    'store-time-punches': 'Pointages du restaurant',
    'by-employee': 'Par employé',
    'day-of-week': 'Jour de la semaine',
    'payroll-id': 'ID paie',
    custom: 'Personnalisé',

    // Punch Extract
    back_to_employee_time_punches: 'Retour aux pointages des employés',
    time_punch_export: 'Export des pointages',

    // Labor Exceptions
    'missing-pii-permissions-message':
      'Vous ne disposez pas des autorisations requises sur les informations personnelles identifiables (PII) pour planifier ce rapport : Accès aux noms complets et Accès à l’adresse, l’e-mail, la date de naissance et l’origine nationale. Veuillez contacter le support si vous pensez qu’il s’agit d’une erreur.',
    'report-title-exception': 'Par exception',
    'report-title-summary-exceptions': 'Synthèse par exception',
    'report-title-summary-location': 'Synthèse par site',
    'adult-exceptions-header': 'Exceptions standard',
    'minor-exceptions-header': 'Exceptions mineurs',
    'exceptions-header': 'Total des exceptions',
    'adult-exceptions-description':
      'Exceptions concernant tout employé non mineur',
    'minor-exceptions-description':
      'Exceptions concernant tout employé mineur, qu’une règle standard ou une règle propre aux mineurs ait été enfreinte',
    'exceptions-description': 'Nombre total d’exceptions pour un employé',
    'breach-type-header': 'Exception',
    'breach-type-description':
      'Règle du logiciel de gestion du personnel qui a été enfreinte',
    'highlighted-rows-explanation':
      'Les lignes surlignées signalent des pointages modifiés',
    'labor-date-header': 'Date de travail',
    'employee-full-name-header': 'Employé',
    'employee-full-name-description': 'Nom de l’employé',
    'first-name-header': 'Prénom',
    'first-name-description': 'Prénom de l’employé',
    'last-name': 'Nom de famille',
    age: 'Âge',
    'actual-shift-start-time-header': 'Début réel',
    'actual-shift-start-time-description': 'Heure de début réelle de ce poste',
    'actual-shift-end-time-header': 'Fin réelle',
    'actual-shift-end-time-description': 'Heure de fin réelle de ce poste',
    'schedule-shift-start-time-header': 'Début planifié',
    'schedule-shift-start-time-description':
      'Heure de début planifiée de ce poste',
    'schedule-shift-end-time-header': 'Fin planifiée',
    'schedule-shift-end-time-description': 'Heure de fin planifiée de ce poste',
    'actual-shift-length-header': 'Durée réelle du poste',
    'actual-shift-length-description': 'Durée réelle du poste',
    'date-time-of-exception-header': 'Heure de l’exception',
    'date-time-of-exception-description':
      'Heure à laquelle l’exception est survenue',
    'is-manager-authorized-header': 'Autorisé par un manager',
    'is-manager-authorized-description':
      'Cette exception a-t-elle été autorisée par un manager ?',
    'manager-name-header': 'Manager',
    'manager-name-description': 'Nom du manager',
    punches: 'Pointages',
    'error-loading-report':
      'Une erreur s’est produite lors du chargement du rapport',
    'punch-type': 'Type de pointage',
    'is-overnight-shift': 'Poste de nuit',
    'is-overnight-shift-desc':
      '« O » si le pointage était le pointage de fin de 4 h 00 ou de début de 4 h 00 d’un poste à cheval sur deux journées de travail, sinon « N »',
    'is-paid-break': 'Pause payée',
    'is-paid-break-desc':
      '« O » si le pointage correspond au début ou à la fin d’une pause payée, sinon « N »',
    'in-time': 'Heure d’entrée',
    'out-time': 'Heure de sortie',

    // Time and Attendance (mcd)
    'time-and-attendance': 'Temps et présence',
    'time-and-attendance-analysis': 'Analyse des temps et présences',
    'first-name': 'Prénom',
    'employee-first-name': 'Prénom de l’employé',
    'employee-last-name': 'Nom de famille de l’employé',
    'job-title-code': 'Code de poste',
    'mcdonalds-job-title-code': 'Code de poste McDonald’s',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-within-the-threshold':
      'Nombre de postes de la période où l’employé a pointé à l’entrée dans le seuil imparti (avant ou après l’heure planifiée)',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-after-the-threshold':
      'Nombre de postes de la période où l’employé a pointé à l’entrée après le seuil',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-before-the-threshold':
      'Nombre de postes de la période où l’employé a pointé à l’entrée avant le seuil',
    'number-of-shifts-where-an-employee-was-on-time-divided-by-total-shifts-scheduled-in-the-selected-period':
      'Nombre de postes où l’employé était à l’heure, divisé par le total des postes planifiés sur la période sélectionnée',
    'number-of-scheduled-shifts-an-employee-had-punches-for-divided-by-total-number-of-scheduled-shifts':
      'Nombre de postes planifiés pour lesquels l’employé a pointé, divisé par le nombre total de postes planifiés',
    'number-of-scheduled-shifts-where-the-employee-punched-out-later-than-the-threshold':
      'Nombre de postes planifiés où l’employé a pointé à la sortie après le seuil',
    'number-of-scheduled-shifts-where-the-employee-punched-out-earlier-than-the-threshold':
      'Nombre de postes planifiés où l’employé a pointé à la sortie avant le seuil',
    'number-of-days-where-an-employee-worked-but-was-not-scheduled-in-the-selected-period':
      'Nombre de jours où l’employé a travaillé sans être planifié sur la période sélectionnée',
    'mcdonalds-global-employee-identifier':
      'Identifiant global d’employé McDonald’s',
    'sched-start-time': 'Heure de début planifiée',
    'sched-end-time': 'Heure de fin planifiée',
    'punch-start-time': 'Heure de pointage entrée',
    'punch-end-time': 'Heure de pointage sortie',
    'punch-early-late-min-threshold': 'Seuil min. avance/retard de pointage',
    schedule: 'Planning',
    'at-store': 'Au restaurant',

    // Turnover Report + JTC Definitions
    'january-thru-last-month': 'De janvier au mois dernier',
    'trailing-13-months': '13 derniers mois',
    'premium-upgrade-message-start':
      'Vous souhaitez réduire la rotation du personnel ? ',
    'premium-upgrade-message-link-text': 'Passez à Premium',
    'premium-upgrade-message-end':
      ' pour renforcer l’engagement des employés et améliorer la fidélisation.',
    'jtc-definitions': 'Définitions JTC',
    'jtc-name': 'Nom du JTC',
    'turnover-type': 'Type de rotation',
    'general-manager-w-mgr-punches':
      'DIRECTEUR DE RESTAURANT AVEC POINTAGES MANAGER',
    'general-manager-w-crew-punches':
      'DIRECTEUR DE RESTAURANT AVEC POINTAGES ÉQUIPIER',
    'general-manager': 'DIRECTEUR DE RESTAURANT',
    'store-mgr-trainee-f': 'MANAGER DE RESTAURANT STAGIAIRE-F',
    'floor-supervisor': 'SUPERVISEUR DE SALLE',
    swing: 'Polyvalent',
    'cert-swing-mgr': 'MANAGER POLYVALENT CERTIFIÉ',
    'crew-trainer': 'FORMATEUR ÉQUIPIERS',
    'crew-person': 'ÉQUIPIER',
    'manager-oje': 'MANAGER OJE',
    'security-guard': 'AGENT DE SÉCURITÉ',
    'backup-maintenance-person': 'AGENT DE MAINTENANCE SUPPLÉANT',
    'primary-maintenance-person': 'AGENT DE MAINTENANCE PRINCIPAL',
    'intern-f': 'STAGIAIRE-F',
    'administrative-assistant': 'ASSISTANT ADMINISTRATIF',
    'shift-manager-trainee': 'RESPONSABLE DE POSTE STAGIAIRE',
    'otp-pro-hourly': 'OTP PRO HORAIRE',
    'otp-pro-salary': 'OTP PRO SALARIÉ',
    'department-manager-i': 'DIRECTEUR DE DÉPARTEMENT i',
    'department-manager-ii': 'DIRECTEUR DE DÉPARTEMENT ii',
    'department-manager-iii': 'DIRECTEUR DE DÉPARTEMENT iii',
    'area-manager-grill-ca': 'RESPONSABLE DE ZONE - GRILL (CA)',
    'guam-inventory-employee': 'EMPLOYÉ INVENTAIRE GUAM',
    'intern-so-cal-region': 'STAGIAIRE - RÉGION SO CAL',
    'profit-center-admin-assist': 'ASSISTANT ADMIN. CENTRE DE PROFIT',
    'lsm-coordinator': 'COORDINATEUR LSM',
    'intern-gsw': 'STAGIAIRE GSW',
    'dept-mgr-w-i-crew-punches': 'DIR. DÉPARTEMENT AVEC POINTAGES ÉQUIPIER i',
    'dept-mgr-w-ii-crew-punches': 'DIR. DÉPARTEMENT AVEC POINTAGES ÉQUIPIER ii',
    'dept-mgr-w-iii-crew-punches':
      'DIR. DÉPARTEMENT AVEC POINTAGES ÉQUIPIER iii',

    // Turnover Grid
    turnover: 'Rotation du personnel',
    'number-of-employees-hired-in-the-period':
      'Nombre d’employés embauchés sur la période',
    'roster-size-description':
      'Nombre d’employés du groupe sélectionné actifs dans l’effectif',
    terms: 'Départs',
    'number-of-employees-whose-job-ended':
      'Nombre d’employés dont le contrat a pris fin',
    'terms-less-than-90': 'Départs < 90',
    'terms-less-than-90-description':
      'Pour le mois, nombre de nouvelles embauches ayant quitté l’entreprise avant d’atteindre 90 jours d’ancienneté. Ce chiffre n’est définitif que 90 jours après la fin du mois (janvier ne sera définitif que le 1er mai, février le 1er juin, etc.)',
    'retained-greater-than-90': 'Conservés > 90',
    'number-of-employees-who-remained-employed-at-the-restaurant-more-than-90-days':
      'Nombre d’employés restés en poste au restaurant plus de 90 jours',
    'terms-less-than-90-pct': '% départs < 90',
    'terms-less-than-90-pct-description':
      'Départs < 90 divisés par les embauches du mois. Ce chiffre n’est définitif que 90 jours après la fin du mois (janvier ne sera définitif que le 1er mai, février le 1er juin, etc.)',
    'retained-greater-than-90-pct': '% conservés > 90',
    'retained-greater-than-90-divided-by-number-of-employees-hired-in-the-month':
      'Conservés > 90 divisés par le nombre d’employés embauchés dans le mois',
    'monthly-turnover-multiplied-by-12-to-annualized-it':
      'Rotation mensuelle multipliée par 12 pour l’annualiser',
    'ttm-turnover-description':
      'Rotation sur les douze derniers mois. Total des départs des 12 derniers mois divisé par la taille de l’effectif à la fin du mois le plus récent',
    'ytd-turnover-description':
      'Rotation cumulée depuis le début de l’année. Total des départs de l’année en cours divisé par la taille de l’effectif à la fin du mois le plus récent',
    'three-month-turnover': 'Rotation sur 3 mois',
    '3-month-turnover-description':
      'La rotation sur 3 mois porte sur la période de 3 mois la plus récente pour laquelle on peut savoir si les nouvelles embauches ont atteint 90 jours. {link}',
    'details-link-text': 'Les détails sont ici',
    'three-month-terms': 'Départs sur 3 mois',
    '3-month-terms-description':
      'Nombre de personnes ayant quitté l’entreprise sur la période de 3 mois',
    'three-month-retained': 'Conservés sur 3 mois',
    '3-month-retained-description':
      'Nombre de personnes conservées sur la période de 3 mois',
    'new-hire-retention': 'Fidélisation des nouvelles embauches',
    'employees-in-red-were-terminated-prior-to-working-90-days':
      'Les employés en rouge sont partis avant d’avoir travaillé 90 jours',

    // Emp Hours This Week
    'filter-results': 'Filtrer les résultats',
    'emp-hours-this-week': 'Heures employés cette semaine',

    // Shift report
    'shift-report': 'Rapport de poste',
    'actual-gc': 'GC réel',
    'actual-gc-recorded-by-the-pos': 'GC réel enregistré par la caisse',
    'projected-gc': 'GC prévu',
    'actual-gc-vs-proj': 'GC réel vs prévu',
    'actual-gc-minus-gc-that-were-projected-in-the-scheduling-software':
      'GC réel moins le GC prévu dans le logiciel de planification',
    'proj-eff': 'Efficacité prév.',
    'number-of-hours-where-actual-gc-was-within-10':
      'Nombre d’heures où le GC réel se situait à moins de 10 du GC prévu, divisé par le nombre total d’heures d’ouverture du restaurant',
    'total-act-hrs': 'Total h. réelles',
    'var-actual-hrs': 'H. réelles variables',
    'act-punch-hrs': 'H. pointées réelles',
    'actual-hours-punched-on-the-timeclock':
      'Heures réellement pointées sur la pointeuse',
    'salaried-manager-hrs': 'H. managers salariés',
    'since-salaried-managers-do-not':
      'Les managers salariés ne pointant pas, ce sont les heures planifiées des managers salariés qui sont utilisées (on considère que toutes les heures planifiées des salariés sont travaillées)',
    'total-need-hrs': 'Total h. requises',
    'total-hours-needed-hours-variable-hours-needed':
      'Total des heures requises - Heures variables requises plus heures d’encadrement requises + heures fixes planifiées',
    'var-need-hrs': 'H. variables requises',
    'flr-need-hrs': 'H. encadrement requises',
    'manager-hours-needed-to-run-the-floor':
      'Heures de manager nécessaires pour piloter la salle',
    'total-sch-hrs': 'Total h. planifiées',
    'var-sch-hrs': 'H. variables planifiées',
    'flr-sch-hrs': 'H. encadrement planifiées',
    'manager-hours-scheduled-to-run-the-floor':
      'Heures de manager planifiées pour piloter la salle',
    'fixed-sch-hrs': 'H. fixes planifiées',
    'scheduled-hours-for-schedule-symbols-that-are-fixed':
      'Heures planifiées pour les symboles de planning « fixes » (indépendants du volume de ventes)',
    'total-guide': 'Guide total',
    'fixed-guide': 'Guide heures fixes',
    'hours-in-the-fixed-hours-guide':
      'Heures inscrites au guide des heures fixes (également appelé contrat) pour un symbole de planning donné',
    'var-guide': 'Guide variable',
    'flr-guide': 'Guide encadrement',
    'floor-hours-needed-based-on-gc-volume':
      'Heures d’encadrement requises en fonction du volume de GC',
    'act-vs-need-percentage': '% réel vs requis',
    'sch-vs-guide-percentage': '% planifié vs guide',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Heures réellement utilisées comparées aux heures planifiées',
    'act-vs-sch-percentage': '% réel vs planifié',
    'sch-flr-vs-guide': 'Encadrement planifié vs guide',
    'var-act-vs-need': 'Variable réel vs requis',
    'actual-variable-hours-used-compared-to-variable-hours-needed':
      'Heures variables réellement utilisées comparées aux heures variables requises selon le guide VLH',
    'fixed-sch-vs-guide': 'Fixe planifié vs guide',
    'var-sch-vs-guide': 'Variable planifié vs guide',

    // Labor Schedules
    labor_schedules: 'Plannings du personnel',

    // Rewards
    'by-employee-title': 'Par employé',
    'by-store-title': 'Par restaurant',
    'auto-rewards': 'Récompenses automatiques',
    'rewards-by-store': 'Récompenses par restaurant',
    'rewards-by-employee': 'Récompenses par employé',
    transfers: 'Transferts',
    purchase: 'Achat',
    refund: 'Remboursement',
    manual: 'Manuel',
    auto: 'Auto',
    pts: 'Pts',
    qty: 'Qté',
    'employee-name-description': 'Nom de l’employé',
    'by-date': 'Par date',
    'sum-all-dates': 'Cumul',
    geid: 'GEID',
    '3-month-turnover': 'Rotation sur 3 mois',
    '3-month-terms': 'Départs sur 3 mois',
    '3-month-retained': 'Conservés sur 3 mois',
    category: 'Catégorie',
    value: 'Valeur',
    'retained-90-divided-by-number-of-employees-hired-in-the-month':
      'Conservés > 90 divisés par le nombre d’employés embauchés dans le mois',
    primary: 'Principal',
    secondary: 'Secondaire',
    // Training Report — Shift Leader
    'shift-leader-foundations': 'Fondamentaux du responsable de poste',
    'sl-shift-leader': 'Responsable de poste',
    'sl-advancing-tooltip':
      'Advancing Leadership est un parcours secondaire accessible uniquement après avoir terminé Leadership Foundations',
    'sl-location': 'Site',
    'sl-role': 'Rôle',
    'sl-path': 'Parcours',
    'sl-employee': 'Employé',
    'sl-jtc-start-date': 'Date de début du JTC',
    'sl-due-date': 'Date d’échéance',
    'sl-avg-days': 'Nombre moyen de jours pour terminer',
    'sl-all': 'Tous',
    'sl-past-due': 'En retard',
    'dl-dlim': 'DLIM',
    'dl-completed-dlim': 'Cours DLIM terminé (1 sur 2)',
    'dl-dlim-subtitle': '1 sur 2 est obligatoire',
    download: 'Télécharger',
    'sl-past-due-hint':
      "En retard : non terminé et la date d'échéance est passée depuis {n} jours",
    'sl-due-soon-hint': 'Bientôt dû : à terminer dans {n} jours',
    'sl-past-due-group-hint':
      "En retard : {n} cours obligatoire(s) de ce groupe non terminé(s) à la date d'échéance",
    'sl-due-soon-group-hint':
      'Bientôt dû : {n} cours obligatoire(s) de ce groupe à terminer dans les prochains jours',
    'sl-due-soon': 'Échéance proche',
    'sl-not-started': 'Non commencé',
    'sl-in-progress': 'En cours',
    'sl-completed': 'Terminé',
    'sl-na': 's.o.',
    'sl-badge-start-overdue': 'Démarrage en retard - 14',
    'sl-badge-start-due': 'Démarrage à échéance - 14',
    'sl-employees': 'employés',
    'sl-card-past-due': 'Date d’échéance dépassée',
    'sl-card-due-soon': 'Échéance proche',
    'past-due-date-training': 'Formation en retard',
    'due-soon-training': 'Formation à échéance proche',
    'sl-card-not-trained': 'Non formé sur ce parcours',
    'crew-pct-past-due': '{pct} En retard',
    'crew-pct-crew-trainer-not-completed':
      '{pct} Formation de formateur équipiers non terminée',
    'crew-pct-due-soon': '{pct} Bientôt dû',
    'sl-pct-not-trained': '{pct} Non formé sur ce parcours',
    'sl-col-past-due': 'Nb en retard',
    'sl-col-due-soon': 'Nb à échéance proche',
    'sl-first-course-col': 'Premier cours (14 jours)',
    'sl-training-status': 'Statut de la formation',
    'sl-see-all': 'TOUT VOIR',
    'sl-close': 'Fermer',
    'sl-due-header-tooltip':
      'Le premier cours du parcours doit être suivi au plus tard 14 jours après la date d’effet du JTC. L’ensemble du parcours doit être terminé au plus tard 9 mois après la date d’effet du JTC.',
    'sl-tip-first-overdue':
      'Premier cours non commencé dans les 14 jours suivant le JTC (échéance {date}).',
    'sl-tip-first-due':
      'Le premier cours doit être commencé dans les 14 jours suivant le JTC (échéance {date}).',
    'sl-tip-count-past-due':
      '{n} cours ayant dépassé l’échéance de 9 mois du parcours (échéance {date}).',
    'sl-tip-count-due-soon':
      '{n} cours arrivant à échéance avant le délai de 9 mois du parcours (échéance {date}).',
    'hire-date': 'Date d’embauche',
    'completion-date': 'Date d’achèvement',
    'course-name': 'Nom du cours',
    'employee-training-details': 'Détails de formation de l’employé',
    'overall-progress': 'Progression globale {pct} %',
    'employees-none-for-status': 'Aucun employé avec ce statut',
    'employees-load-failed':
      'Impossible de charger les employés. Modifiez un filtre pour réessayer.',
    'employees-removed-for-status':
      '{n} employé(s) sélectionné(s) retiré(s) : statut différent',
    'mapping-title': 'Cartographie de la formation',
    'mapping-courses-filters': 'Cours',
    'mapping-completions': 'Réussites',
    'mapping-completions-any': 'Toutes',
    'mapping-completions-none': 'Aucune',
    'mapping-completions-some': 'Quelques-unes',
    'mapping-hide-retired': 'Masquer les retirés',
    'mapping-unmapped-ids-caption':
      'Réussites sans cours. Non concernées par les filtres de cours ci-dessus.',
    'mapping-group-assigned': 'Dans un parcours',
    'mapping-n-of-m-courses': '{n} sur {m}',
    'mapping-path-reordered': 'Ordre des parcours enregistré',
    'mapping-show': 'Afficher',
    'mapping-hide': 'Masquer',
    'mapping-applies-to-line': 'S’applique à',
    'mapping-reorder-hint': 'Glissez pour réordonner',
    'mapping-required-paths': 'Parcours requis',
    'mapping-course-library': 'Bibliothèque de cours',
    'mapping-search-courses': 'Rechercher par nom ou identifiant Campus',
    'mapping-library-hint':
      'Glissez un cours sur un parcours pour l’ajouter, ou d’un parcours à l’autre pour le déplacer. Utilisez le x d’un cours pour le retirer du parcours.',
    'mapping-group-unassigned': 'Dans aucun parcours',
    'mapping-unmapped-ids':
      'Identifiants Campus avec des réussites mais sans cours',
    'mapping-unmapped-ids-hint':
      'Des employés des emplacements sélectionnés ont terminé ces identifiants de cours Campus, mais aucun cours ne les couvre. Créez un cours à partir de l’un d’eux pour le cartographier.',
    'mapping-no-courses': 'Aucun cours',
    'mapping-drop-course-here': 'Déposez un cours ici',
    'mapping-n-completed': '{n} terminés',
    'mapping-zero-completed': '0 terminé',
    'mapping-last-completed': 'dernier {date}',
    'mapping-create-course-from-id': 'Créer un cours pour {id}',
    'mapping-course-moved': 'Ordre des cours enregistré',
    'mapping-path-regrouped': 'Exigence du parcours mise à jour',
    'mapping-n-paths-no-courses': '{n} parcours n’ont aucun cours',
    'mapping-n-unassigned-courses': '{n} cours ne sont dans aucun parcours',
    'mapping-n-unassigned-with-completions':
      '{n} d’entre eux ont des réussites',
    'mapping-add-jtc': 'Ajouter un JTC',
    'mapping-jtc-code': 'Code JTC',
    'mapping-jtc-invalid': 'Entrez le JTC sous forme de nombre entier',
    'mapping-remove-jtc': 'Retirer le JTC {jtc}',
    'mapping-new-path': 'Nouveau parcours',
    'mapping-edit-path': 'Modifier le parcours',
    'mapping-require-path': 'Exiger un parcours',
    'mapping-remove-from-role': 'Retirer de ce rôle',
    'mapping-add-course': 'Ajouter un cours',
    'mapping-edit-course': 'Modifier le cours',
    'mapping-remove-from-path': 'Retirer de ce parcours',
    'mapping-existing-course': 'Cours existant',
    'mapping-new-course': 'Nouveau cours',
    'mapping-pick-course': 'Choisir un cours',
    'mapping-no-courses-left': 'Aucun cours à ajouter',
    'mapping-on-no-path': 'dans aucun parcours',
    'mapping-course-name': 'Nom du cours',
    'mapping-path-name': 'Nom du parcours',
    'mapping-campus-ids-hint':
      'Saisissez un identifiant de cours Campus et appuyez sur Entrée',
    'mapping-course-url': 'Lien Campus (https)',
    'mapping-art': 'Visuels',
    'mapping-art-preview-celebration': 'Aperçu de la célébration',
    'mapping-art-celebration-preview': 'Célébration de la clé (en direct)',
    'mapping-art-palette-blobs': 'Taches',
    'mapping-art-palette-rays': 'Rayons',
    'mapping-art-palette-confetti': 'Confettis',
    'mapping-art-palette-default': 'valeurs de l’app',
    'mapping-art-key-palette': 'Palette de la célébration',
    'mapping-art-palette-add': 'Ajouter une couleur',
    'mapping-art-palette-remove': 'Retirer la couleur',
    'mapping-art-missing': '{n} visuel(s) manquant(s)',
    'mapping-art-missing-title':
      'Des visuels obligatoires manquent; l’app équipier affichera les visuels de secours',
    'mapping-art-show': 'Afficher',
    'mapping-art-hide': 'Masquer',
    'mapping-art-none': 'Pas encore de visuels',
    'mapping-art-save-first':
      'Enregistrez d’abord la fiche, puis les visuels pourront être téléversés',
    'mapping-art-upload': 'Téléverser',
    'mapping-art-replace': 'Remplacer',
    'mapping-art-clear': 'Retirer',
    'mapping-art-door-still': 'Porte (fermée)',
    'mapping-art-door-clean': 'Porte, cadrage serré',
    'mapping-art-door': 'Porte',
    'mapping-art-door-rig': 'Style de porte',
    'mapping-default-art': 'Visuels par défaut',
    'mapping-default-art-hint':
      'Ce qu’affiche tout parcours ou cours sans visuel propre, emplacement par emplacement. Un parcours avec un style de porte garde sa porte ; sans style, il affiche celle-ci. S’applique à tous les rôles.',
    'mapping-art-rig-magic': 'Magique',
    'mapping-art-rig-magic-hint':
      'Un panneau pliant avec une serrure lumineuse. Utilisé par Foundation et Beverage Specialist.',
    'mapping-art-rig-hinged': 'À charnières',
    'mapping-art-rig-hinged-hint':
      'Un battant sur levier qui projette des objets en s’ouvrant. Utilisé par Production.',
    'mapping-art-rig-diner': 'Diner',
    'mapping-art-rig-diner-hint':
      'Une porte battante à deux vantaux avec un plateau. Utilisée par Service.',
    'mapping-art-rig-vault': 'Coffre',
    'mapping-art-rig-vault-hint':
      'Une porte ronde de coffre avec des traces holographiques. Utilisée par Digital Ambassador.',
    'mapping-art-rig-locker': 'Casier',
    'mapping-art-rig-locker-hint':
      'Une porte de casier avec des gemmes flottantes et un jaillissement de butin. Utilisée par Compliance.',
    'mapping-art-door-layers': 'Calques',
    'mapping-art-door-layers-hint':
      'Dessinés sur le gabarit du style. La porte ne s’affiche qu’une fois tous les calques téléversés.',
    'mapping-art-door-layer-closed': 'Panneau fermé',
    'mapping-art-door-layer-frame': 'Cadre',
    'mapping-art-door-layer-leaf': 'Battant',
    'mapping-art-door-layer-interior': 'Intérieur',
    'mapping-art-door-layer-lever': 'Levier',
    'mapping-art-door-layer-leafFront': 'Battant, avant',
    'mapping-art-door-layer-leafBack': 'Battant, arrière',
    'mapping-art-door-layer-tray': 'Plateau',
    'mapping-art-door-layer-holo': 'Holo',
    'mapping-art-door-layer-traces': 'Traces',
    'mapping-art-door-layer-plate': 'Plaque',
    'mapping-art-door-layer-faceFront': 'Face, avant',
    'mapping-art-door-layer-faceBack': 'Face, arrière',
    'mapping-art-door-layer-knob': 'Bouton',
    'mapping-art-door-decor-props': 'Objets projetés',
    'mapping-art-door-decor-gems': 'Gemmes flottantes',
    'mapping-art-door-decor-loot': 'Jaillissement de butin',
    'mapping-art-optional': 'facultatif',
    'mapping-art-tuning-scale': 'Échelle',
    'mapping-art-tuning-shiftX': 'Décalage de la porte (px)',
    'mapping-art-tuning-labelShift': 'Décalage de l’étiquette (px)',
    'mapping-art-tuning-opening': 'Polygone de l’ouverture',
    'mapping-art-tuning-keyholeX': 'Serrure x',
    'mapping-art-tuning-keyholeY': 'Serrure y',
    'mapping-art-tuning-edge': 'Dégradé du bord',
    'mapping-art-advanced': 'Avancé',
    'mapping-art-advanced-hint':
      'Utile seulement quand le visuel s’écarte du gabarit du style.',
    'mapping-art-door-preview': 'Aperçu de la porte',
    'mapping-art-door-preview-hint':
      'Dessinée par le même mécanisme que l’app des équipiers, à l’échelle ci-dessus.',
    'mapping-art-door-open': 'Ouvrir',
    'mapping-art-door-close': 'Fermer',
    'mapping-art-door-incomplete':
      'Téléversez tous les calques pour voir la porte',
    'mapping-art-gradient': 'Dégradé de fond',
    'mapping-art-fallback-key': 'Clé de secours',
    'mapping-art-celebration-key': 'Clé de célébration',
    'mapping-art-preview-title': 'Aperçu de la célébration',
    'mapping-art-preview-hint':
      'Appuyez sur lecture pour voir la clé de célébration sur le dégradé avec la palette ci-dessus. L’aperçu redémarre quand une couleur change.',
    'mapping-art-missing-slot': 'Manquant',
    'mapping-art-course-key': 'Clé',
    'mapping-use-groups': 'Groupes par modalité',
    'mapping-item-name': 'Nom de l’étape',
    'mapping-n-steps': '{n} étapes',
    'mapping-edit-group': 'Modifier le groupe',
    'mapping-edit-step': 'Modifier l’étape',
    'mapping-unnamed-step': 'Étape sans nom',
    'mapping-done': 'Terminé',
    'mapping-remove-item': 'Retirer l’étape',
    'mapping-drag-to-reorder': 'Glisser pour réordonner',
    'mapping-group-modality': 'Modalité',
    'mapping-no-modality': 'Sans modalité',
    'mapping-group-required': 'Obligatoire',
    'mapping-optional-group': 'facultatif',
    'mapping-group-item': 'Élément {n}',
    'mapping-group-item-hint': 'Ids Campus de cet élément, un seul suffit',
    'mapping-add-item': 'Ajouter un élément',
    'mapping-add-group': 'Ajouter un groupe',
    'mapping-remove-group': 'Retirer le groupe',
    'mapping-group-rule': 'Tous les éléments du groupe doivent être terminés',
    'mapping-groups-rule':
      'Le cours est terminé dès qu’un groupe obligatoire est terminé. Les groupes facultatifs n’affichent que la progression.',
    'mapping-group-ids-required':
      'Chaque groupe doit avoir au moins un élément avec un id Campus',
    'mapping-retired-flag': 'Retiré',
    'mapping-states-scope':
      'Seulement pour les restaurants de ces États (facultatif)',
    'mapping-translations': 'Traductions',
    'mapping-translation-es': 'Espagnol',
    'mapping-translation-fr': 'Français',
    'mapping-translation-fr-ca': 'Français (Canada)',
    'mapping-due-window': 'Délai d’échéance',
    'mapping-window-days': 'Jours',
    'mapping-applies-each': 'Chaque cours',
    'mapping-applies-first': 'Premier cours seulement',
    'mapping-due-soon-days': 'Bientôt dû, jours avant',
    'mapping-path-deadline-label': 'Échéance de tout le parcours',
    'mapping-deadline-months': 'Mois',
    'mapping-anchor': 'Compté à partir de',
    'mapping-anchor-first-punch-label': 'Premier pointage',
    'mapping-anchor-first-jtc-label': 'Premier début de JTC',
    'mapping-anchor-role': 'Dans le rôle (facultatif)',
    'mapping-due-dates-from-label':
      'Seulement pour les débuts à partir du (AAAA-MM-JJ)',
    'mapping-required': 'Requis',
    'mapping-pick-one-group': 'Groupe « un au choix » (facultatif)',
    'mapping-pick-one-group-hint':
      'Les parcours portant le même nom de groupe sont des alternatives : l’employé en complète un',
    'mapping-pick-path': 'Choisir un parcours',
    'mapping-no-paths-left': 'Tous les parcours sont déjà sur ce rôle',
    'mapping-save': 'Enregistrer',
    'mapping-cancel': 'Annuler',
    'mapping-save-failed': 'La modification n’a pas été enregistrée.',
    'mapping-saved-course': 'Cours enregistré',
    'mapping-saved-path': 'Parcours enregistré',
    'mapping-course-added': 'Cours ajouté au parcours',
    'mapping-course-removed': 'Cours retiré du parcours',
    'mapping-jtc-added': 'JTC ajouté',
    'mapping-jtc-removed': 'JTC retiré',
    'mapping-path-required': 'Parcours ajouté au rôle',
    'mapping-path-unrequired': 'Parcours retiré du rôle',
    'mapping-name-required': 'Le nom est obligatoire',
    'mapping-campus-ids-required':
      'Au moins un identifiant de cours Campus est requis',
    'mapping-url-https': 'Le lien doit commencer par https://',
    'mapping-select-role':
      'Sélectionnez un rôle pour voir ses parcours, ses cours et ses employés.',
    'mapping-select-locations': 'Sélectionnez au moins un emplacement.',
    'mapping-paths': 'Parcours',
    'mapping-paths-and-courses': 'Parcours et cours',
    'mapping-n-paths': '{n} parcours',
    'mapping-n-courses': '{n} cours',
    'mapping-pick-one-of-n': 'Un au choix parmi {n}',
    'mapping-pick-one-plus-n': 'Un au choix parmi {n}, plus {m} requis',
    'mapping-pick-one-of-these-paths': 'Un de ces parcours au choix',
    'mapping-required-with-path': 'Requis avec le parcours',
    'mapping-optional-paths': 'Parcours facultatifs',
    'mapping-pick-one': 'un au choix',
    'mapping-admin-only': 'Cette page est réservée aux administrateurs QSR.',
    'mapping-required-for-role': 'requis',
    'mapping-optional-for-role': 'facultatif',
    'mapping-applies-to': 'S’applique à',
    'mapping-employees-with-jtcs': 'Employés dans {n} codes de poste (JTC)',
    'mapping-all-active-employees': 'Tous les employés actifs',
    'mapping-due-rule': 'Règle d’échéance',
    'mapping-no-due-rule': 'Aucune date d’échéance',
    'mapping-each-course-due':
      'Chaque cours est dû {days} jours après {anchor}',
    'mapping-first-course-due':
      'Le premier cours est dû {days} jours après {anchor}',
    'mapping-path-deadline':
      'Le parcours complet est dû {months} mois après {anchor}',
    'mapping-due-dates-from':
      'Les échéances s’appliquent aux débuts à partir du {date}',
    'mapping-anchor-first-punch': 'le premier pointage',
    'mapping-anchor-first-jtc': 'le premier début de JTC',
    'mapping-anchor-first-jtc-in-role': 'le premier début dans {role}',
    'mapping-courses': 'Cours',
    'mapping-campus-ids': 'ID Campus',
    'mapping-states': 'États',
    'mapping-retired': 'Retiré',
    'mapping-open-in-campus': 'Ouvrir dans Campus',
    'mapping-first-punch': 'Premier pointage',
    'mapping-name-unavailable': 'Nom non disponible',
    'mapping-employees': 'Employés',
    'mapping-n-employees': '{n} employés',
    'mapping-no-employees':
      'Aucun employé des emplacements sélectionnés ne relève de ce rôle.',
    'employees-who-picked': 'Employés ayant choisi {path}',
    'picked-path': 'Ont choisi {path}',
    'completed-capstone-course': 'Ont terminé le cours {path}',
    'one-of-n-mandatory': '1 sur {n} est obligatoire',
  },
  'fr-ca': {
    // Legacy camelCase keys
    employee: 'Employé',
    roster: 'Liste des employés',
    payroll: 'Paie',
    employeeRoster: 'Liste des employés',
    employeeRosterAnalysis: 'Analyse de la liste des employés',
    rosterStatistics: 'Statistiques de la liste des employés',
    noPunchesOnly: 'Sans poinçon seulement',
    copyEmails: 'Copier les courriels',
    forOutlook: 'Pour Outlook',
    minorAdult: 'Mineur/adulte',
    highlightedRowsDenoteMinors:
      'Les rangées surlignées correspondent à des mineurs',
    adult: 'Adulte',
    minor: 'Mineur',
    primaryHourlyPayRate: 'Taux horaire principal',
    primaryJobTitleCode: 'Code de titre d’emploi principal',
    primaryJobTitleCodeDescription:
      'Description du code de titre d’emploi principal',
    contact: 'Coordonnées',
    birthday: 'Anniversaire',
    anniversary: 'Anniversaire d’embauche',
    reviewDue: 'Évaluation à venir',
    signature: 'Signature',
    crewStaffSize: 'Équipiers (effectif)',
    shiftStaffSize: 'Gérants de quart (effectif)',
    rosterSize: 'Taille de la liste',
    rosterActive: 'Liste active',

    // People Dashboard
    overview: 'Aperçu',
    shift: 'Quart',
    'turnover-trend': 'Tendance du roulement',
    'roster-statistics': 'Statistiques de la liste des employés',
    attendance: 'Assiduité',
    staffing: 'Dotation',
    'on-time-rating': 'Taux de ponctualité',
    'crew-turnover': 'Roulement des équipiers',
    'shift-turnover': 'Roulement des gérants de quart',

    // Overview Subwidget - Attendance
    'attendance-rating': 'Taux d’assiduité',
    'monthly-average-restaurant-shifts-worked':
      'Moyenne mensuelle du restaurant : % de quarts travaillés',
    'jtc-crew-and-swing': 'JTC : équipiers et polyvalents',
    'green-attendance': 'Vert : 90 % ou plus',
    'yellow-attendance': 'Jaune : de 80 % à moins de 90 %',
    'red-attendance': 'Rouge : moins de 80 %',
    'please-select-a-previous-month-to-view-attendance-rating':
      'Veuillez sélectionner un mois antérieur pour consulter le taux d’assiduité.',
    'rest-avg': 'Moy. restaurant',
    'total-shifts': 'Total des quarts',
    'missed-shifts': 'Quarts manqués',

    // Overview Subwidget - Shift
    'actual-hours-as-of-needed-for-month-needed':
      'Heures réelles en % des heures requises pour le mois. Requis = Variable requis + Plancher requis + Fixe à l’horaire',
    'green-shift': 'Vert : 95 %-105 %',
    'yellow-shift': 'Jaune : 85-95 % ou 105-115 %',
    'red-shift': 'Rouge : moins de 85 % ou plus de 115 %',
    'scheduled-hours-as-of-guide-for-month':
      'Heures à l’horaire en % du guide pour le mois',
    'actual-hours-as-of-scheduled-for-month':
      'Heures réelles en % des heures à l’horaire pour le mois',
    'avg-hrs-r-d': 'Moy. h/R/J',
    'act-vs-req': 'Réel c. requis',
    'act-vs-sch': 'Réel c. horaire',
    'sch-vs-guide': 'Horaire c. guide',
    last: 'Précédent',
    month: 'Mois',
    current: 'En cours',
    required: 'Requis',
    'required-hours': 'Requis',
    scheduled: 'À l’horaire',

    // Overview Subwidget - Roster
    'average-restaurant-active-paid-during-month':
      'Moyenne du restaurant : % actifs (payés) durant le mois',
    'average-restaurant-active-during-month':
      'Moyenne du restaurant : % actifs durant le mois',
    'green-roster': 'Vert : 95 % ou plus',
    'yellow-roster': 'Jaune : de 90 % à moins de 95 %',
    'red-roster': 'Rouge : moins de 90 %',
    active: 'Actif',
    termed: 'Cessation d’emploi',
    inactive: 'Inactif',
    'employee-location': 'Emplacement de l’employé',
    home: 'Emplacement d’attache',
    shared: 'Partagé',
    'termination-year': 'Année de cessation d’emploi',
    'term-year': 'Année cessation',
    total: 'Total',
    crew: 'Équipiers',
    manager: 'Gérant',
    'past-due-date': 'Date d’échéance dépassée',
    'overall-trained': 'Formation globale',
    'path-not-completed': 'Parcours {path} non terminé',
    'employees-label': 'employés',
    'crew-trainer-role': 'Formateur d’équipiers',
    'awaiting-verification': 'En attente de vérification',
    'crew-trainer-training-not-completed':
      'Formation de formateur d’équipiers non terminée',
    'overall-trained-in-compliance': 'Formation globale en conformité',
    'overall-trained-in-path': 'Formation globale en {path}',
    'overall-trained-crew-trainer':
      'Formation globale de formateur d’équipiers terminée',

    // Training report filters / labels
    role: 'Rôle',
    path: 'Parcours',
    all: 'Tous',
    'past-due': 'En retard',
    'due-soon': 'Échéance prochaine',
    'new-hires': 'Nouvelles embauches',
    'awaiting-eval': 'En attente de votre évaluation',
    foundation: 'Fondements',
    production: 'Production',
    service: 'Service',
    digital: 'Numérique',
    employees: 'Employés',
    courses: 'Cours',
    'by-stats': 'Par statistiques',
    'by-courses': 'Par cours',
    'employee-training-report': 'Rapport de formation des employés',
    compliance: 'Conformité',
    'digital-ambassador': 'Ambassadeur numérique',
    'shift-leader': 'Chef de quart',
    'department-leader': 'Chef de service',

    // Overview Subwidget - OnTime
    'monthly-average-restaurant-of-shifts-on-time':
      'Moyenne mensuelle du restaurant : % de quarts commencés à l’heure',
    'punch-threshold': 'Seuil de poinçon : 3 min',
    'green-ontime': 'Vert : 85 % ou plus',
    'yellow-ontime': 'Jaune : de 70 % à moins de 85 %',
    'red-ontime': 'Rouge : moins de 70 %',
    'please-select-a-previous-month-to-view-on-time-rating':
      'Veuillez sélectionner un mois antérieur pour consulter le taux de ponctualité.',
    'on-time': 'À l’heure',

    // Overview Subwidget - Turnover
    'crew-monthly-annualized-turnover':
      '% de roulement mensuel annualisé des équipiers',
    'green-turnover': 'Vert : moins de 130 %',
    'yellow-turnover': 'Jaune : de 130 % à 200 %',
    'red-turnover': 'Rouge : plus de 200 %',
    hires: 'Embauches',
    terminations: 'Cessations d’emploi',

    // Overview Subwidget - Retention (Shift Turnover)
    'monthly-annualized-shift-turnover':
      '% de roulement mensuel annualisé des gérants de quart',
    'green-below-50': 'Vert : moins de 50 %',
    'yellow-50-to-100': 'Jaune : de 50 % à 100 %',
    'red-above-100': 'Rouge : plus de 100 %',

    // Turnover Trend Widget
    'shift-managers': 'Gérants de quart',
    'monthly-annual-turnover': 'Roulement mensuel annualisé',
    'monthly-ann': 'Mens. ann.',
    'ttm-turnover': 'Roulement TTM',
    ttm: 'TTM',
    'ytd-turnover': 'Roulement cumulé annuel',
    ytd: 'CAJ',
    '3mo': '3 mois',
    '3mo-turnover': 'Roulement sur 3 mois',
    'tooltip-turnover':
      'Les données de roulement exigent une plage de dates couvrant un mois complet',

    // Shift Widget (dashboard)
    'by-store': 'Par restaurant',
    'act-hrs-vs-need': 'H. réelles c. requises',
    'sch-hrs-vs-guide': 'H. à l’horaire c. guide',
    'act-hrs-vs-sch': 'H. réelles c. horaire',

    // Roster Statistics Widget
    'roster-active': 'Liste active',
    'number-of-non-terminated-employees':
      'Nombre d’employés sans cessation d’emploi ayant poinçonné durant la période sélectionnée',
    'roster-inactive': 'Liste inactive',

    // Attendance Widget (dashboard grid)
    'punch-in-on-time': 'Poinçon d’entrée à l’heure',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-within':
      'Nombre de quarts de la période où l’employé a poinçonné à l’entrée à l’intérieur du seuil (avant ou après l’heure prévue)',
    'punch-in-late': 'Poinçon d’entrée en retard',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-after':
      'Nombre de quarts de la période où l’employé a poinçonné à l’entrée après le seuil',
    'punch-in-early': 'Poinçon d’entrée en avance',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-before':
      'Nombre de quarts de la période où l’employé a poinçonné à l’entrée avant le seuil',
    'punch-out-on-time': 'Poinçon de sortie à l’heure',
    'number-of-scheduled-shifts-where-the-employee-punched-out-within-the-threshold':
      'Nombre de quarts à l’horaire où l’employé a poinçonné à la sortie à l’intérieur du seuil',
    'number-of-shifts-where-an-employee-was-on-time-divided-by-total':
      'Nombre de quarts où l’employé était à l’heure, divisé par le total des quarts à l’horaire durant la période sélectionnée',
    'number-of-scheduled-shifts-an-employee-had-punches-for':
      'Nombre de quarts à l’horaire pour lesquels l’employé a poinçonné, divisé par le nombre total de quarts à l’horaire',
    'punch-out-late': 'Poinçon de sortie en retard',
    'number-of-scheduled-shifts-where-the-employee-punched-out-later':
      'Nombre de quarts à l’horaire où l’employé a poinçonné à la sortie après le seuil',
    'punch-out-early': 'Poinçon de sortie en avance',
    'number-of-scheduled-shifts-where-the-employee-punched-out-earlier':
      'Nombre de quarts à l’horaire où l’employé a poinçonné à la sortie avant le seuil',
    'worked-not-sched': 'Travaillé, hors horaire',
    'number-of-days-where-an-employee-worked-but-was-not-scheduled':
      'Nombre de jours où l’employé a travaillé sans être à l’horaire durant la période sélectionnée',
    'missed-shift': 'Quart manqué',
    'number-of-missed-shifts-for-the-employee-in-the-selected-period':
      'Nombre de quarts manqués par l’employé durant la période sélectionnée',
    'days-on-sched': 'Jours à l’horaire',
    'crew-swing': 'Équipiers / polyvalents',

    // Employee Roster
    'custom-date-range': 'Plage de dates personnalisée',
    'employee-roster': 'Liste des employés',
    'employee-roster-analysis': 'Analyse de la liste des employés',
    'no-punches-only': 'Sans poinçon seulement',
    search: 'Rechercher',
    'copy-emails': 'Copier les courriels',
    'for-outlook': 'Pour Outlook',
    'minor-adult': 'Mineur/adulte',
    'highlighted-rows-denote-minors':
      'Les rangées surlignées correspondent à des mineurs',
    'primary-hourly-pay-rate': 'Taux horaire principal',
    'employees-primary-hourly-pay-rate':
      'Taux horaire principal de l’employé - peut être nul ou vide (S.O.) pour les employés salariés',
    'primary-job-title-code': 'Code de titre d’emploi principal',
    'mcdonalds-primary-job-title-code':
      'Code de titre d’emploi principal McDonald’s',
    'primary-job-title-code-description':
      'Description du code de titre d’emploi principal',
    'mcdonalds-primary-job-title-code-description':
      'Description du code de titre d’emploi principal McDonald’s',
    purpose: 'Objet',
    'signature-line': 'Ligne de signature',
    'date-signed': 'Date de signature',
    'review-due': 'Évaluation à venir',

    // Roster Statistics (full page)
    'crew-staff-size': 'Équipiers (effectif)',
    'total-number-of-hourly-crew':
      'Nombre total d’équipiers horaires inscrits à la liste pour le mois sélectionné',
    'shift-staff-size': 'Gérants de quart (effectif)',
    'total-number-of-swing-managers-or-floor-supervisors':
      'Nombre total de gérants polyvalents ou de superviseurs de plancher dont le statut est « Actif »',
    'gm-dm-crew-staff-size': 'DG et DS (effectif)',
    'number-of-total-active-general-managers-and-department-managers':
      'Nombre total de directeurs généraux et de directeurs de service actifs',
    'crew-active': 'Équipiers actifs',
    'number-of-crew-who-had-punched-hours-in-the-selected-month':
      'Nombre d’équipiers ayant poinçonné des heures durant le mois sélectionné',
    'shift-active': 'Gérants de quart actifs',
    'number-of-swing-managers-or-floor-supervisors':
      'Nombre de gérants polyvalents ou de superviseurs de plancher au statut « Actif » ayant poinçonné au cours du mois le plus récent',
    'number-of-swing-managers-or-floor-supervisors-active':
      'Nombre de gérants polyvalents ou de superviseurs de plancher au statut « Actif » ayant poinçonné au cours du mois le plus récent',
    'under-18-staff-size': 'Moins de 18 ans (effectif)',
    'number-of-staff-whose-age-is-below-18-years-old':
      'Nombre d’employés âgés de moins de 18 ans',
    'under-17-staff-size': 'Moins de 17 ans (effectif)',
    'number-of-staff-whose-age-is-below-17-years-old':
      'Nombre d’employés âgés de moins de 17 ans',
    'under-16-staff-size': 'Moins de 16 ans (effectif)',
    'number-of-staff-whose-age-is-below-16-years-old':
      'Nombre d’employés âgés de moins de 16 ans',
    'roster-size': 'Taille de la liste',
    'total-number-of-people-whose-status-is-active':
      'Nombre total de personnes dont le statut est « Actif »',
    'number-of-non-terminated-employees-who-had-punches':
      'Nombre d’employés sans cessation d’emploi ayant poinçonné durant la période sélectionnée',
    'number-crew-inactive': 'Nb équipiers inactifs',
    'crew-who-were-on-the-roster-not-termed-in-the-selected-month':
      'Équipiers inscrits à la liste (sans cessation d’emploi) durant le mois sélectionné mais n’ayant poinçonné aucune heure',
    'number-of-swing-managers-or-floor-supervisors-inactive':
      'Nombre de gérants polyvalents ou de superviseurs de plancher au statut « Actif » n’ayant pas poinçonné au cours du mois le plus récent',
    'crew-who-were-on-the-roster-not-termed':
      'Équipiers inscrits à la liste (sans cessation d’emploi) durant le mois sélectionné mais n’ayant poinçonné aucune heure',
    'number-shift-inactive': 'Nb gérants de quart inactifs',
    'number-of-people-who-have-active-status':
      'Nombre de personnes au statut « Actif » n’ayant pas poinçonné au cours du mois le plus récent',
    'crew-active-pct': '% équipiers actifs',
    'crew-active-divided-by-total-crew':
      'Équipiers actifs divisés par le total des équipiers',
    'shift-active-pct': '% gérants de quart actifs',
    'shift-active-divided-by-shift-staff-size':
      'Gérants de quart actifs divisés par l’effectif des gérants de quart. Pourcentage de gérants polyvalents ou de superviseurs de plancher au statut « Actif » ayant poinçonné le mois dernier',
    'under-18-pct': '% moins de 18 ans',
    'under-18-staff-size-divided-by-total-staff':
      'Effectif des moins de 18 ans divisé par l’effectif total',
    'under-17-pct': '% moins de 17 ans',
    'under-17-staff-size-divided-by-total-staff':
      'Effectif des moins de 17 ans divisé par l’effectif total',
    'under-16-pct': '% moins de 16 ans',
    'under-16-staff-size-divided-by-total-staff':
      'Effectif des moins de 16 ans divisé par l’effectif total',
    'roster-active-pct': '% liste active',
    'roster-active-divided-by-total-staff':
      'Liste active divisée par l’effectif total',

    // Employee Roster Bottom Sheet
    error_loadingReport:
      'Une erreur est survenue lors du chargement du rapport.',
    employee_roster: 'Liste des employés pour l’emplacement',

    // Birthdays/Anniversaries
    birthdays: 'Anniversaires',
    anniversaries: 'Anniversaires d’embauche',
    'todays-birthdays': 'Anniversaires du jour',
    'current-months-birthdays': 'Anniversaires du mois en cours',
    'next-months-birthdays': 'Anniversaires du mois prochain',
    loc: 'Empl.',
    'employee-name': 'Nom de l’employé',
    location: 'Empl.',
    todays: 'Du jour',
    'current-months': 'Du mois en cours',
    'next-months': 'Du mois prochain',

    // Store Time Punches
    'back-to-employee-time-punches': 'Retour aux poinçons des employés',
    'store-time-punches': 'Poinçons du restaurant',
    'by-employee': 'Par employé',
    'day-of-week': 'Jour de la semaine',
    'payroll-id': 'ID de paie',
    custom: 'Personnalisé',

    // Punch Extract
    back_to_employee_time_punches: 'Retour aux poinçons des employés',
    time_punch_export: 'Exportation des poinçons',

    // Labor Exceptions
    'missing-pii-permissions-message':
      'Vous n’avez pas les autorisations requises sur les renseignements personnels identifiables (RPI) pour planifier ce rapport : Accès aux noms complets et Accès à l’adresse, au courriel, à la date de naissance et à l’origine nationale. Veuillez communiquer avec le soutien si vous croyez qu’il s’agit d’une erreur.',
    'report-title-exception': 'Par exception',
    'report-title-summary-exceptions': 'Sommaire par exception',
    'report-title-summary-location': 'Sommaire par emplacement',
    'adult-exceptions-header': 'Exceptions régulières',
    'minor-exceptions-header': 'Exceptions - mineurs',
    'exceptions-header': 'Total des exceptions',
    'adult-exceptions-description':
      'Exceptions visant tout employé qui n’est pas mineur',
    'minor-exceptions-description':
      'Exceptions visant tout employé mineur, qu’une règle régulière ou une règle propre aux mineurs ait été enfreinte',
    'exceptions-description': 'Nombre total d’exceptions pour un employé',
    'breach-type-header': 'Exception',
    'breach-type-description':
      'Règle du logiciel de gestion de la main-d’œuvre qui a été enfreinte',
    'highlighted-rows-explanation':
      'Les rangées surlignées indiquent des poinçons modifiés',
    'labor-date-header': 'Date de travail',
    'employee-full-name-header': 'Employé',
    'employee-full-name-description': 'Nom de l’employé',
    'first-name-header': 'Prénom',
    'first-name-description': 'Prénom de l’employé',
    'last-name': 'Nom de famille',
    age: 'Âge',
    'actual-shift-start-time-header': 'Début réel',
    'actual-shift-start-time-description': 'Heure de début réelle de ce quart',
    'actual-shift-end-time-header': 'Fin réelle',
    'actual-shift-end-time-description': 'Heure de fin réelle de ce quart',
    'schedule-shift-start-time-header': 'Début prévu',
    'schedule-shift-start-time-description':
      'Heure de début prévue de ce quart',
    'schedule-shift-end-time-header': 'Fin prévue',
    'schedule-shift-end-time-description': 'Heure de fin prévue de ce quart',
    'actual-shift-length-header': 'Durée réelle du quart',
    'actual-shift-length-description': 'Durée réelle du quart',
    'date-time-of-exception-header': 'Heure de l’exception',
    'date-time-of-exception-description':
      'Heure à laquelle l’exception est survenue',
    'is-manager-authorized-header': 'Autorisé par un gérant',
    'is-manager-authorized-description':
      'Cette exception a-t-elle été autorisée par un gérant?',
    'manager-name-header': 'Gérant',
    'manager-name-description': 'Nom du gérant',
    punches: 'Poinçons',
    'error-loading-report':
      'Une erreur est survenue lors du chargement du rapport',
    'punch-type': 'Type de poinçon',
    'is-overnight-shift': 'Quart de nuit',
    'is-overnight-shift-desc':
      '« O » si le poinçon était le poinçon de fin de 4 h 00 ou de début de 4 h 00 d’un quart chevauchant deux journées de travail, sinon « N »',
    'is-paid-break': 'Pause payée',
    'is-paid-break-desc':
      '« O » si le poinçon correspond au début ou à la fin d’une pause payée, sinon « N »',
    'in-time': 'Heure d’entrée',
    'out-time': 'Heure de sortie',

    // Time and Attendance (mcd)
    'time-and-attendance': 'Temps et présences',
    'time-and-attendance-analysis': 'Analyse des temps et présences',
    'first-name': 'Prénom',
    'employee-first-name': 'Prénom de l’employé',
    'employee-last-name': 'Nom de famille de l’employé',
    'job-title-code': 'Code de titre d’emploi',
    'mcdonalds-job-title-code': 'Code de titre d’emploi McDonald’s',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-within-the-threshold':
      'Nombre de quarts de la période où l’employé a poinçonné à l’entrée à l’intérieur du seuil (avant ou après l’heure prévue)',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-after-the-threshold':
      'Nombre de quarts de la période où l’employé a poinçonné à l’entrée après le seuil',
    'number-of-shifts-in-the-period-where-the-employee-punched-in-before-the-threshold':
      'Nombre de quarts de la période où l’employé a poinçonné à l’entrée avant le seuil',
    'number-of-shifts-where-an-employee-was-on-time-divided-by-total-shifts-scheduled-in-the-selected-period':
      'Nombre de quarts où l’employé était à l’heure, divisé par le total des quarts à l’horaire durant la période sélectionnée',
    'number-of-scheduled-shifts-an-employee-had-punches-for-divided-by-total-number-of-scheduled-shifts':
      'Nombre de quarts à l’horaire pour lesquels l’employé a poinçonné, divisé par le nombre total de quarts à l’horaire',
    'number-of-scheduled-shifts-where-the-employee-punched-out-later-than-the-threshold':
      'Nombre de quarts à l’horaire où l’employé a poinçonné à la sortie après le seuil',
    'number-of-scheduled-shifts-where-the-employee-punched-out-earlier-than-the-threshold':
      'Nombre de quarts à l’horaire où l’employé a poinçonné à la sortie avant le seuil',
    'number-of-days-where-an-employee-worked-but-was-not-scheduled-in-the-selected-period':
      'Nombre de jours où l’employé a travaillé sans être à l’horaire durant la période sélectionnée',
    'mcdonalds-global-employee-identifier':
      'Identifiant mondial d’employé McDonald’s',
    'sched-start-time': 'Heure de début prévue',
    'sched-end-time': 'Heure de fin prévue',
    'punch-start-time': 'Heure du poinçon d’entrée',
    'punch-end-time': 'Heure du poinçon de sortie',
    'punch-early-late-min-threshold': 'Seuil min. d’avance/retard du poinçon',
    schedule: 'Horaire',
    'at-store': 'Au restaurant',

    // Turnover Report + JTC Definitions
    'january-thru-last-month': 'De janvier au mois dernier',
    'trailing-13-months': '13 derniers mois',
    'premium-upgrade-message-start':
      'Vous souhaitez réduire le roulement du personnel? ',
    'premium-upgrade-message-link-text': 'Passez à Premium',
    'premium-upgrade-message-end':
      ' pour stimuler la mobilisation des employés et améliorer la rétention.',
    'jtc-definitions': 'Définitions JTC',
    'jtc-name': 'Nom du JTC',
    'turnover-type': 'Type de roulement',
    'general-manager-w-mgr-punches':
      'DIRECTEUR GÉNÉRAL AVEC POINÇONS DE GÉRANT',
    'general-manager-w-crew-punches':
      'DIRECTEUR GÉNÉRAL AVEC POINÇONS D’ÉQUIPIER',
    'general-manager': 'DIRECTEUR GÉNÉRAL',
    'store-mgr-trainee-f': 'GÉRANT DE RESTAURANT STAGIAIRE-F',
    'floor-supervisor': 'SUPERVISEUR DE PLANCHER',
    swing: 'Polyvalent',
    'cert-swing-mgr': 'GÉRANT POLYVALENT CERTIFIÉ',
    'crew-trainer': 'FORMATEUR D’ÉQUIPIERS',
    'crew-person': 'ÉQUIPIER',
    'manager-oje': 'GÉRANT OJE',
    'security-guard': 'AGENT DE SÉCURITÉ',
    'backup-maintenance-person': 'PRÉPOSÉ À L’ENTRETIEN SUPPLÉANT',
    'primary-maintenance-person': 'PRÉPOSÉ À L’ENTRETIEN PRINCIPAL',
    'intern-f': 'STAGIAIRE-F',
    'administrative-assistant': 'ADJOINT ADMINISTRATIF',
    'shift-manager-trainee': 'GÉRANT DE QUART STAGIAIRE',
    'otp-pro-hourly': 'OTP PRO HORAIRE',
    'otp-pro-salary': 'OTP PRO SALARIÉ',
    'department-manager-i': 'DIRECTEUR DE SERVICE i',
    'department-manager-ii': 'DIRECTEUR DE SERVICE ii',
    'department-manager-iii': 'DIRECTEUR DE SERVICE iii',
    'area-manager-grill-ca': 'GÉRANT DE SECTEUR - GRILL (CA)',
    'guam-inventory-employee': 'EMPLOYÉ D’INVENTAIRE GUAM',
    'intern-so-cal-region': 'STAGIAIRE - RÉGION SO CAL',
    'profit-center-admin-assist': 'ADJOINT ADMIN. CENTRE DE PROFIT',
    'lsm-coordinator': 'COORDONNATEUR LSM',
    'intern-gsw': 'STAGIAIRE GSW',
    'dept-mgr-w-i-crew-punches': 'DIR. DE SERVICE AVEC POINÇONS D’ÉQUIPIER i',
    'dept-mgr-w-ii-crew-punches': 'DIR. DE SERVICE AVEC POINÇONS D’ÉQUIPIER ii',
    'dept-mgr-w-iii-crew-punches':
      'DIR. DE SERVICE AVEC POINÇONS D’ÉQUIPIER iii',

    // Turnover Grid
    turnover: 'Roulement du personnel',
    'number-of-employees-hired-in-the-period':
      'Nombre d’employés embauchés durant la période',
    'roster-size-description':
      'Nombre d’employés du groupe sélectionné qui sont actifs dans la liste',
    terms: 'Cessations',
    'number-of-employees-whose-job-ended':
      'Nombre d’employés dont l’emploi a pris fin',
    'terms-less-than-90': 'Cessations < 90',
    'terms-less-than-90-description':
      'Pour le mois, nombre de nouvelles embauches ayant fait l’objet d’une cessation d’emploi avant d’atteindre 90 jours de service. Ce nombre ne sera définitif que 90 jours après la fin du mois (janvier ne sera définitif que le 1er mai, février le 1er juin, etc.)',
    'retained-greater-than-90': 'Retenus > 90',
    'number-of-employees-who-remained-employed-at-the-restaurant-more-than-90-days':
      'Nombre d’employés demeurés en poste au restaurant plus de 90 jours',
    'terms-less-than-90-pct': '% cessations < 90',
    'terms-less-than-90-pct-description':
      'Cessations < 90 divisées par les embauches du mois. Ce nombre ne sera définitif que 90 jours après la fin du mois (janvier ne sera définitif que le 1er mai, février le 1er juin, etc.)',
    'retained-greater-than-90-pct': '% retenus > 90',
    'retained-greater-than-90-divided-by-number-of-employees-hired-in-the-month':
      'Retenus > 90 divisés par le nombre d’employés embauchés dans le mois',
    'monthly-turnover-multiplied-by-12-to-annualized-it':
      'Roulement mensuel multiplié par 12 pour l’annualiser',
    'ttm-turnover-description':
      'Roulement des douze derniers mois. Total des cessations des 12 derniers mois divisé par la taille de la liste à la fin du mois le plus récent',
    'ytd-turnover-description':
      'Roulement cumulé depuis le début de l’année. Total des cessations de l’année en cours divisé par la taille de la liste à la fin du mois le plus récent',
    'three-month-turnover': 'Roulement sur 3 mois',
    '3-month-turnover-description':
      'Le roulement sur 3 mois porte sur la période de 3 mois la plus récente pour laquelle on peut savoir si les nouvelles embauches ont atteint 90 jours. {link}',
    'details-link-text': 'Les détails sont ici',
    'three-month-terms': 'Cessations sur 3 mois',
    '3-month-terms-description':
      'Nombre de personnes ayant fait l’objet d’une cessation d’emploi durant la période de 3 mois',
    'three-month-retained': 'Retenus sur 3 mois',
    '3-month-retained-description':
      'Nombre de personnes retenues durant la période de 3 mois',
    'new-hire-retention': 'Rétention des nouvelles embauches',
    'employees-in-red-were-terminated-prior-to-working-90-days':
      'Les employés en rouge ont fait l’objet d’une cessation d’emploi avant d’avoir travaillé 90 jours',

    // Emp Hours This Week
    'filter-results': 'Filtrer les résultats',
    'emp-hours-this-week': 'Heures des employés cette semaine',

    // Shift report
    'shift-report': 'Rapport de quart',
    'actual-gc': 'GC réel',
    'actual-gc-recorded-by-the-pos': 'GC réel enregistré par le PDV',
    'projected-gc': 'GC prévu',
    'actual-gc-vs-proj': 'GC réel c. prévu',
    'actual-gc-minus-gc-that-were-projected-in-the-scheduling-software':
      'GC réel moins le GC prévu dans le logiciel d’établissement des horaires',
    'proj-eff': 'Efficacité prévue',
    'number-of-hours-where-actual-gc-was-within-10':
      'Nombre d’heures où le GC réel se situait à moins de 10 du GC prévu, divisé par le nombre total d’heures d’ouverture du restaurant',
    'total-act-hrs': 'Total h. réelles',
    'var-actual-hrs': 'H. réelles variables',
    'act-punch-hrs': 'H. poinçonnées réelles',
    'actual-hours-punched-on-the-timeclock':
      'Heures réellement poinçonnées sur l’horodateur',
    'salaried-manager-hrs': 'H. gérants salariés',
    'since-salaried-managers-do-not':
      'Comme les gérants salariés ne poinçonnent pas, ce sont les heures de gérants salariés inscrites à l’horaire qui sont utilisées (on présume que toutes les heures salariées à l’horaire sont travaillées)',
    'total-need-hrs': 'Total h. requises',
    'total-hours-needed-hours-variable-hours-needed':
      'Total des heures requises - Heures variables requises plus heures de plancher requises + heures fixes à l’horaire',
    'var-need-hrs': 'H. variables requises',
    'flr-need-hrs': 'H. plancher requises',
    'manager-hours-needed-to-run-the-floor':
      'Heures de gérant requises pour diriger le plancher',
    'total-sch-hrs': 'Total h. à l’horaire',
    'var-sch-hrs': 'H. variables à l’horaire',
    'flr-sch-hrs': 'H. plancher à l’horaire',
    'manager-hours-scheduled-to-run-the-floor':
      'Heures de gérant inscrites à l’horaire pour diriger le plancher',
    'fixed-sch-hrs': 'H. fixes à l’horaire',
    'scheduled-hours-for-schedule-symbols-that-are-fixed':
      'Heures à l’horaire pour les symboles d’horaire « fixes » (indépendants du volume de ventes)',
    'total-guide': 'Guide total',
    'fixed-guide': 'Guide des heures fixes',
    'hours-in-the-fixed-hours-guide':
      'Heures inscrites au guide des heures fixes (aussi appelé contrat) pour un symbole d’horaire donné',
    'var-guide': 'Guide variable',
    'flr-guide': 'Guide plancher',
    'floor-hours-needed-based-on-gc-volume':
      'Heures de plancher requises selon le volume de GC',
    'act-vs-need-percentage': '% réel c. requis',
    'sch-vs-guide-percentage': '% horaire c. guide',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Heures réellement utilisées comparées aux heures inscrites à l’horaire',
    'act-vs-sch-percentage': '% réel c. horaire',
    'sch-flr-vs-guide': 'Plancher à l’horaire c. guide',
    'var-act-vs-need': 'Variable réel c. requis',
    'actual-variable-hours-used-compared-to-variable-hours-needed':
      'Heures variables réellement utilisées comparées aux heures variables requises selon le guide VLH',
    'fixed-sch-vs-guide': 'Fixe à l’horaire c. guide',
    'var-sch-vs-guide': 'Variable à l’horaire c. guide',

    // Labor Schedules
    labor_schedules: 'Horaires de main-d’œuvre',

    // Rewards
    'by-employee-title': 'Par employé',
    'by-store-title': 'Par restaurant',
    'auto-rewards': 'Récompenses automatiques',
    'rewards-by-store': 'Récompenses par restaurant',
    'rewards-by-employee': 'Récompenses par employé',
    transfers: 'Transferts',
    purchase: 'Achat',
    refund: 'Remboursement',
    manual: 'Manuel',
    auto: 'Auto',
    pts: 'Pts',
    qty: 'Qté',
    'employee-name-description': 'Nom de l’employé',
    'by-date': 'Par date',
    'sum-all-dates': 'Cumul',
    geid: 'GEID',
    '3-month-turnover': 'Roulement sur 3 mois',
    '3-month-terms': 'Cessations sur 3 mois',
    '3-month-retained': 'Retenus sur 3 mois',
    category: 'Catégorie',
    value: 'Valeur',
    'retained-90-divided-by-number-of-employees-hired-in-the-month':
      'Retenus > 90 divisés par le nombre d’employés embauchés dans le mois',
    primary: 'Principal',
    secondary: 'Secondaire',
    // Training Report — Shift Leader
    'shift-leader-foundations': 'Fondements du chef de quart',
    'sl-shift-leader': 'Chef de quart',
    'sl-advancing-tooltip':
      'Advancing Leadership est un parcours secondaire accessible uniquement après avoir terminé Leadership Foundations',
    'sl-location': 'Emplacement',
    'sl-role': 'Rôle',
    'sl-path': 'Parcours',
    'sl-employee': 'Employé',
    'sl-jtc-start-date': 'Date de début du JTC',
    'sl-due-date': 'Date d’échéance',
    'sl-avg-days': 'Nombre moyen de jours pour terminer',
    'sl-all': 'Tous',
    'sl-past-due': 'En retard',
    'dl-dlim': 'DLIM',
    'dl-completed-dlim': 'Cours DLIM terminé (1 sur 2)',
    'dl-dlim-subtitle': '1 sur 2 est obligatoire',
    download: 'Télécharger',
    'sl-past-due-hint':
      "En retard : non terminé et la date d'échéance est passée depuis {n} jours",
    'sl-due-soon-hint': 'Bientôt dû : à terminer dans {n} jours',
    'sl-past-due-group-hint':
      "En retard : {n} cours obligatoire(s) de ce groupe non terminé(s) à la date d'échéance",
    'sl-due-soon-group-hint':
      'Bientôt dû : {n} cours obligatoire(s) de ce groupe à terminer dans les prochains jours',
    'sl-due-soon': 'Échéance prochaine',
    'sl-not-started': 'Non commencé',
    'sl-in-progress': 'En cours',
    'sl-completed': 'Terminé',
    'sl-na': 's.o.',
    'sl-badge-start-overdue': 'Début en retard - 14',
    'sl-badge-start-due': 'Début à échéance - 14',
    'sl-employees': 'employés',
    'sl-card-past-due': 'Date d’échéance dépassée',
    'sl-card-due-soon': 'Échéance prochaine',
    'past-due-date-training': 'Formation en retard',
    'due-soon-training': 'Formation à échéance prochaine',
    'sl-card-not-trained': 'Non formé dans ce parcours',
    'crew-pct-past-due': '{pct} En retard',
    'crew-pct-crew-trainer-not-completed':
      '{pct} Formation de formateur d’équipiers non terminée',
    'crew-pct-due-soon': '{pct} Bientôt dû',
    'sl-pct-not-trained': '{pct} Non formé dans ce parcours',
    'sl-col-past-due': 'Nb en retard',
    'sl-col-due-soon': 'Nb à échéance prochaine',
    'sl-first-course-col': 'Premier cours (14 jours)',
    'sl-training-status': 'Statut de la formation',
    'sl-see-all': 'TOUT VOIR',
    'sl-close': 'Fermer',
    'sl-due-header-tooltip':
      'Le premier cours du parcours doit être suivi au plus tard 14 jours après la date d’entrée en vigueur du JTC. L’ensemble du parcours doit être terminé au plus tard 9 mois après cette date.',
    'sl-tip-first-overdue':
      'Premier cours non commencé dans les 14 jours suivant le JTC (échéance {date}).',
    'sl-tip-first-due':
      'Le premier cours doit être commencé dans les 14 jours suivant le JTC (échéance {date}).',
    'sl-tip-count-past-due':
      '{n} cours ayant dépassé l’échéance de 9 mois du parcours (échéance {date}).',
    'sl-tip-count-due-soon':
      '{n} cours arrivant à échéance avant le délai de 9 mois du parcours (échéance {date}).',
    'hire-date': 'Date d’embauche',
    'completion-date': 'Date d’achèvement',
    'course-name': 'Nom du cours',
    'employee-training-details': 'Détails de la formation de l’employé',
    'overall-progress': 'Progression globale {pct} %',
    'employees-none-for-status': 'Aucun employé avec ce statut',
    'employees-load-failed':
      'Impossible de charger les employés. Modifiez un filtre pour réessayer.',
    'employees-removed-for-status':
      '{n} employé(s) sélectionné(s) retiré(s) : statut différent',
    'mapping-title': 'Cartographie de la formation',
    'mapping-courses-filters': 'Cours',
    'mapping-completions': 'Réussites',
    'mapping-completions-any': 'Toutes',
    'mapping-completions-none': 'Aucune',
    'mapping-completions-some': 'Quelques-unes',
    'mapping-hide-retired': 'Masquer les retirés',
    'mapping-unmapped-ids-caption':
      'Réussites sans cours. Non concernées par les filtres de cours ci-dessus.',
    'mapping-group-assigned': 'Dans un parcours',
    'mapping-n-of-m-courses': '{n} sur {m}',
    'mapping-path-reordered': 'Ordre des parcours enregistré',
    'mapping-show': 'Afficher',
    'mapping-hide': 'Masquer',
    'mapping-applies-to-line': 'S’applique à',
    'mapping-reorder-hint': 'Glissez pour réordonner',
    'mapping-required-paths': 'Parcours requis',
    'mapping-course-library': 'Bibliothèque de cours',
    'mapping-search-courses': 'Rechercher par nom ou identifiant Campus',
    'mapping-library-hint':
      'Glissez un cours sur un parcours pour l’ajouter, ou d’un parcours à l’autre pour le déplacer. Utilisez le x d’un cours pour le retirer du parcours.',
    'mapping-group-unassigned': 'Dans aucun parcours',
    'mapping-unmapped-ids':
      'Identifiants Campus avec des réussites mais sans cours',
    'mapping-unmapped-ids-hint':
      'Des employés des emplacements sélectionnés ont terminé ces identifiants de cours Campus, mais aucun cours ne les couvre. Créez un cours à partir de l’un d’eux pour le cartographier.',
    'mapping-no-courses': 'Aucun cours',
    'mapping-drop-course-here': 'Déposez un cours ici',
    'mapping-n-completed': '{n} terminés',
    'mapping-zero-completed': '0 terminé',
    'mapping-last-completed': 'dernier {date}',
    'mapping-create-course-from-id': 'Créer un cours pour {id}',
    'mapping-course-moved': 'Ordre des cours enregistré',
    'mapping-path-regrouped': 'Exigence du parcours mise à jour',
    'mapping-n-paths-no-courses': '{n} parcours n’ont aucun cours',
    'mapping-n-unassigned-courses': '{n} cours ne sont dans aucun parcours',
    'mapping-n-unassigned-with-completions':
      '{n} d’entre eux ont des réussites',
    'mapping-add-jtc': 'Ajouter un JTC',
    'mapping-jtc-code': 'Code JTC',
    'mapping-jtc-invalid': 'Entrez le JTC sous forme de nombre entier',
    'mapping-remove-jtc': 'Retirer le JTC {jtc}',
    'mapping-new-path': 'Nouveau parcours',
    'mapping-edit-path': 'Modifier le parcours',
    'mapping-require-path': 'Exiger un parcours',
    'mapping-remove-from-role': 'Retirer de ce rôle',
    'mapping-add-course': 'Ajouter un cours',
    'mapping-edit-course': 'Modifier le cours',
    'mapping-remove-from-path': 'Retirer de ce parcours',
    'mapping-existing-course': 'Cours existant',
    'mapping-new-course': 'Nouveau cours',
    'mapping-pick-course': 'Choisir un cours',
    'mapping-no-courses-left': 'Aucun cours à ajouter',
    'mapping-on-no-path': 'dans aucun parcours',
    'mapping-course-name': 'Nom du cours',
    'mapping-path-name': 'Nom du parcours',
    'mapping-campus-ids-hint':
      'Saisissez un identifiant de cours Campus et appuyez sur Entrée',
    'mapping-course-url': 'Lien Campus (https)',
    'mapping-art': 'Visuels',
    'mapping-art-preview-celebration': 'Aperçu de la célébration',
    'mapping-art-celebration-preview': 'Célébration de la clé (en direct)',
    'mapping-art-palette-blobs': 'Taches',
    'mapping-art-palette-rays': 'Rayons',
    'mapping-art-palette-confetti': 'Confettis',
    'mapping-art-palette-default': 'valeurs de l’app',
    'mapping-art-key-palette': 'Palette de la célébration',
    'mapping-art-palette-add': 'Ajouter une couleur',
    'mapping-art-palette-remove': 'Retirer la couleur',
    'mapping-art-missing': '{n} visuel(s) manquant(s)',
    'mapping-art-missing-title':
      'Des visuels obligatoires manquent; l’app équipier affichera les visuels de secours',
    'mapping-art-show': 'Afficher',
    'mapping-art-hide': 'Masquer',
    'mapping-art-none': 'Pas encore de visuels',
    'mapping-art-save-first':
      'Enregistrez d’abord la fiche, puis les visuels pourront être téléversés',
    'mapping-art-upload': 'Téléverser',
    'mapping-art-replace': 'Remplacer',
    'mapping-art-clear': 'Retirer',
    'mapping-art-door-still': 'Porte (fermée)',
    'mapping-art-door-clean': 'Porte, cadrage serré',
    'mapping-art-door': 'Porte',
    'mapping-art-door-rig': 'Style de porte',
    'mapping-default-art': 'Visuels par défaut',
    'mapping-default-art-hint':
      'Ce qu’affiche tout parcours ou cours sans visuel propre, emplacement par emplacement. Un parcours avec un style de porte garde sa porte ; sans style, il affiche celle-ci. S’applique à tous les rôles.',
    'mapping-art-rig-magic': 'Magique',
    'mapping-art-rig-magic-hint':
      'Un panneau pliant avec une serrure lumineuse. Utilisé par Foundation et Beverage Specialist.',
    'mapping-art-rig-hinged': 'À charnières',
    'mapping-art-rig-hinged-hint':
      'Un battant sur levier qui projette des objets en s’ouvrant. Utilisé par Production.',
    'mapping-art-rig-diner': 'Diner',
    'mapping-art-rig-diner-hint':
      'Une porte battante à deux vantaux avec un plateau. Utilisée par Service.',
    'mapping-art-rig-vault': 'Coffre',
    'mapping-art-rig-vault-hint':
      'Une porte ronde de coffre avec des traces holographiques. Utilisée par Digital Ambassador.',
    'mapping-art-rig-locker': 'Casier',
    'mapping-art-rig-locker-hint':
      'Une porte de casier avec des gemmes flottantes et un jaillissement de butin. Utilisée par Compliance.',
    'mapping-art-door-layers': 'Calques',
    'mapping-art-door-layers-hint':
      'Dessinés sur le gabarit du style. La porte ne s’affiche qu’une fois tous les calques téléversés.',
    'mapping-art-door-layer-closed': 'Panneau fermé',
    'mapping-art-door-layer-frame': 'Cadre',
    'mapping-art-door-layer-leaf': 'Battant',
    'mapping-art-door-layer-interior': 'Intérieur',
    'mapping-art-door-layer-lever': 'Levier',
    'mapping-art-door-layer-leafFront': 'Battant, avant',
    'mapping-art-door-layer-leafBack': 'Battant, arrière',
    'mapping-art-door-layer-tray': 'Plateau',
    'mapping-art-door-layer-holo': 'Holo',
    'mapping-art-door-layer-traces': 'Traces',
    'mapping-art-door-layer-plate': 'Plaque',
    'mapping-art-door-layer-faceFront': 'Face, avant',
    'mapping-art-door-layer-faceBack': 'Face, arrière',
    'mapping-art-door-layer-knob': 'Bouton',
    'mapping-art-door-decor-props': 'Objets projetés',
    'mapping-art-door-decor-gems': 'Gemmes flottantes',
    'mapping-art-door-decor-loot': 'Jaillissement de butin',
    'mapping-art-optional': 'facultatif',
    'mapping-art-tuning-scale': 'Échelle',
    'mapping-art-tuning-shiftX': 'Décalage de la porte (px)',
    'mapping-art-tuning-labelShift': 'Décalage de l’étiquette (px)',
    'mapping-art-tuning-opening': 'Polygone de l’ouverture',
    'mapping-art-tuning-keyholeX': 'Serrure x',
    'mapping-art-tuning-keyholeY': 'Serrure y',
    'mapping-art-tuning-edge': 'Dégradé du bord',
    'mapping-art-advanced': 'Avancé',
    'mapping-art-advanced-hint':
      'Utile seulement quand le visuel s’écarte du gabarit du style.',
    'mapping-art-door-preview': 'Aperçu de la porte',
    'mapping-art-door-preview-hint':
      'Dessinée par le même mécanisme que l’app des équipiers, à l’échelle ci-dessus.',
    'mapping-art-door-open': 'Ouvrir',
    'mapping-art-door-close': 'Fermer',
    'mapping-art-door-incomplete':
      'Téléversez tous les calques pour voir la porte',
    'mapping-art-gradient': 'Dégradé de fond',
    'mapping-art-fallback-key': 'Clé de secours',
    'mapping-art-celebration-key': 'Clé de célébration',
    'mapping-art-preview-title': 'Aperçu de la célébration',
    'mapping-art-preview-hint':
      'Appuyez sur lecture pour voir la clé de célébration sur le dégradé avec la palette ci-dessus. L’aperçu redémarre quand une couleur change.',
    'mapping-art-missing-slot': 'Manquant',
    'mapping-art-course-key': 'Clé',
    'mapping-use-groups': 'Groupes par modalité',
    'mapping-item-name': 'Nom de l’étape',
    'mapping-n-steps': '{n} étapes',
    'mapping-edit-group': 'Modifier le groupe',
    'mapping-edit-step': 'Modifier l’étape',
    'mapping-unnamed-step': 'Étape sans nom',
    'mapping-done': 'Terminé',
    'mapping-remove-item': 'Retirer l’étape',
    'mapping-drag-to-reorder': 'Glisser pour réordonner',
    'mapping-group-modality': 'Modalité',
    'mapping-no-modality': 'Sans modalité',
    'mapping-group-required': 'Obligatoire',
    'mapping-optional-group': 'facultatif',
    'mapping-group-item': 'Élément {n}',
    'mapping-group-item-hint': 'Ids Campus de cet élément, un seul suffit',
    'mapping-add-item': 'Ajouter un élément',
    'mapping-add-group': 'Ajouter un groupe',
    'mapping-remove-group': 'Retirer le groupe',
    'mapping-group-rule': 'Tous les éléments du groupe doivent être terminés',
    'mapping-groups-rule':
      'Le cours est terminé dès qu’un groupe obligatoire est terminé. Les groupes facultatifs n’affichent que la progression.',
    'mapping-group-ids-required':
      'Chaque groupe doit avoir au moins un élément avec un id Campus',
    'mapping-retired-flag': 'Retiré',
    'mapping-states-scope':
      'Seulement pour les restaurants de ces États (facultatif)',
    'mapping-translations': 'Traductions',
    'mapping-translation-es': 'Espagnol',
    'mapping-translation-fr': 'Français',
    'mapping-translation-fr-ca': 'Français (Canada)',
    'mapping-due-window': 'Délai d’échéance',
    'mapping-window-days': 'Jours',
    'mapping-applies-each': 'Chaque cours',
    'mapping-applies-first': 'Premier cours seulement',
    'mapping-due-soon-days': 'Bientôt dû, jours avant',
    'mapping-path-deadline-label': 'Échéance de tout le parcours',
    'mapping-deadline-months': 'Mois',
    'mapping-anchor': 'Compté à partir de',
    'mapping-anchor-first-punch-label': 'Premier pointage',
    'mapping-anchor-first-jtc-label': 'Premier début de JTC',
    'mapping-anchor-role': 'Dans le rôle (facultatif)',
    'mapping-due-dates-from-label':
      'Seulement pour les débuts à partir du (AAAA-MM-JJ)',
    'mapping-required': 'Requis',
    'mapping-pick-one-group': 'Groupe « un au choix » (facultatif)',
    'mapping-pick-one-group-hint':
      'Les parcours portant le même nom de groupe sont des alternatives : l’employé en complète un',
    'mapping-pick-path': 'Choisir un parcours',
    'mapping-no-paths-left': 'Tous les parcours sont déjà sur ce rôle',
    'mapping-save': 'Enregistrer',
    'mapping-cancel': 'Annuler',
    'mapping-save-failed': 'La modification n’a pas été enregistrée.',
    'mapping-saved-course': 'Cours enregistré',
    'mapping-saved-path': 'Parcours enregistré',
    'mapping-course-added': 'Cours ajouté au parcours',
    'mapping-course-removed': 'Cours retiré du parcours',
    'mapping-jtc-added': 'JTC ajouté',
    'mapping-jtc-removed': 'JTC retiré',
    'mapping-path-required': 'Parcours ajouté au rôle',
    'mapping-path-unrequired': 'Parcours retiré du rôle',
    'mapping-name-required': 'Le nom est obligatoire',
    'mapping-campus-ids-required':
      'Au moins un identifiant de cours Campus est requis',
    'mapping-url-https': 'Le lien doit commencer par https://',
    'mapping-select-role':
      'Sélectionnez un rôle pour voir ses parcours, ses cours et ses employés.',
    'mapping-select-locations': 'Sélectionnez au moins un emplacement.',
    'mapping-paths': 'Parcours',
    'mapping-paths-and-courses': 'Parcours et cours',
    'mapping-n-paths': '{n} parcours',
    'mapping-n-courses': '{n} cours',
    'mapping-pick-one-of-n': 'Un au choix parmi {n}',
    'mapping-pick-one-plus-n': 'Un au choix parmi {n}, plus {m} requis',
    'mapping-pick-one-of-these-paths': 'Un de ces parcours au choix',
    'mapping-required-with-path': 'Requis avec le parcours',
    'mapping-optional-paths': 'Parcours facultatifs',
    'mapping-pick-one': 'un au choix',
    'mapping-admin-only': 'Cette page est réservée aux administrateurs QSR.',
    'mapping-required-for-role': 'requis',
    'mapping-optional-for-role': 'facultatif',
    'mapping-applies-to': 'S’applique à',
    'mapping-employees-with-jtcs': 'Employés dans {n} codes de poste (JTC)',
    'mapping-all-active-employees': 'Tous les employés actifs',
    'mapping-due-rule': 'Règle d’échéance',
    'mapping-no-due-rule': 'Aucune date d’échéance',
    'mapping-each-course-due':
      'Chaque cours est dû {days} jours après {anchor}',
    'mapping-first-course-due':
      'Le premier cours est dû {days} jours après {anchor}',
    'mapping-path-deadline':
      'Le parcours complet est dû {months} mois après {anchor}',
    'mapping-due-dates-from':
      'Les échéances s’appliquent aux débuts à partir du {date}',
    'mapping-anchor-first-punch': 'le premier pointage',
    'mapping-anchor-first-jtc': 'le premier début de JTC',
    'mapping-anchor-first-jtc-in-role': 'le premier début dans {role}',
    'mapping-courses': 'Cours',
    'mapping-campus-ids': 'ID Campus',
    'mapping-states': 'États',
    'mapping-retired': 'Retiré',
    'mapping-open-in-campus': 'Ouvrir dans Campus',
    'mapping-first-punch': 'Premier pointage',
    'mapping-name-unavailable': 'Nom non disponible',
    'mapping-employees': 'Employés',
    'mapping-n-employees': '{n} employés',
    'mapping-no-employees':
      'Aucun employé des emplacements sélectionnés ne relève de ce rôle.',
    'employees-who-picked': 'Employés ayant choisi {path}',
    'picked-path': 'Ont choisi {path}',
    'completed-capstone-course': 'Ont terminé le cours {path}',
    'one-of-n-mandatory': '1 sur {n} est obligatoire',
  },
};
